const nl: Record<string, string> = {
  // --- LEA-319 Trust-Redesign (variant '50credits-trust'). NL gate copy
  //     translated from the approved DE/EN mockups (Om signs off wording in QA).
  //     Testimonial names/quotes/roles + photos are verbatim from the Webflow
  //     CMS (Janik 2026-06-11).
  'og.title.trust.lead': 'Probeer Leadscraper ',
  'og.title.trust.grad': '3 dagen gratis',
  'og.title.trust.tail': ' met 50 echte leads.',
  'og.subtitle.trust':
    'Vandaag wordt er niets afgeschreven. Je test met echte leads uit je doelgroep, en als het niet bij je past, beëindig je de trial met één klik. Geen telefoontje, geen opzegtermijn.',
  'og.trust.demo.tag': 'Live-demo · geen marketingvideo',
  'og.trust.demo.title': 'Bekijk hoe Leadscraper jouw leads vindt',
  'og.trust.demo.body':
    'Echte zoekopdracht, echt dashboard, echte resultaten: oprichter Janik laat je het complete proces zien, van het beschrijven van je doelgroep tot de kant-en-klare leadlijst.',
  'og.trust.demo.play': 'Demovideo afspelen',
  'og.trust.demo.close': 'Sluiten',
  'og.trust.timeline.1.when': 'Vandaag',
  'og.trust.timeline.1.body':
    'Kies een plan, voeg een betaalmethode toe. {s}: je 50 credits zijn meteen te gebruiken.',
  'og.trust.timeline.1.strong': '€ 0 afgeschreven',
  'og.trust.timeline.2.when': 'Dag 1–3',
  'og.trust.timeline.2.body':
    'Je test met echte leads. Niet overtuigd? {s} beëindigt de trial direct, zonder contact, zonder uitleg.',
  'og.trust.timeline.2.strong': 'Eén klik in je account',
  'og.trust.timeline.3.when': 'Vanaf dag 3',
  'og.trust.timeline.3.body':
    'Pas nu start je abonnement in het gekozen plan. {s}, geen minimale looptijd.',
  'og.trust.timeline.3.strong': 'Maandelijks opzegbaar',
  'og.trust.ctaNote': 'Vandaag € 0 · Beëindigen = 1 klik',
  'og.trust.proof.head': 'Salesteams die al zijn overgestapt',
  // Nachfolger des geloeschten og.trust.proof.pill (behauptete Google & OMR ohne Beleg; LEA-619). Nur aus
  // lib/verifiedReviews gerendert, {platform} = Plattformen der gezeigten Bewertungen.
  'og.trust.proof.pillVerified': 'Reviews op {platform}',
  'og.trust.bar.card.title': '€ 0 vandaag',
  'og.trust.bar.card.body': 'Kaart, PayPal of SEPA-incasso · veilig via Stripe',
  'og.trust.bar.cancel.title': 'In 5 seconden opgezegd',
  'og.trust.bar.cancel.body': '1 klik in je account, zonder contact, direct van kracht',
  'og.trust.bar.gdpr.title': 'Alleen openbare data',
  'og.trust.bar.gdpr.body': 'AVG by design · Servers in de EU · alleen openbare bronnen',
  'og.trust.founderLine.title': 'Gebouwd in Hamburg, Duitsland',
  'og.trust.founderLine.name': ': Janik Deimann, Oprichter',
  'og.trust.founderLine.sub':
    'Duitse engineering, Europese gegevensbescherming, en als je ons schrijft, antwoordt een mens.',
  'og.trust.founderLine.ask': 'Nog twijfels? Mail ons: support@leadscraper.eu, een mens antwoordt.',

  // --- Paywall revisie 19 (goedgekeurd door Janik op 11-09-2026) ---
  // Het Duits is het goedgekeurde origineel: behoud het genuanceerde 'tot 50'
  // en de opmerking over extra credits in elke vertaling.
  'og.r19.accountReady': 'Account aangemaakt · Activeer je proefperiode',
  'og.r19.headline.lead': 'Vind tot',
  'og.r19.headline.grad': '50 gratis leads.',
  'og.r19.lead':
    'Begin vandaag met bedrijven die bij jouw aanbod passen. Je proefperiode bevat {credits} credits voor maximaal {credits} bedrijfsleads.',
  'og.r19.offerNote':
    'Contacten en bedrijfsonderzoek kosten extra credits. Credits die je daarvoor gebruikt verlagen het aantal bedrijven.',
  'og.r19.rating.value': '4,8 / 5',
  'og.r19.rating.caption': 'Uitstekende gebruikersfeedback',
  'og.r19.rating.aria': 'Klantbeoordeling: 4,8 van de 5 sterren',
  'og.r19.product.footnote': 'Jij bepaalt bij welke bedrijven je dieper onderzoek doet.',
  'og.r19.picker.title': 'Begin nu gratis.',
  'og.r19.picker.trialCredits': '{credits} proefcredits',
  'og.r19.picker.trialPlan': '{plan} · {days} dagen € 0, daarna {renewal}, maandelijks opzegbaar',
  'og.r19.picker.trialPlanAll': '{plan} · proef € 0, daarna {renewal}, maandelijks opzegbaar',
  'og.r19.picker.today': '€ 0',
  'og.r19.picker.todayLabel': 'vandaag',
  'og.r19.picker.description': 'Kies je pakket voor de periode na de proef.',
  'og.r19.credits.title': '1 bedrijf vinden',
  'og.r19.credits.equals': '=',
  'og.r19.credits.unit': '1 credit',
  'og.r19.credits.note': 'Contacten & bedrijfsonderzoek kosten extra credits.',
  'og.r19.credits.info': 'Bekijk een voorbeeld van het creditverbruik',
  'og.r19.credits.example':
    'Voorbeeld: je vindt 20 bedrijven en voegt bij 10 daarvan contacten en bedrijfsonderzoek toe. Dat zijn 40 credits.',
  'og.r19.credits.exampleRest': 'Je houdt {rest} van je {credits} proefcredits over.',
  'og.r19.credits.disclaimer':
    '{credits} credits zijn niet automatisch {credits} volledig onderzochte contacten.',
  'og.r19.plans.legend': 'Kies je pakket voor na de proefperiode',
  'og.r19.plans.creditsPerMonth': '{credits} credits / maand',
  'og.r19.plans.perMonth': '/ maand',
  'og.r19.plans.caption.basic': 'Om te beginnen',
  'og.r19.plans.caption.starter': 'Voor regelmatige acquisitie',
  'og.r19.plans.caption.growth': 'Voor een groter salesteam',
  'og.r19.cta': 'Nu gratis beginnen',
  'og.r19.renewal': 'Daarna {s} voor {credits} credits.',
  'og.r19.renewal.strong': '€ {price} / maand',
  'og.r19.renewal.cancel': 'Zeg op voor het einde van de proef en je betaalt niets.',
  'og.r19.security': 'Betaalmethode in de volgende stap',
  'og.r19.help.faq': 'Proef & opzeggen',
  'og.r19.help.features': 'Pakketten in detail',
  // MCP self-service token UI (LEA-269)
  'mcp.live': 'Live',
  'mcp.tok.generate': 'Token genereren',
  'mcp.tok.title': 'Een AI-client verbinden',
  'mcp.tok.intro':
    'Genereer een persoonlijk token om Claude, Cursor of je eigen agent met je Leadscraper-account te verbinden. Het token wordt maar één keer getoond.',
  'mcp.tok.name': 'Tokennaam',
  'mcp.tok.generating': 'Genereren…',
  'mcp.tok.once': 'Kopieer dit token nu: om veiligheidsredenen wordt het nooit meer getoond.',
  'mcp.tok.yourToken': 'Jouw token',
  'mcp.tok.copy': 'Kopiëren',
  'mcp.tok.copied': 'Gekopieerd',
  'mcp.tok.claudeConfig': 'Claude Desktop-configuratie',
  'mcp.tok.copyConfig': 'Configuratie kopiëren',
  'mcp.tok.done': 'Klaar',
  'mcp.tok.limit': 'Tokenlimiet bereikt: trek eerst een oude in.',
  'mcp.tok.mintFailed': 'Kon token niet genereren. Probeer het opnieuw.',
  'mcp.tok.revoked': 'Token "{name}" ingetrokken',
  'mcp.tok.revokeFailed': 'Kon token niet intrekken.',
  'mcp.tok.expires': 'verloopt',
  'mcp.tok.lastUsed': 'laatst gebruikt',
  'mcp.tok.neverUsed': 'nooit gebruikt',
  'mcp.tok.revoke': 'Intrekken',
  // LEA-349 Phase 3: Claude.ai (web) OAuth connect path
  'mcp.claude.connect': 'Verbinden met Claude',
  'mcp.claude.cardHint': 'Claude.ai (web) verbindt met één klik via OAuth, geen token nodig.',
  'mcp.claude.intro':
    'Voeg Leadscraper toe aan Claude.ai als custom connector. Je keurt de toegang één keer goed, geen token om te kopiëren of plakken.',
  'mcp.claude.cta': 'Claude-connectors openen',
  'mcp.claude.urlLabel': 'Jouw MCP-server-URL',
  'mcp.claude.step1': 'Klik op "Claude-connectors openen" en daarna op "Add custom connector".',
  'mcp.claude.step2': 'Plak de URL hierboven en ga verder.',
  'mcp.claude.step3': 'Keur de toegang goed ("Allow"): Claude kan nu je leads gebruiken.',
  'mcp.claude.desktopNote': 'Gebruik je Claude Desktop, Cursor of je eigen agent?',
  'mcp.claude.desktopCta': 'Genereer in plaats daarvan een token',
  'acct.bill.addMethod': 'Betaalmethode toevoegen',
  'acct.bill.cardEnds': 'Visa eindigt op •• 4242',
  'acct.bill.cardExpHolder': 'Verloopt 08/2028 · Janik Deimann',
  'acct.bill.col.amount': 'Bedrag',
  'acct.bill.col.credits': 'Credits',
  'acct.bill.col.date': 'Datum',
  'acct.bill.col.desc': 'Beschrijving',
  'acct.bill.col.invoice': 'Factuur',
  'acct.bill.col.status': 'Status',
  'acct.bill.descSub': '{plan}-abonnement · {month} {year}',
  'acct.bill.empty': 'Geen transacties gevonden',
  'acct.bill.emptySub': 'Je betalingsgeschiedenis wordt hier weergegeven na je eerste aankoop.',
  'acct.bill.filter.30': 'Laatste 30 dagen',
  'acct.bill.filter.90': 'Laatste 90 dagen',
  'acct.bill.filter.all': 'Ooit',
  'acct.bill.history': 'Transactiegeschiedenis',
  'acct.bill.manageCards': 'Kaarten beheren',
  'acct.bill.manageViaStripe': 'Beheer via Stripe Customer Portal',
  'acct.bill.methodAutoAdded': 'Wordt automatisch toegevoegd na start proefperiode.',
  'acct.bill.methodOnFile': 'Betaalmethode opgeslagen',
  'acct.bill.methods': 'Betaalmethoden',
  'acct.bill.noMethods': 'Geen betaalmethoden gevonden',
  'acct.bill.paid': 'Betaald',
  'acct.bill.pdfUnavailable': 'Deze factuur kan hier nu niet als pdf worden geladen. Je kunt hem openen en downloaden bij Stripe.',
  'acct.bill.pdfOpenStripe': 'Factuur openen bij Stripe',
  'acct.bill.primary': 'Primair',
  'acct.dataAccount': 'Data & Account',
  'acct.deleteAccount.btn': 'Account verwijderen',
  'acct.deleteAccount.confirmBtn': 'Account definitief verwijderen',
  'acct.deleteAccount.confirmPwLabel': 'Ter bevestiging je wachtwoord invoeren',
  'acct.deleteAccount.deleting': 'Wordt verwijderd …',
  'acct.deleteAccount.errFailed': 'Verwijderen mislukt.',
  'acct.deleteAccount.errPwRequired': 'Voer je wachtwoord in.',
  'acct.deleteAccount.modalBody':
    'Je account wordt gedeactiveerd en na 30 dagen definitief verwijderd. Binnen deze termijn kun je het reactiveren via e-mail + wachtwoord. Alle je Leads, profielen en beoordelingen worden dan onherroepelijk verwijderd.',
  'acct.deleteAccount.modalTitle': 'Account verwijderen',
  'acct.deleteAccount.title': 'Account verwijderen',
  'acct.deleteAccount.warn':
    'Je account wordt over 30 dagen definitief verwijderd. Je kunt het in deze tijd reactiveren.',
  'acct.seedimport.title': 'Bestaande-klantenlijst importeren',
  'acct.seedimport.desc':
    'Upload een CSV- of tekstbestand met je bestaande klanten — één domein of URL per regel (of een kolom met domeinen). Deze bedrijven worden in GEEN ENKELE doelgroep als nieuwe lead geleverd.',
  'acct.seedimport.hint': 'CSV of .txt · max 5 MB',
  'acct.seedimport.cta': 'CSV uploaden',
  'acct.seedimport.uploading': 'Importeren …',
  'acct.seedimport.report':
    '{rows} regels · {resolved} domeinen herkend · {added} nieuw · {total} in je lijst',
  'acct.seedimport.unresolved': '{n} regels overgeslagen (geen herkenbaar domein)',
  'acct.seedimport.capped': 'Importlimiet bereikt — niet alle domeinen zijn toegevoegd.',
  'acct.seedimport.failed': 'Import mislukt. Controleer het bestand en probeer opnieuw.',
  'acct.export.btn': 'Exporteren',
  'acct.export.failed': 'Export mislukt. Probeer het opnieuw.',
  'acct.export.preparing': 'Export wordt voorbereid: kan bij veel data even duren.',
  'acct.export.ready': 'Download gestart.',
  'acct.export.sub': 'AVG Art. 20: al je data als JSON-download.',
  'acct.export.title': 'Data exporteren',
  'acct.int.apiKey': 'API-sleutel',
  'acct.int.apiKeyP': 'Uit de ontwikkelaarsinstellingen van je CRM',
  'acct.int.autoPush': 'Auto-Push bij "Geschikt"',
  'acct.int.autoPushSub': 'Leads worden automatisch naar je CRM gepusht zodra je ze bevestigt.',
  'acct.int.bulkPush': '{n} naar CRM verzenden',
  // LEA-282: HubSpot OAuth strings (Wave 2)
  'acct.int.oauthFail': 'OAuth-verbinding mislukt',
  'acct.int.reconnect': 'Opnieuw verbinden',
  'acct.int.reconnectRequired': 'Opnieuw verbinden vereist',
  'acct.int.connectedVia': 'Verbonden via OAuth',
  // LEA-268 backfill: CRM-button strings missing from the initial deploy
  // (Om bug-report 2026-05-26 — keys rendered as bracketed [det.crmOpenRecord]).
  'det.crmPushing': 'Bezig met pushen…',
  'det.crmPushFail': 'CRM-push mislukt',
  'det.crmSubRequired': 'CRM-push vereist een betaald abonnement.',
  'det.crmDuplicate': 'Al in CRM',
  'det.crmNotConnected': 'Geen CRM verbonden: stel er één in via Account → Integraties',
  'det.crmOpenRecord': 'Record bekijken',
  'acct.int.pushFail': 'CRM-push mislukt',
  'acct.int.pushDuplicate': 'Al in CRM',
  'acct.int.pushSubRequired': 'CRM-push vereist een betaald abonnement.',
  'acct.int.bulkSummary': '{pushed} verzonden · {skipped} overgeslagen · {failed} mislukt',
  'leads.bulkPushBtn': 'Stuur {n} naar {crm}',
  'leads.bulkPushPickBtn': 'Stuur {n} naar CRM ▾',
  'leads.bulkPushTitle': 'Stuur de momenteel zichtbare leads (max 50) naar je CRM',
  'acct.int.cancel': 'Annuleren',
  'acct.int.connect': 'Verbinden',
  // LEA-317
  'acct.int.subRequired':
    'CRM-integraties zijn alleen beschikbaar op betaalde abonnementen. Upgrade je abonnement om je CRM te verbinden.',
  'acct.int.upgradeTitle': 'Upgrade om je CRM te verbinden',
  'acct.int.upgradeCta': 'Upgraden',
  'acct.int.connectFirst':
    'Verbind je CRM in de accountinstellingen om leads automatisch te pushen.',
  'acct.int.connectSuccess': 'Verbonden met {name}',
  'acct.int.connected': 'Verbonden',
  'acct.int.disconnect': 'Loskoppelen',
  'acct.int.disconnectSuccess': 'Verbinding met {name} verbroken',
  'acct.int.manage': 'Beheren',
  'acct.int.mapping': 'Veldmapping',
  'acct.int.mappingSub': 'Leadscraper-velden → CRM-velden',
  'acct.int.none': 'Geen CRM verbonden',
  'acct.int.notConnected': 'Niet verbonden',
  'acct.int.notPushedYet': 'Nog niet gepusht',
  'acct.int.object': 'Object-type',
  'acct.int.openInCRM': 'Openen in {name}',
  'acct.int.owner': 'Eigenaar',
  'acct.int.pipeline': 'Pipeline',
  'acct.int.pushSuccess': '{n} lead(s) verzonden naar {name}',
  'acct.int.pushToCRM': 'Naar CRM verzenden',
  'acct.int.pushedAt': 'Gepusht {when}',
  'acct.int.pushedTo': 'In {name}',
  'acct.int.save': 'Verbinding opslaan',
  'acct.int.sectionLead': 'CRM-status',
  'acct.int.stage': 'Stage voor nieuwe leads',
  'acct.int.sub': 'Verbind je CRM en push passende leads automatisch – of handmatig per lead.',
  // LEA-334: webhook signing secret + verification handshake
  'acct.int.whsec.title': 'Webhook-ondertekeningsgeheim',
  'acct.int.whsec.sub':
    'We ondertekenen elke webhook-aflevering met HMAC-SHA256, zodat je endpoint kan controleren dat die echt van Leadscraper komt.',
  'acct.int.whsec.revealed': 'Kopieer dit nu: het wordt maar één keer getoond.',
  'acct.int.whsec.copy': 'Kopiëren',
  'acct.int.whsec.copied': 'Gekopieerd',
  'acct.int.whsec.rotate': 'Geheim roteren en tonen',
  'acct.int.whsec.rotating': 'Roteren…',
  'acct.int.whsec.rotateHint':
    'Bij roteren wordt een nieuw geheim aangemaakt en eenmalig getoond: werk daarna je endpoint bij.',
  'acct.int.whsec.fail': 'Kon het ondertekeningsgeheim niet roteren.',
  'acct.int.whsec.docs':
    'Controleren: header X-Leadscraper-Signature: t=<unix>,v1=<hex>, waarbij hex = HMAC-SHA256(secret, "<t>.<rawBody>"). Weiger het verzoek als het niet overeenkomt of de timestamp verouderd is.',
  'acct.int.webhookUrl': 'Webhook-URL',
  'acct.int.webhookUrlP': 'https://your-endpoint.example.com/leadscraper',
  'acct.int.autoPushSubWebhook':
    'Nieuwe leads worden automatisch naar je webhook gestuurd zodra hun contactgegevens zijn verrijkt.',
  'acct.int.whverify.title': 'Verifieer je endpoint',
  'acct.int.whverify.sub':
    'Een bereikbaar endpoint (geeft 2xx terug) is niet hetzelfde als een geverifieerd endpoint. Bevestig een eenmalige code zodat we weten dat leads echt aankomen: tot die tijd worden er geen afgeleverd.',
  'acct.int.whverify.verified': '✓ Geverifieerd',
  'acct.int.whverify.unverified': 'Niet geverifieerd',
  'acct.int.whverify.send': 'Testevent versturen',
  'acct.int.whverify.sending': 'Versturen…',
  'acct.int.whverify.resend': 'Testevent opnieuw versturen',
  'acct.int.whverify.sent': 'Testevent verstuurd: check je endpoint voor de code.',
  'acct.int.whverify.sendFail': 'Kon het testevent niet versturen.',
  'acct.int.whverify.enter': 'Voer de code (LSWH-…) in die bij je endpoint is aangekomen:',
  'acct.int.whverify.confirm': 'Bevestigen',
  'acct.int.whverify.ok': 'Webhook geverifieerd: leads kunnen nu worden afgeleverd.',
  'acct.int.whverify.mismatch':
    'Die code klopt niet. Controleer je endpoint en probeer het opnieuw.',
  'acct.int.whverify.expired': 'Die code is verlopen: verstuur een nieuw testevent.',
  'acct.int.testing': 'Verbinding testen …',
  'acct.int.title': 'CRM-Integraties',
  'acct.menu.logout': 'Uitloggen',
  'acct.menu.settings': 'Account-instellingen',
  'acct.plan.active': 'Actief',
  'acct.plan.canceled': 'Geannuleerd',
  'acct.plan.refundedEnded':
    'Abonnement terugbetaald, plan beëindigd. Kies een plan om door te gaan.',
  'acct.plan.addOneOff': 'Eenmalig pakket toevoegen',
  'acct.plan.afterTrial': 'Na proefperiode',
  'acct.plan.bonusCredits': 'Pakket-Credits',
  'acct.plan.bonusCreditsTip':
    'Betaalde Credits uit eenmalige pakketten, worden toegevoegd aan het maandelijkse contingent en vervallen niet.',
  'acct.plan.dayLeft': 'Nog 1 dag gratis proberen: daarna loopt je abonnement automatisch door.',
  // LEA-561: Abbuchungsdatum + Ein-Klick-Kuendigung im Trial. Bewusst OHNE
  // Erinnerungs-Versprechen — die Reminder-Mail ist gebaut, aber noch von
  // keinem Scheduler aufgerufen; eine Zusage, die das System nicht halten
  // kann, ist genau der Vertrauensbruch, den LEA-553 abstellen soll.
  'acct.plan.trialFirstCharge': 'Eerste afschrijving op {date}. Zeg altijd op met één klik.',
  'acct.plan.daysLeft':
    'Nog {n} dagen gratis proberen: daarna loopt je abonnement automatisch door.',
  'acct.plan.endsToday': 'Proefperiode eindigt vandaag. Je abonnement start automatisch.',
  'acct.plan.leftOf': 'van {total} over',
  'acct.plan.monthUsage': 'Leads deze maand',
  'acct.plan.nextBill': 'Volgende facturatie op {date} · {leads} Leads/maand',
  'acct.plan.cancelsOn': 'Eindigt op {date}',
  'acct.plan.cancelNote': 'Geen verdere afschrijving, actief tot {date}.',
  'acct.plan.perMonth': '/ maand',
  'acct.plan.secureSub': 'Abonnement beveiligen',
  'acct.plan.switch': 'Plan wijzigen',
  'acct.plan.trial': 'Proefperiode',
  'acct.plan.trialCredits': 'Trial-Credits',
  'acct.plan.trialCreditsTip':
    'Gratis test-Credits van je aanmelding, worden toegevoegd aan het maandelijkse contingent en vervallen niet.',
  // LEA-704: surplus of a migrated account = the balance carried over, not trial credits.
  'acct.plan.carriedOverCredits': 'Overgenomen Credits',
  'acct.plan.carriedOverCreditsTip':
    'Je tegoed van vóór de overstap naar betalen per contact, bovenop het maandelijkse contingent en zonder vervaldatum.',
  'acct.plan.trialUsage': 'Test-Leads deze periode',
  'acct.plan.usedThisMonth': '{used} / {total} deze maand gebruikt · Reset op {date}',
  'acct.plan.your': 'Jouw plan',
  'acct.prof.avatarErr': 'Afbeelding kon niet worden geüpload. Probeer opnieuw.',
  'acct.prof.avatarMime': 'Kies een JPG-, PNG- of WebP-bestand.',
  'acct.prof.avatarSize': 'Bestand te groot (max. 2 MB).',
  'acct.prof.avatarUpdated': 'Profielafbeelding bijgewerkt.',
  'acct.prof.email': 'E-mailadres',
  'acct.prof.first': 'Voornaam',
  'acct.prof.lang': 'Taal',
  'acct.prof.last': 'Achternaam',
  'acct.prof.save': 'Opslaan',
  'acct.prof.title': 'Profielinformatie',
  'acct.prof.upload': 'Afbeelding uploaden',
  'acct.prof.uploadHint': 'JPG, PNG of WebP. Max. 2 MB.',
  'acct.pw.changing': 'Wordt gewijzigd …',
  'acct.pw.complexity':
    'Nieuw wachtwoord moet minimaal 8 tekens bevatten, hoofd- en kleine letters, cijfer en speciaal teken (@$!%*?&).',
  'acct.pw.confirm': 'Nieuw wachtwoord bevestigen',
  'acct.pw.cta': 'Wachtwoord wijzigen',
  'acct.pw.current': 'Huidige wachtwoord',
  'acct.pw.failed': 'Wachtwoord kon niet worden gewijzigd.',
  'acct.pw.minErr': 'Minimaal 8 tekens.',
  'acct.pw.minHint': 'Minimaal 8 tekens',
  'acct.pw.mismatch': 'Wachtwoorden komen niet overeen.',
  'acct.pw.new': 'Nieuw wachtwoord',
  'acct.pw.sameAsCurrent': 'Nieuw wachtwoord moet anders zijn dan het huidige.',
  'acct.pw.success': 'Wachtwoord gewijzigd ✓',
  'acct.pw.title': 'Wachtwoord wijzigen',
  'acct.pw.wrongCurrent': 'Huidige wachtwoord is onjuist.',
  'acct.sec.active': 'Actief',
  'acct.sec.change': 'Wijzigen',
  'acct.sec.inactive': 'Inactief',
  'acct.sec.pw': 'Wachtwoord wijzigen',
  'acct.sec.pwSub': 'Wijzig hier je accountwachtwoord',
  'acct.sec.title': 'Beveiligingsinstellingen',
  'acct.sec.twofa': 'Twee-factor authenticatie',
  'acct.sec.twofaActivate': '2FA inschakelen',
  'acct.sec.twofaDeactivate': '2FA uitschakelen',
  'acct.sec.twofaSoon':
    'Twee-factor-authenticatie (Authenticator-app) is hier nog niet aangesloten: de schakelaar was tot nu toe alleen lokaal. Echte 2FA komt als volgende.',
  'acct.sec.twofaSub':
    'Authenticatie is uitgeschakeld. Schakel het in om een extra beveiligingslaag aan je account toe te voegen.',
  'acct.sub':
    'Beheer profielinstellingen, wijzig betaalmethoden en download facturen voor eerdere transacties.',
  'acct.tab.billing': 'Facturatie',
  'acct.tab.integrations': 'Integraties',
  'acct.tab.profile': 'Profiel',
  'acct.founder.title': 'Directe lijn met de oprichter',
  'acct.founder.body':
    'Feedback, een vraag, een probleem? Je bericht komt rechtstreeks bij Janik terecht, niet in een ticketsysteem.',
  'acct.founder.cta': 'Stuur Janik een bericht',
  'acct.title': 'Profiel',
  'acct.toast.failed': 'Opslaan mislukt. Probeer opnieuw.',
  'acct.toast.saved': 'Profiel opgeslagen.',

  'ai.collapse': 'Inklappen',
  'ai.cortex': 'Leadscraper',
  'ai.dismiss': 'Verbergen',
  'ai.errorReply':
    'Ik kan nu niet bij mijn gegevens. Probeer het zo opnieuw, of formuleer je vraag korter.',
  'ai.footer': 'Leadscraper kent alleen je doelgroepen en feedback, geen externe data.',
  'ai.greeting':
    'Hey 👋 Ik ben je Leadscraper-assistent. Ik zie je actieve profiel "{profile}" en alle patronen die het systeem heeft geleerd. Waar gaat het over?',
  'ai.inputP': 'Vraag de assistent iets …',
  'ai.ins.edge.cta': 'Lead bekijken',
  'ai.ins.edge.fallback':
    'Leadscraper is hier onzeker: jouw oordeel helpt het patroon te verscherpen.',
  'ai.ins.edge.title': 'Grensgevaal: {company}',
  'ai.ins.pattern.cta': 'Patroon controleren',
  'ai.ins.pattern.title': 'Nieuw patroon in "{profile}"',
  'ai.ins.tune.body':
    'Match-rate op {rate}%. Ik kan je helpen de volgende zoekopdracht gerichter te formuleren.',
  'ai.ins.tune.cta': 'Zoekopdracht scherper maken',
  'ai.ins.tune.title': '"{profile}" is nog in training',
  'ai.intro':
    'Ik bewaak je profielen 24/7 en help je scherpere zoekopdrachten en betrouwbare leersignalen te formuleren.',
  'ai.langHint':
    'Antwoord in het Nederlands. Maximaal 3-4 korte zinnen per antwoord, behalve bij concrete instructies.',
  'ai.moreN': '+{n} meer',
  'ai.now': 'nu',
  'ai.onlinePrefix': 'Online · kent je {n} doelgroepen',
  'ai.openChat': 'Chat openen',
  'ai.quickStart': 'Snelstart',
  'ai.seedRefine': 'Stel een verfijnde zoekopdracht voor mijn doelgroep "{profile}" voor.',
  'ai.send': 'Versturen',
  'ai.sp1.label': 'Hoe staat mijn actieve doelgroep ervoor?',
  'ai.sp1.prompt':
    'Vat in 3 zinnen samen hoe goed Leadscraper mijn actieve profiel al begrijpt: wat is geleerd, wat niet?',
  'ai.sp2.label': 'Welke patronen moet ik bevestigen?',
  'ai.sp2.prompt':
    'Welke geleerde patronen moet ik als volgende bevestigen of afwijzen, zodat het systeem sneller leert?',
  'ai.sp3.label': 'Zoekopdracht voorstellen',
  'ai.sp3.prompt':
    "Stel me op basis van mijn actieve profiel een precieze volgende zoekopdracht voor: met branche, locatie, grootte en extra's.",
  'ai.sp4.label': 'Waar verlies ik kwaliteit?',
  'ai.sp4.prompt':
    'Waar zie je in mijn profielen potentieel voor hogere match-rates? Wat moet ik aanpassen?',
  'ai.tag.confirmed': 'bevestigd',
  'ai.tag.uncertain': 'onzeker',
  'ai.tag.unconfirmed': 'onbevestigd',
  'ai.thinkingAbout': 'Waar ik nu over nadenk',

  'api.confidence.cautiously_optimistic': 'voorzichtig optimistisch',
  'api.confidence.fairly_sure': 'redelijk zeker',
  'api.confidence.uncertain': 'onzeker',
  'api.confidence.very_sure': 'zeer zeker',

  'apierr.intentParseTimeout': "Onze AI deed er te lang over om je omschrijving te lezen — probeer het zo opnieuw.",

  'auth.login.docTitle': 'Aanmelden · Leadscraper',
  'auth.login.email': 'E-mail',
  'auth.login.errCredentials': 'E-mail of wachtwoord is onjuist.',
  'auth.login.errEmail': 'Ongeldig e-mailadres.',
  'auth.login.errEmpty': 'Vul alle velden in.',
  'auth.login.errGeneric': 'Aanmelding mislukt. Probeer het opnieuw.',
  'auth.login.errUnverified': 'Bevestig eerst je e-mailadres.',
  'auth.login.forgot': 'Wachtwoord vergeten?',
  'auth.login.google': 'Aanmelden met Google',
  'auth.login.googleBusy': 'Aanmelden met Google …',
  'auth.login.hidePassword': 'Wachtwoord verbergen',
  'auth.login.microsoft': 'Aanmelden met Microsoft',
  'auth.login.microsoftBusy': 'Aanmelden met Microsoft …',
  'auth.login.noAccount': 'Nog geen account?',
  'auth.login.or': 'Of',
  'auth.login.password': 'Wachtwoord',
  'auth.login.remember': 'Ingelogd blijven',
  'auth.login.showPassword': 'Wachtwoord tonen',
  'auth.login.signUp': 'Registreren',
  'auth.login.sub': 'Meld je aan bij je account om toegang te krijgen tot je account.',
  'auth.login.submit': 'Aanmelden',
  'auth.login.submitting': 'Aanmelden …',
  'auth.login.title': 'Welkom terug',
  'auth.register.docTitle': 'Registreren · Leadscraper',
  'auth.register.email': 'E-mail',
  'auth.register.errEmail': 'Ongeldig e-mailadres.',
  'auth.register.errEmpty': 'Vul alle velden in.',
  'auth.register.errBotCheck': 'Rond de botcontrole af.',
  'auth.register.errPwMismatch': 'Wachtwoorden komen niet overeen.',
  'auth.register.errPwShort': 'Wachtwoord moet minimaal 8 tekens lang zijn.',
  'auth.register.firstName': 'Voornaam',
  'auth.register.google': 'Registreren met Google',
  'auth.register.googleBusy': 'Registreren met Google …',
  'auth.register.haveAccount': 'Al een account?',
  'auth.register.hidePassword': 'Wachtwoord verbergen',
  'auth.register.lastName': 'Achternaam',
  'auth.register.microsoft': 'Registreren met Microsoft',
  'auth.register.microsoftBusy': 'Registreren met Microsoft …',
  'auth.register.or': 'Of',
  'auth.register.password': 'Wachtwoord',
  'auth.register.passwordConfirm': 'Wachtwoord bevestigen',
  'auth.register.showPassword': 'Wachtwoord tonen',
  'auth.register.signIn': 'Inloggen',
  'auth.register.sub':
    'Test hoe eenvoudig precieze leadlijsten vandaag dankzij AI-agenten gegenereerd kunnen worden.',
  'auth.register.submit': 'Account aanmaken',
  'auth.register.submitting': 'Wordt aangemaakt …',
  'auth.register.title': 'Gratis account aanmaken',
  'auth.reset.backToLogin': 'Terug naar inloggen',
  'auth.reset.confirmLabel': 'Wachtwoord bevestigen*',
  'auth.reset.confirmPlaceholder': 'Wachtwoord opnieuw invoeren',
  'auth.reset.docTitle': 'Wachtwoord resetten · Leadscraper',
  'auth.reset.doneSub': 'Je kunt nu inloggen met je nieuwe wachtwoord.',
  'auth.reset.doneTitle': 'Wachtwoord succesvol gewijzigd',
  'auth.reset.emailLabel': 'E-mail*',
  'auth.reset.emailPlaceholder': 'Voer je e-mailadres in',
  'auth.reset.errInvalidEmail': 'Voer een geldig e-mailadres in.',
  'auth.reset.errPwMismatch': 'Wachtwoorden komen niet overeen.',
  'auth.reset.errPwShort': 'Het wachtwoord moet minimaal 8 tekens lang zijn.',
  'auth.reset.errPwWeak':
    'Het wachtwoord moet hoofdletters en kleine letters, een cijfer en een speciaal teken bevatten.',
  'auth.reset.pwRules':
    'Minimaal 8 tekens, met hoofdletters en kleine letters, een cijfer en een speciaal teken.',
  'auth.reset.errRequest': 'Verzoek mislukt. Probeer het opnieuw.',
  'auth.reset.goToLogin': 'Naar inloggen',
  'auth.reset.haveAccount': 'Heb je al een account?',
  'auth.reset.hidePassword': 'Wachtwoord verbergen',
  'auth.reset.invalidSub': 'Deze wachtwoord resetlink is niet meer geldig. Vraag een nieuwe aan.',
  'auth.reset.invalidTitle': 'Link ongeldig of verlopen',
  'auth.reset.newPwLabel': 'Nieuw wachtwoord*',
  'auth.reset.newPwPlaceholder': 'Minimaal 8 tekens',
  'auth.reset.newPwSub': 'Kies een nieuw wachtwoord voor je account.',
  'auth.reset.newPwTitle': 'Nieuw wachtwoord instellen',
  'auth.reset.requestNew': 'Nieuwe link aanvragen',
  'auth.reset.oauthTitle': 'Dit account gebruikt {provider}-aanmelding',
  'auth.reset.oauthSub':
    'Voor dit account is geen wachtwoord ingesteld. Meld je in plaats daarvan aan met {provider}.',
  'auth.reset.resetBtn': 'Wachtwoord resetten',
  'auth.reset.saving': 'Wordt opgeslagen …',
  'auth.reset.send': 'Link verzenden',
  'auth.reset.sending': 'Wordt verzonden …',
  'auth.reset.sentSub':
    'Als er een account bestaat met dit e-mailadres, hebben we je een resetlink gestuurd. Controleer je inbox (en spam).',
  'auth.reset.sentTitle': 'E-mail verzonden',
  'auth.reset.showPassword': 'Wachtwoord tonen',
  'auth.reset.signIn': 'Inloggen',
  'auth.reset.sub': 'Voer je e-mailadres in en we sturen je een link om je wachtwoord te resetten.',
  'auth.reset.title': 'Wachtwoord resetten',
  'auth.shell.nextSlide': 'Volgende slide',
  // LEA-285: auth slide carousel — mirrors apps/auth/src/lib/i18n.ts.
  'auth.slides.1.headline':
    'AI-agents vinden B2B-bedrijven die precies passen bij jouw ideale klantprofiel.',
  'auth.slides.2.headline':
    'Elke leadlijst wordt vers gegenereerd uit openbare bronnen, geen verouderde of doorverkochte data.',
  'auth.slides.3.headline':
    'Elke lead bevat de relevante beslissers, bronlinks en een duidelijke reden waarom hij past.',
  'auth.slides.aria.region': 'Product-highlights',
  'auth.slides.aria.slide': 'Slide {n} van {total}',
  'auth.slides.aria.goTo': 'Spring naar slide {n}',

  // --- Login + Registrierung, Revision 19 (Janik 17.09.2026) ---
  // Uebersetzung; das deutsche Original ist die Referenz.
  'auth.r19.skip': 'Naar de inhoud',
  'auth.r19.header.haveAccount': 'Al een account?',
  'auth.r19.hero.titleLead': 'Vind de',
  'auth.r19.hero.titleGrad': 'klanten',
  'auth.r19.hero.titleTail': 'voor wie jouw aanbod gemaakt is.',
  'auth.r19.hero.lead':
    'Beschrijf wie je wilt bereiken. Leadscraper vindt passende bedrijven, zoekt contactpersonen op en laat zien waar je het gesprek kunt beginnen.',
  'auth.r19.demo.caption': 'Jouw onderzoek. Stap voor stap.',
  'auth.r19.demo.play': 'Bekijk de werkwijze',
  'auth.r19.form.title': 'Begin met Leadscraper.',
  'auth.r19.form.google': 'Met Google',
  'auth.r19.form.microsoft': 'Met Microsoft',
  'auth.r19.form.separator': 'of met je e-mailadres',
  'auth.r19.form.businessEmail': 'Zakelijk e-mailadres',
  'auth.r19.form.emailPlaceholder': 'jij@bedrijf.nl',
  'auth.r19.form.show': 'Tonen',
  'auth.r19.form.hide': 'Verbergen',
  'auth.r19.legal.accept':
    'Door je te registreren ga je akkoord met onze {terms}. Informatie over je gegevens vind je in ons {privacy}.',
  'auth.r19.legal.privacyLink': 'privacybeleid',
  'auth.r19.proof.founderTitle': 'Persoonlijk begeleid door de oprichter.',
  'auth.r19.proof.founderBody': 'Janik is je directe aanspreekpunt.',
  'auth.r19.confidence.eyebrow': 'Voor je eerste gesprek',
  'auth.r19.confidence.title1': 'Je weet wie je benadert.',
  'auth.r19.confidence.title2': 'En waarom.',
  'auth.r19.confidence.p1.title': 'Bronnen horen erbij.',
  'auth.r19.confidence.p1.body':
    'Je ziet waarop het onderzoek is gebaseerd en kunt de gegevens zelf controleren.',
  'auth.r19.confidence.p2.title': 'Open punten blijven zichtbaar.',
  'auth.r19.confidence.p2.body':
    'Ontbreekt een gegeven, dan zie je dat. Zo bepaal je zelf hoe je verder zoekt.',
  'auth.r19.confidence.p3.title': 'Je krijgt een invalshoek.',
  'auth.r19.confidence.p3.body':
    'Bedrijfskennis helpt je het eerste contact voor te bereiden met een concrete aanleiding.',
  'auth.r19.founder.eyebrow': 'Persoonlijk aan je zijde',
  'auth.r19.founder.role': 'Oprichter van Leadscraper',
  'auth.r19.founder.photoAlt': 'Janik Deimann, oprichter van Leadscraper',
  'auth.r19.founder.body': 'Ik help je persoonlijk bij je zoektocht en je vragen over Leadscraper.',
  'auth.r19.founder.contact': 'Vraag het in de chat',
  'auth.r19.footer.copyright': '© Leadscraper · Deimann Com GmbH',
  'auth.r19.footer.privacy': 'Privacy',
  'auth.r19.footer.imprint': 'Juridische kennisgeving',
  // Geprueft 17.09.2026: HTTP 200.
  'auth.r19.footer.imprintUrl': 'https://www.leadscraper.de/nl/juridische-kennisgeving',
  'auth.r19.footer.navLabel': 'Juridische informatie',
  'auth.verify.defaultError': 'Er is een fout opgetreden.',
  'auth.verify.docTitle': 'E-mail bevestigen · Leadscraper',
  'auth.verify.error': 'Bevestiging mislukt',
  'auth.verify.goToDashboard': 'Direct naar dashboard',
  'auth.verify.noToken': 'Bevestigingslink ontbreekt',
  'auth.verify.noTokenSub':
    'Klik op de link in de e-mail die we je hebben gestuurd. Als je geen e-mail hebt ontvangen, kun je een nieuwe aanvragen.',
  'auth.verify.resendError': 'Nieuwe bevestigingse-mail aanvragen',
  'auth.verify.resendFailed': 'E-mail kon niet opnieuw worden verzonden.',
  'auth.verify.resendNoToken': 'Bevestigingse-mail opnieuw verzenden',
  'auth.verify.resending': 'Wordt verzonden …',
  'auth.verify.resent': 'E-mail opnieuw verzonden ✓',
  'auth.verify.success': 'Succesvol!',
  'auth.verify.successSub':
    'Je e-mailadres is bevestigd. Je wordt doorgestuurd naar het dashboard …',
  'auth.verify.title': 'E-mail bevestigen',
  'auth.verify.toLogin': 'Naar inloggen',
  'auth.verify.verifying': 'E-mail wordt bevestigd …',
  'auth.verify.verifyingSub': 'Een moment geduld.',

  'bill.ret.cancelBody':
    'Er is niets afgeschreven. Je kunt het betalingsproces altijd opnieuw starten.',
  'bill.ret.cancelCta': 'Terug naar Dashboard',
  'bill.ret.cancelTitle': 'Proces geannuleerd',
  'bill.ret.cta': 'Naar Dashboard',
  'bill.ret.docTitleCancel': 'Proces geannuleerd · Leadscraper',
  'bill.ret.docTitleSuccess': 'Betaling succesvol · Leadscraper',
  'bill.ret.errorBody':
    'Je betaling is mogelijk succesvol. We konden de status net niet laden. Controleer je account onder "Facturering".',
  'bill.ret.errorTitle': 'Status niet beschikbaar',
  'bill.ret.rowCredits': 'Credits',
  'bill.ret.rowCreditsAvail': '{n} beschikbaar',
  'bill.ret.rowNextRenewal': 'Volgende facturering',
  'bill.ret.rowPlan': 'Abonnement',
  'bill.ret.seedCta': 'Naar mijn leads',
  'bill.ret.seedDone': 'Alle {delivered} leads zijn binnen. Aan de slag.',
  'bill.ret.seedPartial':
    '{delivered} leads zijn binnen. De rest van je tegoed blijft beschikbaar voor je eigen zoekopdrachten.',
  'bill.ret.seedWorking':
    '{delivered} van {total} leads zijn afgerond, de rest wordt nu verrijkt. In totaal duurt dit 10 tot 30 minuten.',
  'bill.ret.seedWorkingCreated':
    'Je {created} leads zijn aangemaakt. Het opzoeken van de contactpersonen duurt 10 tot 30 minuten. Exporteer het liefst pas als ze er allemaal zijn.',
  'bill.ret.seedWorkingZero':
    'Je leads worden nu aangemaakt. Het opzoeken van de contactpersonen duurt 10 tot 30 minuten. Exporteer het liefst pas als ze er allemaal zijn.',
  'bill.ret.successBodyCredits': 'Je Credits zijn bijgeschreven.',
  'bill.ret.successBodySub': 'Je abonnement is actief. Je hebt nu toegang tot je Leads.',
  'bill.ret.successTitle': 'Betaling succesvol',
  'bill.ret.verifying': 'Betaling wordt verwerkt …',
  'bill.ret.verifyingSub': 'We updaten je account. Dit duurt slechts een moment.',

  'billing.disabled': 'Betalingen zijn momenteel niet beschikbaar. Probeer het later opnieuw.',
  'billing.errorClose': 'Sluiten',
  'billing.errorTitle': 'Er is iets misgegaan',
  'billing.portalNoCustomer': 'Abonnementsbeheer is pas beschikbaar na de eerste aankoop.',
  'billing.trialStarted': 'Welkom bij het {plan}-abonnement: proefperiode loopt.',
  // LEA-546: der Tarifwechsel wurde serverseitig abgelehnt, weil das Abo
  // gerade nicht änderbar ist (Kündigung vorgemerkt bzw. Zahlung offen).
  'billing.reactivateFirst':
    'Je abonnement staat gepland om te eindigen. Activeer het eerst opnieuw, daarna kun je van plan wisselen.',
  'billing.manageInPortal':
    'Dit abonnement kan nu niet worden gewijzigd. Open het facturatieportaal om de betaling te regelen.',
  'billing.unknownError': 'Onbekende fout bij het betalingsproces.',
  'billing.alreadySubscribed': 'Je hebt dit abonnement al. Je huidige plan staat onder Facturatie.',

  'boot.connectionError': 'Verbindingsfout',
  'boot.connectionErrorDesc': 'Kon geen verbinding maken met de server: {msg}',
  'boot.retry': 'Opnieuw proberen',
  'boot.reconnecting': 'Opnieuw verbinden… (poging {n})',

  'common.cancel': 'Annuleren',
  'common.collapse': 'Inklappen',
  'common.edit': 'Wijzigen',
  'common.hide': 'Verbergen',
  'common.loading': 'Laadt …',
  'common.month.apr': 'april',
  'common.month.aug': 'augustus',
  'common.month.dec': 'december',
  'common.month.feb': 'februari',
  'common.month.jan': 'januari',
  'common.month.jul': 'juli',
  'common.month.jun': 'juni',
  'common.month.mar': 'maart',
  'common.month.may': 'mei',
  'common.month.nov': 'november',
  'common.month.oct': 'oktober',
  'common.month.sep': 'september',
  'common.refresh': 'Vernieuwen',
  'common.save': 'Opslaan',
  'common.saving': 'Wordt opgeslagen …',

  'cortex.activeSince': 'Doelgroep actief sinds',
  'cortex.confirm': 'Bevestigen',
  'cortex.confirmed': 'door jou bevestigd',
  'cortex.correct': 'Corrigeren',
  'cortex.ctaRate': 'Nu eerste Leads beoordelen',
  'cortex.feedbacks': 'Feedbacks',
  'cortex.fits': 'Past',
  'cortex.fitsNot': 'Past niet',
  'cortex.footer':
    'Wanneer je een uitspraak corrigeert of vergeet, wordt deze vanaf nu niet meer gebruikt voor het sorteren van jouw Leads.',
  'cortex.forget': 'Vergeten',
  'cortex.hero': 'Dit heeft Leadscraper geleerd uit je {n} beoordelingen.',
  'cortex.heroEmpty': 'Nog leeg. Leadscraper begint te leren zodra je de eerste Leads beoordeelt.',
  'cortex.heroEmptySub':
    'Memory is het geheugen van je profiel: wat je prefereert, wat je afwijst en waar het systeem nog onzeker over is.',
  'cortex.heroSub':
    'Elke uitspraak kun je bevestigen, corrigeren of laten vergeten. Wijzigingen gelden vanaf de volgende sorteerrun.',
  'cortex.learned': 'Wat Leadscraper heeft geleerd',
  'cortex.matchRate': 'Matchpercentage',
  'cortex.medium': 'gemiddeld',
  'cortex.mediumNote': 'verder geobserveerd',
  'cortex.patterns': 'Geleerde patronen',
  'cortex.patternsPending': 'Nog te bevestigen',
  'cortex.perWeek': 'per week',
  'cortex.plain': 'In gewone taal, zoals jij het zou lezen.',
  'cortex.roi.avgOrder': 'Ø Ordervolume',
  'cortex.roi.disclaimer':
    'Rekenwaarde, gebaseerd op jouw huidige trefferquote. Naarmate Leadscraper rijper wordt, worden de cijfers realistischer.',
  'cortex.roi.expectedFits': 'Verwachte Passt-Leads',
  'cortex.roi.leads': 'Leads',
  'cortex.roi.newCustomers': 'Nieuwe klanten',
  'cortex.roi.revenue': 'Progn. omzet',
  'cortex.roi.revenueSub': 'bij huidige stand',
  'cortex.roi.sub': 'Wat jouw huidige stand waard zou kunnen zijn.',
  'cortex.roi.title': 'ROI-schatting',
  'cortex.roi.viaRate': 'Ø Trefferquote',
  'cortex.roi.winLabel': 'Winkans',
  'cortex.roi.winRate': 'Winkans',
  'cortex.runs.col.action': 'Actie',
  'cortex.runs.col.date': 'Datum',
  'cortex.runs.col.leads': 'Leads',
  'cortex.runs.col.matchrate': 'Match rate',
  'cortex.runs.col.params': 'Zoekparameters',
  'cortex.runs.count': 'Runs',
  'cortex.runs.repeat': 'Herhalen',
  'cortex.runs.sub': 'Alle queries die je voor deze doelgroep hebt gestart.',
  'cortex.runs.title': 'Zoekruns',
  'cortex.sinceStart': 'sinds start',
  'cortex.step': 'Stap',
  'cortex.step1': 'Leads openen',
  'cortex.step1d': 'Bekijk de eerste kaarten in je lijst.',
  'cortex.step2': 'Past / Past niet',
  'cortex.step2d': 'Beoordeel elke Lead. Geef bij afwijzing kort een reden.',
  'cortex.step3': 'Hier nalezen',
  'cortex.step3d': 'Na ~20 feedbacks staan hier de eerste duidelijke uitspraken.',
  'cortex.strong': 'sterk',
  'cortex.strongNote': 'betrouwbare patronen',
  'cortex.tierMedium': 'Gemiddeld',
  'cortex.tierStrong': 'Sterk',
  'cortex.tierWeak': 'Zwak',
  'cortex.title': 'Memory',
  'cortex.uncertain': 'Leadscraper is hier onzeker',
  'cortex.weak': 'zwak',
  'cortex.weakNote': 'Leadscraper is hier onzeker',

  'crm.bald': 'BINNENKORT',
  'crm.comingSoon': 'Binnenkort beschikbaar',
  'crm.customAgent': 'Eigen Agent',
  'crm.history.duplicate': 'Al in CRM',
  'crm.history.empty': 'Nog geen pushes. Gebruik "Naar CRM sturen" bij een Lead om te beginnen.',
  'crm.history.failed': 'Mislukt',
  'crm.history.loading': 'Laden…',
  'crm.picker.title': 'Naar welk CRM?',
  'crm.picker.subtitle': 'Kies waar deze lead moet landen. Je kunt altijd wisselen.',
  'crm.history.sent': 'Verzonden',
  'crm.history.sub': 'De laatste 50 Leads die naar je CRM zijn gepusht, nieuwste eerst.',
  'crm.history.title': 'Push-geschiedenis',
  'crm.mcpComingSoon': 'Beschikbaar zodra MCP-Server live gaat.',
  'crm.mcpSub':
    'Verbind Leadscraper direct met Claude, ChatGPT, Cursor of jouw eigen agent via Model Context Protocol. Je Leads, profielen & Memory worden natively beschikbaar als tools.',
  'crm.mcpTitle': 'Leadscraper als MCP-Server',
  'crm.preview.bulkBody':
    'Maakt {n} organisatie-items aan (en personen voor Leads met contactgegevens). Duplicaten die al in je CRM staan worden overgeslagen. Je bestaande items blijven behouden.',
  'crm.preview.bulkSub': '{n} Leads worden naar je CRM gepusht',
  'crm.preview.dedupNote':
    'Als deze Lead al in je CRM staat (vergelijking via domein), wordt de push geregistreerd, maar geen nieuw item aangemaakt. Je houdt wat je hebt.',
  'crm.preview.noContact': 'Alleen Org',
  'crm.preview.plusMore': '+ {n} meer …',
  'crm.preview.pushBtn': 'Nu pushen',
  'crm.preview.pushNBtn': '{n} nu pushen',
  'crm.preview.pushing': 'Wordt gepusht…',
  'crm.preview.singleSub': 'Dit wordt aangemaakt in je CRM',
  'crm.preview.skipPerson': ': overgeslagen (geen e-mail of telefoon bij deze Lead)',
  'crm.preview.title': 'Voorbeeld: Push naar {crm}',
  'crm.preview.willCreate': 'Wordt aangemaakt',
  'crm.preview.willCreatePerson': ': primair contact met e-mail/telefoon',
  'crm.preview.withContact': 'Org + Persoon',
  'crm.section.available': 'Beschikbaar',
  'crm.section.comingNext': 'Binnenkort',
  'crm.section.comingNextLabel': 'Binnenkort',
  'crm.section.connected': 'Verbonden',
  'crm.section.morePlanned': 'Meer integraties gepland',
  'crm.tooltipComingSoon':
    '{name}-integratie komt binnenkort. Je wordt geïnformeerd zodra deze beschikbaar is.',

  'dash.actNow': 'Openen',
  'dash.action': 'Actie',
  'dash.activeRuns.run': 'Zoekopdracht',
  'dash.activeRuns.runs': 'Zoekopdrachten',
  'dash.activeRuns.title': 'Leadscraper werkt nu voor je',
  'dash.avgOrder': 'Ø Orderwaarde',
  'dash.cadence.daily': 'dagelijks',
  'dash.cadence.hourly': 'uurlijks',
  'dash.cadence.manual': 'handmatig',
  'dash.cadence.monthly': 'maandelijks',
  'dash.cadence.weekly': 'wekelijks',
  'dash.close': 'Sluiten',
  'dash.col.lastRun': 'Laatste run',
  'dash.col.leads': 'Leads',
  'dash.col.matchrate': 'Matchpercentage',
  'dash.col.profile': 'Doelgroep',
  'dash.col.profileH': 'Doelgroep',
  'dash.col.query': 'Doelgroep',
  'dash.col.queryName': 'Query',
  'dash.col.statusH': 'Status',
  'dash.col.trained': 'Getraind',
  'dash.col.whenH': 'Wanneer',
  'dash.company.analyzeBtn': 'Analyseren',
  'dash.company.analyzeFresh': '✨ Leadscraper aanleren',
  'dash.company.analyzing': 'Leadscraper leest…',
  'dash.company.cachedToast': 'Profiel uit geheugen geladen.',
  'dash.company.collapsed':
    'Leadscraper kent jouw bedrijf: alle justifications worden op jou toegesneden.',
  'dash.company.doneToast': '✓ Leadscraper kent je nu.',
  'dash.company.editBody':
    'Voer je bedrijfswebsite in. Leadscraper leest deze en onthoudt permanent wat je aanbiedt, aan wie je verkoopt, en welke argumenten je gebruikt, zodat elke justification bij je Leads een op maat gemaakte pitch-strategie wordt in plaats van alleen "past bij de branche".',
  'dash.company.editTitle': 'Zodat Leadscraper je pitches scherpt: vertel ons wat je verkoopt',
  'dash.company.emptyBody':
    'Voer je bedrijfswebsite in en Leadscraper begrijpt in 10 seconden wat je verkoopt. Vanaf dan verklaart elke Lead-justification concreet waarom JOUW aanbod bij DEZE Lead past, in plaats van alleen "past bij de branche". Dat is het aha-moment.',
  'dash.company.emptyTitle': 'Leadscraper kent je nog niet',
  'dash.company.errorFallback': 'Analyse mislukt: probeer het opnieuw.',
  'dash.company.setupBadge': 'Setup vereist',
  'dash.company.stage1': 'Website laden…',
  'dash.company.stage2': 'Begrijpen wat je aanbiedt…',
  'dash.company.stage3': 'Doelgroep identificeren…',
  'dash.company.stage4': 'Alles koppelen aan jouw waarde…',
  'dash.company.stage5': 'Bijna klaar…',
  'dash.company.urlHint': 'Voer je website in. Zodra de URL er staat, kun je Leadscraper aanleren.',
  'dash.company.urlPlaceholder': 'https://mijn-bedrijf.nl',
  'dash.cortex.reanalyze': 'Opnieuw analyseren: Leadscraper bekijkt de pagina opnieuw',
  'dash.cortex.reanalyzeKeepTitle': 'Je handmatige wijzigingen behouden?',
  'dash.cortex.reanalyzeKeepBody':
    'Je hebt dit bedrijfsprofiel handmatig aangepast. Bij een nieuwe analyse kunnen je wijzigingen behouden blijven en wordt alleen de rest ververst, of wordt alles teruggezet naar de nieuwe AI-suggesties.',
  'dash.cortex.reanalyzeKeepCta': 'Mijn wijzigingen behouden',
  'dash.cortex.reanalyzeResetCta': 'Terugzetten naar AI-suggesties',
  'dash.cortex.sells': 'Wat je verkoopt',
  'dash.cortex.title': 'Wat Leadscraper over jouw bedrijf weet',
  'dash.cortex.toWhom': 'Aan wie',
  'dash.cortex.valueProps': 'Value-Props',
  'dash.date': 'Datum',
  'dash.done': 'Klaar',
  'dash.empty.defineAudience': '+ Nu doelgroep definiëren',
  'dash.empty.noFiltered': 'Geen queries in dit filter.',
  'dash.empty.noProfile': 'Nog geen doelgroep aangemaakt.',
  'dash.empty.noQueryStartedAll': 'Nog geen leadquery gestart over alle doelgroepen.',
  'dash.empty.noQueryStartedForProfile': 'Nog geen Lead-query gestart voor "{profile}".',
  'dash.empty.showAll': 'Alle tonen ({n})',
  'dash.empty.startHint':
    'Klik "Zoekopdracht starten" om een query (bedrijfstype, regio, rol, …) te definiëren.',
  'dash.filter.all': 'Alle',
  'dash.filter.oneshot': 'Eenmalig',
  'dash.filter.running': 'Actief',
  'dash.filter.scheduled': 'Gepland',
  'dash.fmtNext.inDays': 'over {n}d',
  'dash.fmtNext.inH': 'over {n}u',
  'dash.fmtNext.inMin': 'over {n}m',
  'dash.fmtNext.soon': 'start zo meteen',
  'dash.fmtNext.tomorrow': 'morgen',
  'dash.funnel.deepened': 'Verdiept',
  'dash.funnel.evaluated': 'Beoordeeld',
  'dash.funnel.identified': 'Geïdentificeerd',
  'dash.funnel.ready': 'Klaar',
  'dash.inProgress': 'In bewerking',
  'dash.inbox.edge': 'Grensgevallen',
  'dash.inbox.edges': 'Grensgevallen',
  'dash.inbox.hint': 'Tip',
  'dash.inbox.leadsFrom': '{leads} Leads uit {profiles} {profileWord}',
  'dash.inbox.less': 'Minder tonen',
  'dash.inbox.more': '+ {n} meer',
  'dash.inbox.profileWord': 'doelgroep',
  'dash.inbox.profilesWord': 'doelgroepen',
  'dash.inbox.showAll': 'Alle {n} tonen',
  'dash.inbox.title': 'Vandaag te doen',
  'dash.lastQueries.subAll':
    'Je laatst gestarte zoekopdrachten over alle profielen. Klik opent de details en laat je de zoekopdracht herhalen.',
  'dash.lastQueries.subForProfile':
    'Je laatst gestarte zoekopdrachten voor "{profile}". Klik opent de details en laat je de zoekopdracht herhalen.',
  'dash.lastQueries.title': 'Laatste Lead-Queries',
  'dash.lastSearch': 'Laatste zoekopdracht: {result}',
  'dash.lastSearch.error': 'Fout',
  'dash.lastSearch.zero': '0 Leads',
  'dash.lastYear': 'Vorig jaar',
  'dash.leads': 'Leads',
  'dash.leadsGen': 'Leads gegenereerd',
  'dash.leadsGenerated': 'Lead gegenereerd',
  'dash.learning.body':
    'Met elke ✓ "past" of ✗ "past niet" {scope} scherpt Leadscraper zijn begrip van jouw ideale Lead aan, en filtert de volgende matches dienovereenkomstig.',
  'dash.learning.cta': '{n} Leads beoordelen',
  'dash.learning.hint': 'Start boven een zoekopdracht. Zodra er Leads zijn, kun je ze beoordelen.',
  'dash.learning.scopeAll': 'in je doelgroepen',
  'dash.learning.scopeProfile': 'voor "{name}"',
  'dash.learning.title': 'Leadscraper wacht op je eerste feedback',
  'dash.maturity.label': 'Rijpheid: {label}',
  'dash.maturity.next.many': 'Nog {n} feedbacks tot {stage}.',
  'dash.maturity.next.one': 'Nog {n} feedback tot {stage}.',
  'dash.maturity.stage.calibrated': 'Gekalibreerd',
  'dash.maturity.stage.early': 'Lerend',
  'dash.maturity.stage.mature': 'Volwassen',
  'dash.maturity.usage':
    'Leadscraper gebruikt jouw feedback afhankelijk van rijpheidsgraad verschillend sterk in de volgende zoekopdracht.',
  'dash.months': 'Mei,Jun,Jul,Aug,Sep,Okt,Nov,Dec,Jan,Feb,Mrt,Apr',
  'dash.newBadge': 'nieuw',
  'dash.newCust': 'Nieuwe klanten',
  'dash.newCustomers': 'Nieuwe klanten',
  'dash.newProfile': 'Nieuwe doelgroep',
  'dash.nextRun.autoPaused': 'Auto-gepauzeerd · 3 lege runs',
  'dash.nextRun.in': 'Volgende run over {time}',
  'dash.nextRun.manual': 'Handmatig · geen schema',
  'dash.nextRun.paused': 'Gepauzeerd',
  'dash.nextRun.pausedCredits': 'Gepauzeerd · Credits opgebruikt',
  'dash.nextRun.soon': 'Zo meteen',
  'dash.nextUp': 'Volgende',
  'dash.onlyFavorites': 'Alleen favorieten',
  'dash.openLeads': 'Leads openen →',
  'dash.openProfile': 'Leads openen',
  'dash.profileDrop.create': 'Eerste doelgroep aanmaken',
  'dash.profileDrop.createSub': 'Doelgroep definiëren, dan kan het beginnen',
  'dash.profiles': 'actief',
  'dash.progress': 'Voortgang',
  'dash.projRevenue': 'Geprojecteerde omzet',
  'dash.projectedRevenue': 'Geprojecteerde omzet',
  'dash.query.businessType': 'Bedrijfstype',
  'dash.query.contact': 'Contactpersoon',
  'dash.query.dashExplain':
    '"—" betekent: Leadscraper heeft de waarde niet getrackt (komt met V1.13 als volledige run-trace).',
  'dash.query.deepAnalysis': 'Diepteanalyse',
  'dash.query.deepAnalysisHint': 'Website + impressum doorgelezen',
  'dash.query.delivered': 'Geleverd',
  'dash.query.deliveredHint': 'Werkelijke matches',
  'dash.query.evaluated': 'Beoordeeld',
  'dash.query.evaluatedHint': 'Leadscraper-redenering toegepast',
  'dash.query.extras': 'Aanvullende criteria',
  'dash.query.failedTitle': 'Zoekopdracht mislukt',
  'dash.query.header': 'Lead-query',
  'dash.query.howWorked': 'Hoe Leadscraper heeft gewerkt',
  'dash.query.identified': 'Geïdentificeerd',
  'dash.query.identifiedHint': 'Bedrijven gevonden via webzoeken + directories',
  'dash.query.leadsSoFar': '{n} Leads tot nu toe · loopt nog',
  'dash.query.loading': 'wordt geladen…',
  'dash.query.noLeads': 'Geen Leads gevonden',
  'dash.query.profile': 'Doelgroep: {name}',
  'dash.query.region': 'Regio / Locatie',
  'dash.query.rerun': 'Nogmaals starten',
  'dash.query.rerunTitle': 'Deze query opnieuw door Leadscraper halen (bijv. na doelgroep-updates)',
  'dash.query.restart': 'Opnieuw starten',
  'dash.query.runHistory': 'Geschiedenis van laatste runs',
  'dash.query.runningNoLeads': 'Loopt nog, leads komen zo',
  'dash.query.showLeads': '{n} Leads tonen',
  'dash.query.rerunRow': 'Herhalen',
  'dash.query.rerunCta': 'Zoekopdracht herhalen',
  'dash.query.searchedLabel': 'Waar je op zocht',
  'dash.query.autoRepeat': 'Automatisch herhalen',
  'dash.query.openSettings': 'Instellingen openen',
  'dash.query.startedAt': 'Gestart: {date}',
  'dash.query.suggestions': 'Leadscraper-suggesties',
  'dash.query.technicalDetails': 'Technische details',
  'dash.query.unfeasibleTitle': 'Leadscraper acht de query niet uitvoerbaar',
  'dash.query.unnamed': 'Naamloze query',
  'dash.query.whenRuns': 'Wanneer loopt deze zoekopdracht?',
  'dash.queryHint': 'Tip voor zoekopdracht',
  'dash.queryId': 'Query ID',
  'dash.renameQuery': 'Query hernoemen',
  'dash.roi': 'ROI-Calculator',
  'dash.roiShort': 'ROI',
  'dash.run.audience': 'Doelgroep:',
  'dash.run.businessType': 'Bedrijfstype',
  'dash.run.businessTypeP': 'bijv. vouwdozenproducent met eigen stans',
  'dash.run.cancel': 'Annuleren',
  'dash.run.contact': 'Contactpersoon',
  'dash.run.contactP': 'bijv. directie, hoofd inkoop',
  'dash.run.extras': 'Aanvullende beperkingen',
  'dash.run.extrasP':
    'bijv. geen concern, bij voorkeur familiebedrijf, FSC-gecertificeerd gewenst, 50–250 medewerkers',
  'dash.run.forWhich': 'Voor welke doelgroep?',
  'dash.run.minField': 'Minimaal bedrijfstype opgeven',
  'dash.run.notBackendProfile':
    'Deze doelgroep is nog niet geregistreerd in de backend. Maak een echte aan via',
  'dash.run.notBackendProfileCta': '+ Nieuwe doelgroep',
  'dash.run.notBackendProfileEnd': 'aan, dan draait de scraper.',
  'dash.run.optional': '(optioneel)',
  'dash.run.pastQueries': 'Laatste Lead-queries',
  'dash.run.pastQueriesHint': 'Klik om de waarden over te nemen',
  'dash.run.region': 'Regio / Locatie',
  'dash.run.regionHint': 'Stad, provincie, regio of "landelijk": schrijf het zoals je zou zoeken.',
  'dash.run.regionP': 'bijv. Amsterdam, Noord-Holland, Randstad, of landelijk',
  'dash.run.searchBtn': '10 Leads zoeken',
  // LEA-338 Part A / LEA-355 — auto-enrich contact-persons toggle (added in LEA-355).
  'dash.run.withContact.label': 'Contactpersoon automatisch verrijken',
  'dash.run.withContact.hint':
    'Elke nieuwe lead wordt meteen verrijkt met de passende contactpersonen en hun gegevens. Je kunt de leads ook eerst bekijken en ze afzonderlijk verrijken, vooral in het begin aan te raden.',
  'dash.run.withContact.cost': 'Tot {n} Credits, alleen bij een geslaagde verrijking berekend.',
  // LEA-418: per-phase credit-cost transparency
  'dash.run.cost.base': 'Kosten: {n} leads = {n} credits (1 per geleverde lead).',
  'dash.run.cost.extras': 'Contacten & volledige insights: +1 credit/lead elk, alleen op verzoek.',
  'lt.next.connectCostHint': 'Slechts 1 credit bij een bereikbaar contact, anders gratis.',
  // LEA-704: reveal-model pricing (Om QA 26.10.).
  'lt.next.connectFreeHint': 'Gratis — je betaalt pas als je een contactpersoon ontgrendelt.',
  // LEA-356 — cascading Phase-3 acquisition-plan toggle.
  'dash.run.withPlan.label': 'Acquisitieplan automatisch genereren',
  'dash.run.withPlan.hint':
    'Voor elke verrijkte lead wordt een afzonderlijk acquisitieplan gemaakt: een concrete benadering op basis van de gevonden contactpersonen.',
  'dash.run.withPlan.cost': 'Tot {n} Credits, alleen bij een succesvol gegenereerd plan berekend.',
  'dash.run.sub': '10 Credits · 10 Leads · typisch 5–12 min',
  'dash.run.title': 'Lead-zoekopdracht starten',
  'dash.sched.change': 'wijzigen',
  'dash.sched.daily': 'Dagelijks',
  'dash.sched.dailySub': 'Elke dag 10 nieuwe Leads',
  'dash.sched.manual': 'Handmatig',
  'dash.sched.manualSub': 'Geen schema, alleen op klik',
  'dash.sched.pause': '⏸ Pauzeren',
  'dash.sched.resume': '▶ Hervatten',
  'dash.sched.sub': 'Leadscraper haalt regelmatig 10 verse leads op voor deze doelgroep.',
  'dash.sched.time': 'Query plannen',
  'dash.sched.title': 'Query plannen',
  'dash.sched.toast.error': 'Schema kon niet worden opgeslagen: {err}',
  'dash.sched.toast.manual': 'Planning verwijderd: doelgroep draait alleen handmatig.',
  'dash.sched.toast.paused': 'Doelgroep gepauzeerd, geen automatische runs.',
  'dash.sched.toast.set': 'Schema ingesteld: Leadscraper draait automatisch ({cadence}).',
  'dash.sched.twiceWeekly': 'Ma / Do',
  'dash.sched.twiceWeeklySub': '2× per week, ~20 Leads/week',
  'dash.sched.weekly': 'Wekelijks',
  'dash.sched.weeklySub': 'Eenmaal per week 10 Leads',
  'dash.schedInd.nextRun': 'volgende run',
  'dash.schedInfo.everyNh': 'elke {n} u',
  'dash.schedInfo.hourly': 'uurlijks',
  'dash.schedInfo.oneshot': 'eenmalig',
  'dash.schedInfo.paused': 'gepauzeerd',
  'dash.simulation': 'Simulatie',
  'dash.startRun': 'Zoekrun starten',
  'dash.startRunDisabledHint': 'Maak eerst een doelgroep aan, start dan een zoekopdracht',
  'dash.status': 'Status',
  'dash.status.delivered.many': '{n} Leads geleverd',
  'dash.status.delivered.one': '{n} Lead geleverd',
  'dash.status.deliveredSuffix.many': 'Leads geleverd',
  'dash.status.deliveredSuffix.one': 'Lead geleverd',
  'dash.status.done': 'Klaar',
  'dash.status.empty': 'Geen resultaten',
  'dash.status.failed': 'Mislukt',
  'dash.status.running': 'Actief',
  'dash.status.runningEllipsis': 'Actief…',
  'dash.status.runningPrefix': 'Actief · ',
  'dash.status.unfeasible': 'Niet haalbaar',
  'dash.step.delivery': 'Leads samenstellen',
  'dash.step.discovery': 'Bedrijven identificeren',
  'dash.step.done': 'Klaar',
  'dash.step.fallbackProfile': 'Doelgroep',
  'dash.step.hydration': 'Bedrijven diepgaand analyseren',
  'dash.step.planning': 'Leadscraper herinnert zich',
  'dash.step.reasoning': 'Leadscraper beoordeelt',
  'dash.step.starting': 'Starten…',
  'dash.timeline': 'Ontwikkeling van kerncijfers over tijd',
  'dash.totalLeads': 'Totaal aantal Leads',
  'dash.whenCell.next': 'volgende {label}',
  'dash.winRate': 'Winstkans',
  'dash.yourLeads': 'Je Leads',
  'dash.yourProfiles': 'Je doelgroepen',
  'dash.yourProfilesSub':
    'Alle doelgroepen die je traint. Een klik opent de leads van deze doelgroep.',

  'det.accepted': 'Geaccepteerd',
  'det.back': 'Terug naar zoekresultaten',
  'det.city': 'Locatie',
  'det.companyProfile': 'Bedrijfsprofiel',
  'det.contact': 'Contact',
  'det.contactsEmpty':
    'Nog geen contactpersonen geëxtraheerd. Leadscraper zoekt in impressum + LinkedIn.',
  'det.crmSoonTitle':
    'CRM-integratie komt binnenkort. Je wordt op de hoogte gebracht zodra HubSpot, Pipedrive & Co. zijn aangesloten.',
  'det.decider': 'Beslisser',
  'det.delivers': 'Levert:',
  'det.draftMail': 'E-mail concept voorbereiden',
  'det.draftMailSoonToast':
    'E-mail concepten vanuit de Lead zijn nog niet beschikbaar, binnenkort.',
  'det.fetched': 'opgehaald',
  'det.fits': 'Passt',
  'det.fitsNot': 'Passt niet',
  'det.founded': 'Opgericht',
  'det.markedFit': '✓ Als Passt gemarkeerd',
  'det.rejectAnyway': '↩ Toch niet passend?',
  'det.markedNotFit': '× Als Passt niet gemarkeerd',
  'det.memoryHint': 'Hint voor jouw geheugen',
  'det.memoryHintText':
    'Wanneer je deze Lead accepteert of afwijst, beïnvloedt dat vergelijkbare Leads in "{profile}", maar niet jouw andere profielen.',
  'det.open': 'Openen',
  'det.patterns': 'Geleerde patronen die hier van toepassing zijn',
  'det.publicOnly':
    'Alle bronnen zijn openbaar toegankelijk. Leadscraper slaat nooit gegevens op die afkomstig zijn uit niet-openbare of betaalde directories.',
  'det.research.footer':
    'Leadscraper probeert verschillende zoekroutes (LinkedIn, bedrijfswebsite, pers, Xing), voordat het terugvalt op de directeur-fallback. Zo is transparant waarom precies dit contact wordt getoond.',
  'det.research.hit': '✓ Resultaat',
  'det.research.label': 'Onderzoeksroute',
  'det.research.noHit': '○ geen resultaat',
  'det.research.resultMany': 'Resultaten',
  'det.research.resultOne': 'Resultaat',
  'det.research.summaryFallback':
    '{n} zoekroutes geprobeerd: geen specifieke rol gevonden, directeur als fallback',
  'det.research.summaryFound': 'Contact gevonden in stap {stage}: {label}',
  'det.research.summaryNoHit': '{n} zoekroutes zonder resultaat',
  'det.sector': 'Sector',
  'det.shortProfile': 'Kort profiel',
  'det.similar': 'Vergelijkbaar met Leads die je eerder hebt geaccepteerd',
  'det.size': 'Medewerkers',
  'det.sourcesCount': 'Bronnen',
  'det.sourcesSub': 'Elk veld in deze Lead kun je terugvoeren naar een concrete openbare bron.',
  'det.sourcesTitle': 'Waar deze informatie vandaan komt',
  'det.trail.searched': 'Cortex doorzocht {n} openbare bronnen',
  'det.trail.website': 'Bedrijfswebsite',
  'det.trail.register': 'Handelsregister',
  'det.trail.google': 'Google-onderzoek',
  'det.trail.press': 'Pers',
  'det.trail.pages': "{n} pagina's",
  'det.trail.profiles': '{n} profielen',
  'det.capturedAt': 'vastgelegd',
  'det.derivedAt': 'afgeleid',
  'det.sourcePage': 'Bronpagina',
  'det.sourcesBelegtCount': '{n} onderbouwd',
  'det.sourcesTagline': 'Waar elk gegeven vandaan komt, open en verifieerbaar.',
  'det.sourcesBelegt': '{n} van {total} onderbouwd',
  'det.sourcesFieldCount': '{n} velden',
  'det.lastChecked': 'laatst gecontroleerd',
  'det.sourcesUnsourced': 'Nog niet onderbouwd',
  'det.sourcesHonesty':
    'Officiële en openbare gegevens zijn direct onderbouwd; AI-schattingen zijn duidelijk als zodanig gemarkeerd. Leadscraper gebruikt geen betaalde databases.',
  'det.sourcesFlex':
    'Anderen verbergen waar hun data vandaan komt. Wij tonen elke bron, verifieerbaar.',
  'ld.tier.officialName': 'Officieel onderbouwd',
  'ld.tier.officialSub': 'Officieel register en wettelijk verplichte gegevens',
  'ld.tier.publicName': 'Openbaar onderbouwd',
  'ld.tier.publicSub': 'Openbaar zichtbaar op het web',
  'ld.tier.inferredName': 'Door Cortex afgeleid',
  'ld.tier.inferredSub': 'Schatting: controleer vóór verzending',
  'ld.tier.officialFallback': 'Officiële bron',
  'ld.tier.publicFallback': 'Openbare bron',
  'ld.tier.inferredFallback': 'Door Cortex afgeleid',
  'ld.tier.legendOfficial': 'officieel',
  'ld.tier.legendPublic': 'openbaar',
  'ld.tier.legendInferred': 'afgeleid · controleren',
  'ld.tier.legendUnsourced': 'nog open',
  'ld.srcLabel.dork': 'Openbare webzoekopdracht',
  'ld.srcLabel.icypeas_finder': 'Afgeleid e-mailadres',
  'ld.srcLabel.role_match': 'Rolmatch',
  'ld.srcLabel.cortexNace': 'Cortex-branche-analyse',
  'ld.field.vatId': 'Btw-nummer',
  'ld.field.facebook': 'Facebook',
  'ld.field.instagram': 'Instagram',
  'ld.field.country': 'Land',
  'ld.field.contactPhone': 'Telefoon (contactpersoon)',
  'det.toCRM': 'Overnemen in CRM',
  'det.webExcerpts': 'Website-uittreksels',
  'det.website': 'Website',
  'det.whyFits': 'Waarom dit bij je past',
  'det.whyFitsSub': 'uit wat Leadscraper over jou heeft geleerd',

  'error.account_deleted': 'Dit account is verwijderd.',
  'error.email_unverified': 'Verifieer eerst je e-mailadres (link in de aanmeldmail).',
  'error.demo_read_only': 'Dit staat uit in de demo. Er is niets gewijzigd.',
  'error.impersonate_target_not_found':
    'Test-account niet gevonden: de UID bestaat niet in deze DB-omgeving (Mini / Staging / Production).',
  'error.invalidInput': 'Invoer ongeldig.',
  'error.noProfile': 'Geen doelgroep geselecteerd.',
  'error.profileNotRegistered':
    'Doelgroep nog niet geregistreerd in de backend. Ik open de wizard.',
  'error.unauthenticated': 'Je bent niet ingelogd. Herlaad de pagina en log opnieuw in.',

  'expired.body':
    'Je toegang is gepauzeerd. Reactiveer je abonnement om weer Leads te zoeken en je doelgroepen te laten draaien.',
  'expired.readOnly':
    'Je kunt je Leads nog steeds bekijken en exporteren. Nieuwe zoekopdrachten en contactonderzoek vereisen een actief abonnement.',
  'expired.creditsKept': 'Je {credits} Credits zijn bevroren, niet verwijderd.',
  'expired.cta': 'Abonnement reactiveren',
  'expired.ctaLoading': 'Wordt geladen…',
  'expired.title': 'Je abonnement is beëindigd',
  // LEA-704: welcome-back screen for expired accounts moved into the reveal model.
  'revealMigration.title': 'Welkom terug',
  'revealMigration.subtitle': 'Leadscraper rekent nu per contact af',
  'revealMigration.free': 'Zoeken en contactonderzoek zijn gratis',
  'revealMigration.payPerContact': 'Je betaalt alleen als je een contactpersoon ontgrendelt',
  'revealMigration.units': 'Je tegoed blijft staan: {n} contacten om te ontgrendelen',
  'revealMigration.unitsOne': 'Je tegoed blijft staan: 1 contact om te ontgrendelen',
  'revealMigration.unitsNone': 'Koop contacten per pakket wanneer je ze nodig hebt',
  'revealMigration.cta': 'Doorgaan',
  'revealMigration.ctaLoading': 'Even geduld…',
  'revealMigration.error': 'Dat is niet gelukt. Probeer het opnieuw.',

  'fb.blocked.headline': 'De zoekopdracht is te breed',
  'fb.blocked.subline':
    'Leadscraper zou hiermee voornamelijk portals, verbanden of adviesbureaus vinden, geen echte individuele bedrijven.',
  'fb.cta.adjust': 'Zoekopdracht aanpassen',
  'fb.cta.bypass': 'Toch starten',
  'fb.cta.bypassTitle': 'De zoekopdracht doorloopt Leadscraper alsnog, op eigen risico',
  'fb.cta.sharpen': 'Terug & verscherpen',
  'fb.field.ansprechpartner': 'Contactpersoon',
  'fb.field.ort': 'Plaats',
  'fb.field.rawQuery': 'Vrije tekst',
  'fb.field.region': 'Regio',
  'fb.field.unternehmensart': 'Bedrijfstype',
  'fb.field.zusatz': 'Aanvullende criteria',
  'fb.fieldWarnings': 'Velden met opmerkingen',
  'fb.suggestions': 'Concretere formuleringen',
  'fb.suggestionsHint':
    'Kopieer een van de suggesties terug naar het veld of formuleer zelf: dit verhoogt de trefkans meetbaar.',
  'fb.warning.headline': 'Deze zoekopdracht is zeer specifiek',
  'fb.warning.subline':
    'Met deze combinatie van filters vindt Leadscraper mogelijk slechts weinige of geen resultaten. Je kunt toch beginnen of de zoekopdracht iets verbreden.',

  'find.amount': 'Aantal Leads',
  'find.amountHint': 'De waarde moet tussen 1 en 1000 liggen',
  'find.businessType': 'Bedrijfstype',
  'find.businessTypeP': 'bijv. restaurant, advocaat, belastingadviseur',
  'find.contact': 'Contactpersoon',
  'find.contactP': 'bijv. eigenaar, verkoper, directeur',
  'find.creditNote': '(1 Lead = 1 Credit)',
  'find.extras': 'Extra beperkingen',
  'find.extrasP': 'Definieer je doelgroep nog preciezer',
  'find.forProfile': 'Voor welke doelgroep?',
  'find.forProfileHint': 'Je beoordelingen trainen Leadscraper voor deze doelgroep.',
  'find.location': 'Locatie',
  'find.locationP': 'bijv. Amsterdam, Rotterdam, Utrecht',
  'find.start': 'Leadscraper starten',
  'find.title': 'Nieuwe Leads zoeken',
  'find.trainsProfile': 'Traint',

  'hero.eyebrow': 'Leadscraper leert je kennen',
  'hero.stat.feedbacks': 'Feedbacks totaal',
  'hero.stat.matchrate': '⌀ Matchpercentage',
  'hero.stat.profiles': 'actieve doelgroepen',
  'hero.sub':
    'Elke "Past / Past niet" verfijnt welke Leads morgen bovenaan staan. Dit zijn je huidige kerncijfers.',
  'hero.title': 'Over alle doelgroepen heen wordt Leadscraper scherper, met elke feedback.',

  'inbox.sched.body': 'Volgende run {rel}: nieuwe Leads komen automatisch {where}.',
  'inbox.sched.cta': 'Bekijken',
  'inbox.sched.inCRM': 'in CRM',
  'inbox.sched.inList': 'in jouw lijst',
  'inbox.sched.title': '{n} geplande runs actief',

  'ld.aggregatorWarn':
    'Eigen bedrijfswebsite wordt nog bepaald. Tot dan tonen we de bron-URL (directory/pers) waaruit dit bedrijf afkomstig is.',
  'ld.comingSoon': '· binnenkort',
  'ld.company': 'Bedrijf',
  'ld.companySite': 'Bedrijfswebsite',
  'ld.contactPhoneUnknown': 'Directe nummer niet openbaar',
  'ld.contacts': 'Contactpersonen',
  'ld.decisionMaker': '· Beslisser',
  'ld.email.apply': 'Patroon toepassen',
  'ld.email.confGuessed': 'geschat',
  'ld.email.confLikely': 'waarschijnlijk',
  'ld.email.confPlausible': 'plausibel',
  'ld.email.copied': 'Geschat e-mailadres naar klembord gekopieerd.',
  'ld.email.derivedFrom':
    'Afgeleid uit {n} e-mail{s} op de bedrijfswebsite. {conf}: controleer zelf voordat je mailt.',
  'ld.email.noDirectExplain':
    'Het directe e-mailadres voor {first} {last} hebben we niet gevonden. We hebben wel het e-mailpatroon van het bedrijf herkend: klik om het waarschijnlijke adres te zien. Je draagt zelf de verantwoordelijkheid.',
  'ld.email.notFound': 'Geen direct e-mailadres voor dit contact gevonden.',
  'ld.emailLabel': 'E-mail',
  'ld.emailPattern': 'Email-patroon',
  'ld.emailPattern.confHigh': 'hoog',
  'ld.emailPattern.confLow': 'laag',
  'ld.emailPattern.confMid': 'gemiddeld',
  'ld.emailPattern.hint': 'Alle contactpersonen van dit bedrijf volgen waarschijnlijk dit patroon.',
  'ld.emailPattern.noPattern': 'Gevonden emails ({n}) volgen geen duidelijk patroon.',
  'ld.emailPattern.noSamples': 'Geen medewerker-emails op de website gevonden.',
  'ld.emailPattern.notFound': 'Geen patroon gevonden',
  'ld.emailPattern.notRecognized': 'niet herkend',
  'ld.emailPattern.sourceMany': 'Bronnen',
  'ld.emailPattern.sourceOne': 'Bron',
  'ld.fetchedThisWeek': 'deze week',
  'ld.field.acquisitionHook': 'Leadscraper-Acquisitie-Hook',
  'ld.field.centralEmail': 'Centraal e-mailadres',
  'ld.field.centralPhone': 'Centraal telefoonnummer',
  'ld.field.certs': 'Certificaten',
  'ld.field.city': 'Stad',
  'ld.field.companyName': 'Bedrijfsnaam',
  'ld.field.customerRefs': 'Klant-Referenties',
  'ld.field.description': 'Kort profiel',
  'ld.field.email': 'Email (Beslisser)',
  'ld.field.employees': 'Aantal medewerkers',
  'ld.field.firstName': 'Voornaam (beslisser)',
  'ld.field.foundedYear': 'Oprichtingsjaar',
  'ld.field.hrNumber': 'KvK-nummer',
  'ld.field.jobSnapshot': 'Vacatures',
  'ld.field.lastName': 'Achternaam (Beslisser)',
  'ld.field.legalForm': 'Rechtsvorm',
  'ld.field.linkedin': 'LinkedIn (Beslisser)',
  'ld.field.locations': 'Locaties',
  'ld.field.nace': 'NACE-branche',
  'ld.field.ownership': 'Eigenaar / Geschiedenis',
  'ld.field.revenueRange': 'Omzet-range',
  'ld.field.role': 'Rol (Beslisser)',
  'ld.field.sizeClass': 'Grootteklasse',
  'ld.field.street': 'Straat',
  'ld.field.triggerEvent': 'Trigger-Event',
  'ld.field.website': 'Website-URL',
  'ld.field.xing': 'XING (Beslisser)',
  'ld.field.deciderProfile': 'Profiel beslisser',
  'ld.field.zip': 'Postcode',
  'ld.linkedinPublic': 'LinkedIn · openbaar',
  'ld.match.borderline': 'grensgevallen',
  'ld.match.excellent': 'uitstekend',
  'ld.match.solid': 'solide match',
  'ld.match.strong': 'sterke match',
  'ld.sparkle.certs': 'Certificaten & Awards',
  'ld.sparkle.customers': 'Klant-referenties',
  'ld.sparkle.hookFake':
    'Hier kun je aanhaken omdat {company} klassiek MKB-profiel met concrete behoefte toont, past direct bij jouw aanbod.',
  'ld.sparkle.hookLabel': 'Leadscraper Acquisitie-Hook',
  'ld.sparkle.hookUnlockLink': 'jouw bedrijfswebsite',
  'ld.sparkle.hookUnlockPost':
    ' in: Leadscraper genereert dan per Lead een gepersonaliseerde Hook.',
  'ld.sparkle.hookUnlockPre': 'Voer boven in het dashboard ',
  'ld.sparkle.jobs': 'Vacature-snapshot',
  'ld.sparkle.jobsBadge': '{n} open vacatures',
  'ld.sparkle.locations': 'Locaties',
  'ld.sparkle.locked': '· vergrendeld',
  'ld.sparkle.ownerSince': 'sinds {year}',
  'ld.sparkle.ownership': 'Eigendomsstructuur',
  'ld.sparkle.staleAction':
    'Start de Query in het dashboard opnieuw, dan genereren we voor DEZE Lead een gepersonaliseerde acquisitie-Hook plus alle sales-signalen (Trigger-Events, vacatures, klanten, …).',
  'ld.sparkle.staleMsg':
    'Deze Lead werd gegenereerd voordat jouw bedrijfsprofiel bij Leadscraper was opgeslagen.',
  'ld.sparkle.sub': '· Sales-signalen uit Live-Web-analyse',
  'ld.sparkle.title': 'Leadscraper Magic',
  'ld.sparkle.trigger': 'Trigger-Event',
  'ld.sparkle.waitLabel': '· wacht op Re-Run',
  'ld.specialization': 'Specialisatie',
  'ld.srcDesc.firecrawl': 'Hoofdpagina van de bedrijfswebsite (gecached).',
  'ld.srcDesc.footer':
    'Website-footer: vestigingen, certificaten, alternatieve contactmogelijkheden.',
  'ld.srcDesc.haiku_extracted':
    'Leadscraper heeft uit de verwerkte website-inhoud gestructureerde velden geëxtraheerd (beschrijving, klanten, trigger-events).',
  'ld.srcDesc.handelsregister':
    'Officieel Nederlands bedrijfsregister: KvK-nummer, vestiging, inschrijfdatum.',
  'ld.srcDesc.impressum':
    'Verplichte bedrijfsinformatie met bedrijfsnaam, rechtsvorm, adres, directie. Wordt opgehaald en verwerkt.',
  'ld.srcDesc.json_ld': 'Machineleesbare Schema.org-metadata van de website (bedrijfsprofiel).',
  'ld.srcDesc.karriere':
    'Carrièrepagina: openstaande vacatures, gezochte profielen (groeisignaal).',
  'ld.srcDesc.kontakt':
    'Contact-/locatiepagina: telefoonnummers, e-mailadressen, evt. contactpersonen.',
  'ld.srcDesc.llm_haiku':
    'Leadscraper heeft uit de verwerkte website-inhoud gestructureerde velden geëxtraheerd (beschrijving, klanten, trigger-events).',
  'ld.srcDesc.llm_sonnet': 'Leadscraper beoordeelde de lead aan je doelgroep + geheugen.',
  'ld.srcDesc.news': 'Pers-/nieuwspagina: laatste events, uitbreidingen, awards.',
  'ld.srcDesc.regex_derived':
    'Afgeleid uit andere data, bijv. e-mailpatroon uit bekende bedrijfs-e-mail + naam.',
  'ld.srcDesc.serp': 'Google-resultaten voor gerichte domein- of personenzoekopdracht.',
  'ld.srcDesc.team': 'Team-/medewerkerpagina: personen en rollen.',
  'ld.srcDesc.ueber_uns':
    'Zelfbeschrijving van het bedrijf: geschiedenis, eigenaren, waarden, klantreferenties.',
  'ld.srcDesc.user_feedback':
    'Je hebt deze Lead handmatig bevestigd of verworpen: hoogste vertrouwensniveau.',
  'ld.srcLabel.firecrawl': 'Bedrijfswebsite (hoofdpagina)',
  'ld.srcLabel.footer': 'Website-footer',
  'ld.srcLabel.haiku_extracted': 'AI-extractie',
  'ld.srcLabel.handelsregister': 'Handelsregister',
  'ld.srcLabel.impressum': 'Impressum',
  'ld.srcLabel.json_ld': 'Gestructureerde data (Schema.org)',
  'ld.srcLabel.karriere': 'Carrièrepagina',
  'ld.srcLabel.kontakt': 'Contactpagina',
  'ld.srcLabel.llm_haiku': 'AI-extractie',
  'ld.srcLabel.llm_sonnet': 'AI-beoordeling',
  'ld.srcLabel.news': 'Pers / Nieuws',
  'ld.srcLabel.regex_derived': 'Patroon-afleiding',
  'ld.srcLabel.serp': 'Google-zoekopdracht',
  'ld.srcLabel.team': 'Teampagina',
  'ld.srcLabel.ueber_uns': 'Over ons pagina',
  'ld.srcLabel.user_feedback': 'Jouw feedback',
  'ld.toast.accepted': '"{company}" als Geschikt opgeslagen.',
  'ld.toast.feedbackErr': 'Feedback kon niet worden opgeslagen: probeer het opnieuw.',
  'ld.toast.rejected': '"{company}" als Niet geschikt gemarkeerd.',
  'ld.trust.inferred': '🔵 AI-afgeleid',
  'ld.trust.inferredTitle': 'Afgeleid door Leadscraper-AI, geen officiële bron.',
  'ld.trust.official': '🛡 Officieel',
  'ld.trust.officialTitle': 'Juridisch-autoritatieve bron (Handelsregister/Impressum).',
  'ld.trust.public': '🟡 Openbaar',
  'ld.trust.publicTitle': 'Openbaar inzichtelijk op de bedrijfswebsite.',
  'ld.uncertainty': 'Leadscraper is hier {score}: {text}.',
  'ld.unverified.body':
    'Generieke branche-match: de specialisatie werd niet genoemd in de website-content. Indien strikt noodzakelijk, preciseer de Query (bijv. "{token}-vakwinkel").',
  'ld.unverified.title': '"{token}" kon Leadscraper bij dit bedrijf niet verifiëren',
  'ld.viaCentralPhone': 'Via centrale',
  'ld.websiteExcerpt': 'Website-uittreksel',
  'ld.xingPublic': 'XING · openbaar',

  'leads.act.cancel': 'Annuleren',
  'leads.act.details': 'Details',
  'leads.act.fits': 'Geschikt',
  'leads.act.fitsDone': 'Opgeslagen als geschikt',
  'leads.act.fitsNot': 'Niet geschikt',
  'leads.act.fitsNotDone': 'Opgeslagen als niet geschikt',
  'leads.act.reason': 'Reden kiezen',
  'leads.allProfiles': 'Alle doelgroepen',
  'leads.allProfilesHeader': 'Alle doelgroepen',
  'leads.allProfilesShow': 'Alle doelgroepen tonen',
  'leads.backToActive': '← terug naar actieve doelgroep',
  'leads.cardView': 'Kaarten',
  'leads.chip.edge': 'Grenscase · Oordeel?',
  'leads.chip.pattern': 'Vormt een patroon',
  'leads.col.actions': 'Acties',
  'leads.col.centralEmail': 'E-mail',
  'leads.col.centralPhone': 'Telefoon',
  'leads.col.city': 'Locatie',
  'leads.col.company': 'Bedrijf',
  'leads.col.crm': 'CRM',
  'leads.col.decider': 'Beslisser',
  'leads.col.founded': 'Opgericht',
  'leads.col.lastActivity': 'Laatste activiteit',
  'leads.col.legalForm': 'Rechtsvorm',
  'leads.col.match': 'Match',
  'leads.col.nace': 'Branche',
  'leads.col.phase': 'Fase',
  'leads.col.phone': 'Telefoon',
  'leads.col.profile': 'Doelgroep',
  'leads.col.revenue': 'Omzet',
  'leads.col.sector': 'Sub-branche',
  'leads.col.size': 'MW',
  'leads.col.status': 'Status',
  'leads.col.website': 'Website',
  'leads.cols.btn': 'Kolommen',
  'leads.cols.fixed': 'Vast',
  'leads.cols.reset': 'Terugzetten',
  'leads.cols.sub': 'Toon alleen wat je nodig hebt.',
  'leads.cols.title': 'Kolommen weergeven',
  'leads.count': '{shown} van {total} Leads',
  'leads.crm.push': 'Verzenden',
  'leads.crm.notSynced': 'Niet gesynchroniseerd',
  'leads.crm.syncedTo': 'Gesynchroniseerd met {crm}',
  'leads.crm.pushFailed': 'Verzenden mislukt',
  'leads.crossOverview.many': '{n} leads · alle doelgroepen',
  'leads.crossOverview.one': '{n} lead · alle doelgroepen',
  'leads.daysAgo': '{n} dagen geleden',
  'leads.empty':
    'Geen Leads voor dit profiel: start een nieuwe zoekopdracht via "Nieuwe Leads zoeken".',
  'leads.exp.memoryRefs': 'Uit je geheugen',
  'leads.exp.uncertain': 'Leadscraper is hier {score}: {note}.',
  'leads.exp.whyShown': 'Waarom Leadscraper je deze Lead toont',
  'leads.export': 'Export',
  'leads.filter.all': 'Alle',
  'leads.filter.fits': 'Passt',
  'leads.filter.fitsNot': 'Passt niet',
  'leads.filter.unrated': 'Onbeoordeeld',
  'leads.filterBy': 'Filteren op doelgroep',
  'leads.footerHint':
    'Klik op een rij toont de korte gedachte. De knop "Details" opent de 360°-weergave.',
  'leads.searchP': 'Bedrijf, branche, locatie, beslisser …',
  'leads.status.accepted': 'Geschikt',
  'leads.status.rejected': 'Niet geschikt',
  'leads.status.unseen': 'Ongezien',
  'leads.sub':
    '{n} leads · gegroepeerd per profiel. Eén klik opent het 360°-overzicht van het bedrijf.',
  'leads.tableView': 'Tabel',
  'leads.title': 'Je leads',
  'leads.toast.accepted': '"{c}" opgeslagen als geschikt. Leadscraper leert hiervan.',
  'leads.toast.export': 'Export-functie komt binnenkort.',
  'leads.toast.rejected':
    '"{c}" afgewezen · Reden: {r}. Leadscraper leert hiervan voor volgende runs.',

  'lp.card.examplesHint': "(Lead-ID's uit je beoordelingshistorie voor dit cluster)",
  'lp.card.hideExamples': 'Voorbeelden verbergen',
  'lp.card.showExamplesMany': '{n} voorbeeld-leads tonen',
  'lp.card.showExamplesOne': '{n} voorbeeld-lead tonen',
  'lp.cl.age': 'Bedrijfsleeftijd',
  'lp.cl.age.mock': 'Gevestigde bedrijven opgericht voor 2010 geprefereerd',
  'lp.cl.bizModel': 'Bedrijfsmodel',
  'lp.cl.bizModel.mock': 'Operationele aanbieders, geen bureaus of tussenpersonen',
  'lp.cl.buyingSignals': 'Koopsignalen',
  'lp.cl.buyingSignals.mock': 'Actieve trigger-events (groei, hiring) gezocht',
  'lp.cl.domainBlock': 'Domain-Block',
  'lp.cl.domainBlock.mock': 'Concurrent-domeinen worden consistent uitgesloten',
  'lp.cl.geo': 'Locatie',
  'lp.cl.geo.mock': 'NRW + BaWü sterk geprefereerd, Oost-Duitsland minder',
  'lp.cl.industry': 'Branche',
  'lp.cl.industry.mock': 'Voorkeur voor dienstverleningssector (M-N) boven industrie',
  'lp.cl.ownership': 'Eigenaar',
  'lp.cl.ownership.mock': 'Familiebedrijven >> PE-dochters en concerns',
  'lp.cl.role': 'Contactpersoon',
  'lp.cl.role.mock': 'Directieniveau verwacht, afdelingshoofden te junior',
  'lp.cl.size': 'Bedrijfsgrootte',
  'lp.cl.size.mock': 'Neiging naar kleinere operators (10-50 medewerkers)',
  'lp.cl.techStack': 'Tech-Stack',
  'lp.cl.techStack.mock': 'Bepaalde technologieën worden consistent gezocht/vermeden',
  'lp.cta.count': '{n} leads beoordelen',
  'lp.cta.open': 'Leads openen',
  'lp.cta.rate': 'Leads beoordelen',
  'lp.error.load': 'Fout bij laden',
  'lp.evidence.many': '{n} bewijzen',
  'lp.evidence.one': '{n} bewijs',
  'lp.journey.active': 'Actief gepersonaliseerd',
  'lp.journey.matchRate': 'Match rate',
  'lp.journey.matched': 'pasten',
  'lp.journey.notMatched': 'pasten niet',
  'lp.journey.preview': 'Eerste aanleren',
  'lp.journey.title': '{n} beoordelingen: {accepted} past · {rejected} past niet',
  'lp.loading': 'Laadomgeving laden…',
  'lp.locked.pill': 'vanaf {n} beoordelingen',
  'lp.ps.bizModel.analyse':
    'Leadscraper heeft het standaardfilter actief: bureaus, distributeurs en marktplaatsen worden in de reasoning automatisch gedeprioriteert als ze niet bij de vraag passen.',
  'lp.ps.bizModel.content': 'Operationele aanbieders (geen pure bemiddelaars)',
  'lp.ps.bodyDefault':
    'Deze kaarten tonen wat Leadscraper uit je profiel + de bevestigde leads concreet **geanalyseerd** heeft. Beoordeel gerichter met reden zodat de clusters scherper worden.',
  'lp.ps.bodyHigh':
    'Bij slechts {rejected} {rejectWord} kan Leadscraper geen harde uitsluitingsclusters vormen: deze kaarten tonen wat Leadscraper uit je profiel + de {accepted} bevestigde leads concreet **geanalyseerd** heeft. Zodra je gerichter afwijst, rijpen de clusters tot harde filters.',
  'lp.ps.footerBody':
    'Vanaf **50 beoordelingen** houdt Leadscraper bij elke nieuwe zoekopdracht niet alleen rekening met je invoer en wat je bedrijf verkoopt, maar ook met je **geleerde profiel als tendens**: branche, grootteklasse, locatie, rol, eigendomsstructuur. Niet als hard filter, maar als extra weging in de reasoning. Dit betekent dat een nieuwe query naar "accountant Amsterdam" niet generiek alle accountantskantoren zoekt, maar automatisch eigenaarsgeleide MKB-kantoren prefereert, analoog aan het profielbeeld dat je hier hebt opgebouwd.',
  'lp.ps.footerTitle': 'Hoe dit meevloeit in je volgende zoekopdrachten',
  'lp.ps.geo.analyseNo':
    'Leadscraper prioriteert hits uit deze regio en cureert hits uit de omgeving als de kernregio uitgeput raakt.',
  'lp.ps.geo.analyseYes':
    'Leadscraper heeft {n} bedrijven uit deze regio als passend bevestigd: het geografische anker klopt.',
  'lp.ps.geo.fallback': 'DACH-gebied',
  'lp.ps.industry.analyseNo':
    'Leadscraper zoekt systematisch naar bedrijven die passen bij je branche-beschrijving.',
  'lp.ps.industry.analyseYes':
    'Leadscraper bevestigt deze branche door {n} geaccepteerde leads: de branche-afbakening klopt.',
  'lp.ps.industry.anyBranche':
    'Je profiel staat open voor alle branches: Cortex leidt de werkelijke tendens af uit je beoordelingen. Momenteel {n} geaccepteerde Leads als anker. Hoe meer beoordelingen, hoe scherper de afgeleide branche-tendens wordt.',
  'lp.ps.industry.fallback': 'Afgeleid uit je profiel-intentie',
  'lp.ps.ownership.analyseHigh':
    'Leadscraper herkent uit de bevestigde leads dat je focus ligt op eigenaarsgeleide bedrijven: dochterondernemingen worden terughoudender voorgesteld.',
  'lp.ps.ownership.analyseLow':
    'Beoordeel een dochteronderneming concreet met "past niet" zodat Leadscraper hier een hard eigenaar-cluster kan vormen.',
  'lp.ps.ownership.contentHigh': 'Eigenaar-/MKB-profiel bevestigd',
  'lp.ps.ownership.contentLow': 'Mix van eigenaar- en kleinere concernstructuren',
  'lp.ps.ownership.label': 'Eigendomsstructuur',
  'lp.ps.rejectionMany': 'afwijzingen',
  'lp.ps.rejectionOne': 'afwijzing',
  'lp.ps.role.analyseHigh':
    "Leadscraper schrijft in de reasoning actief naar deze rol: colofon + carrièrepagina's + LinkedIn worden gericht hierop gefilterd.",
  'lp.ps.role.analyseLow':
    "Leadscraper zoekt in het colofon + op carrièrepagina's gericht naar deze rollen, valt alleen terug op directeuren als de specifieke rol niet wordt vermeld.",
  'lp.ps.role.fallback': 'Directieniveau',
  'lp.ps.size.analyseHigh':
    'Met {pct}% trefkans ziet Leadscraper dat je gewenste grootteklasse stabiel wordt geraakt, geen correctie nodig.',
  'lp.ps.size.analyseLow':
    'Leadscraper past de medewerkerspanne met elke afwijzing fijner aan op jouw voorstelling.',
  'lp.ps.size.contentHigh': 'Leadscraper raakt de grootteklasse precies',
  'lp.ps.size.contentLow': 'MKB-tendens uit de bevestigde leads',
  'lp.ps.titleDefault': 'Wat Leadscraper begrijpt uit je beoordelingen',
  'lp.ps.titleHigh': 'Leadscraper begrijpt je doelgroep, {pct}% trefferkans',
  'lp.ps.understands': 'Leadscraper begrijpt',
  'lp.s0.body':
    'Bij {preview} beoordeelde leads tonen we je de eerste indruk. Bij {active} zoekt Leadscraper actief voor JOU, gebaseerd op jouw specifieke patronen.',
  'lp.s0.eyebrow': 'Leadscraper leert met je mee',
  'lp.s0.headline': 'Leadscraper bouwt je doelgroep op',
  'lp.s0.openMany': '{n} leads nog niet beoordeeld: beoordeel deze om sneller vooruit te komen.',
  'lp.s0.openOne': '{n} lead nog niet beoordeeld: beoordeel deze om sneller vooruit te komen.',
  'lp.s1.body':
    'Eerste tendensen zijn zichtbaar: bij {n} beoordelingen vloeit dit actief in je zoekopdrachten mee.',
  'lp.s1.eyebrow': 'Eerste indruk',
  'lp.s1.headline': 'Leadscraper verzamelt nog bewijs',
  'lp.s1.morePatterns': 'Andere patronen, worden zichtbaar bij {n} beoordelingen',
  'lp.s1.strongestLabel': 'Sterkste tendens tot nu toe',
  'lp.s2.headline': 'Leadscraper zoekt voor JOU',
  'lp.s2.ignoredMany':
    '{n} beoordelingen waren "kennen we al" of "verkeerde gegevens": deze vloeien bewust niet mee in het leerproces.',
  'lp.s2.ignoredOne':
    '{n} beoordeling was "kennen we al" of "verkeerde gegevens": deze vloeien bewust niet mee in het leerproces.',
  'lp.s2.pillActive': 'Actief gepersonaliseerd',
  'lp.s2.pillSharp': 'Doelgroep zit scherp',
  'lp.s2.pillUpdating': 'Update loopt',
  'lp.s2.reanalysisAgo': 'Laatste heranalyse: {n} beoordelingen geleden · Volgende bij {next}',
  'lp.s2.reanalysisCurrent': 'Heranalyse loopt · Volgende bij {n}',
  'lp.s2.weakLabel': 'Zwakke tendensen, worden harder met meer data',
  'lp.sq.activeSubS1':
    'Op basis van je eerste {n} beoordelingen, worden scherper met elke heranalyse-stap.',
  'lp.sq.activeSubS2':
    'Bijgewerkt na {n} beoordelingen · Heranalyse elke {interval} beoordelingen.',
  'lp.sq.activeTitle': 'Leadscraper stelt deze zoekopdrachten voor',
  'lp.sq.badge.crossSell': 'Cross-sell',
  'lp.sq.badge.expansion': 'Uitbreiding',
  'lp.sq.badge.pattern': 'Patroon',
  'lp.sq.badge.salesFit': 'Sales-fit',
  'lp.sq.badge.zoomOut': 'Zoom-out',
  'lp.sq.emptyBody':
    'Voorstellen worden berekend bij je volgende patroon-heranalyse (elke {n} beoordelingen).',
  'lp.sq.eyebrow': 'Geoptimaliseerde zoekopdrachten',
  'lp.sq.launch': 'Zoekopdracht starten',
  'lp.sq.loading': 'Leadscraper berekent voorstellen…',
  'lp.sq.lockedBody':
    'Zodra je {n} leads hebt beoordeeld, stelt Leadscraper 3–5 zoekopdrachten voor, gestructureerd zoals je invoer, met match-waarschijnlijkheid en korte motivatie.',
  'lp.sq.lockedTitle': 'Leadscraper bereidt concrete voorstellen voor',
  'lp.sq.mockA.contact': 'Directie',
  'lp.sq.mockA.rationale': 'Voorbeeldvoorstel hoe Leadscraper zoekopdrachten voorstelt.',
  'lp.sq.mockA.region': 'Beieren',
  'lp.sq.mockA.type': 'MKB-machinebouwers',
  'lp.sq.mockB.rationale': 'Voorbeeldvoorstel hoe Leadscraper zoekopdrachten voorstelt.',
  'lp.sq.mockB.region': 'DACH',
  'lp.sq.mockB.type': 'Technische installatiebedrijven ziekenhuis-sector',
  'lp.sq.tier.hypothesis': 'Test-hypothese',
  'lp.sq.tier.solid': 'Solide',
  'lp.sq.tier.strong': 'Sterk',
  'lp.sq.tier.veryStrong': 'Zeer sterk',
  'lp.tone.drop': 'STERKE DROP',
  'lp.tone.keep': 'STERKE KEEP',
  'lp.tone.softDrop': 'LICHTE DROP',
  'lp.tone.softKeep': 'LICHTE KEEP',

  'lt.badge.soft': 'mogelijk',
  'lt.dashHint1': 'In het dashboard vind je een hint hierover (symbool',
  'lt.dashHint2': 'naast de status).',
  'lt.exp.btn': 'Export',
  'lt.exp.csvHint': '.csv (komma-gescheiden)',
  'lt.exp.fail': 'Export mislukt: {err}',
  'lt.exp.ing': 'Exporteren…',
  'lt.exp.noRows': 'Geen Leads gevonden om te exporteren.',
  'lt.exp.success': '{n} rijen geëxporteerd als {fmt}.',
  'lt.exp.tipNoLeads': 'Alleen leads met contactpersonen of een afgerond plan zijn exporteerbaar',
  'lt.exp.tipReady': '{n} Leads exporteren',
  'lt.exp.tipWrongFilter':
    'Alleen passende Leads kunnen geëxporteerd worden. Schakel over naar "Passt"-filter.',
  'lt.exp.toastNoLeads':
    'Alleen leads met contactpersonen of een afgerond acquisitieplan kunnen worden geëxporteerd.',
  'lt.exp.unknownErr': 'Onbekende fout',
  'lt.expH.city': 'Locatie',
  'lt.expH.company': 'Bedrijf',
  'lt.expH.companyEmail': 'Bedrijfs-e-mail',
  'lt.expH.companyPhone': 'Bedrijfstelefoon',
  'lt.expH.contact': 'Contactpersoon',
  'lt.expH.direct': 'direct',
  'lt.expH.email': 'E-mail',
  'lt.expH.emailSource': 'E-mailbron',
  'lt.expH.guessed': 'geschat ({n}%)',
  'lt.expH.profile': 'Doelgroep',
  'lt.expH.role': 'Functie',
  'lt.expH.sector': 'Sector',
  'lt.feedbackFail': 'Feedback kon niet worden opgeslagen: probeer het opnieuw.',
  'lt.naceF.A': 'Land- en bosbouw, visserij',
  'lt.payoff.avoided': 'Het dossier vermijdt voortaan:',
  'lt.payoff.flowsIn': 'Vloeit mee in de volgende analyse.',
  'lt.naceF.B': 'Mijnbouw en winning van delfstoffen',
  'lt.naceF.C': 'Industrie',
  'lt.naceF.D': 'Energievoorziening',
  'lt.naceF.E': 'Watervoorziening; afvalwater- en afvalbeheer',
  'lt.naceF.F': 'Bouwnijverheid',
  'lt.naceF.G': 'Handel; onderhoud en reparatie van motorvoertuigen',
  'lt.naceF.H': 'Vervoer en opslag',
  'lt.naceF.I': 'Horeca',
  'lt.naceF.J': 'Informatie en communicatie',
  'lt.naceF.K': 'Financiële instellingen en verzekeringen',
  'lt.naceF.L': 'Onroerend goed',
  'lt.naceF.M': 'Vrije beroepen en wetenschappelijke en technische activiteiten',
  'lt.naceF.N': 'Administratieve en ondersteunende dienstverlening',
  'lt.naceF.O': 'Openbaar bestuur, defensie; sociale verzekeringen',
  'lt.naceF.P': 'Onderwijs',
  'lt.naceF.Q': 'Gezondheids- en welzijnszorg',
  'lt.naceF.R': 'Kunst, amusement en recreatie',
  'lt.naceF.S': 'Overige dienstverlening',
  'lt.naceF.T': 'Particuliere huishoudens',
  'lt.naceF.U': 'Extraterritoriale organisaties',
  'lt.naceS.A': 'Land/Bosbouw',
  'lt.naceS.B': 'Mijnbouw',
  'lt.naceS.C': 'Verwerkende industrie',
  'lt.naceS.D': 'Energie',
  'lt.naceS.E': 'Water/Afval',
  'lt.naceS.F': 'Bouw',
  'lt.naceS.G': 'Handel',
  'lt.naceS.H': 'Vervoer/Opslag',
  'lt.naceS.I': 'Horeca',
  'lt.naceS.J': 'IT/Media',
  'lt.naceS.K': 'Financiën/Verzek.',
  'lt.naceS.L': 'Vastgoed',
  'lt.naceS.M': 'Vrije beroepen',
  'lt.naceS.N': 'Zakelijke dienstverlening',
  'lt.naceS.O': 'Openbaar bestuur',
  'lt.naceS.P': 'Onderwijs',
  'lt.naceS.Q': 'Gezondheid',
  'lt.naceS.R': 'Kunst/Amusement',
  'lt.naceS.S': 'Overige diensten',
  'lt.naceS.T': 'Priv. huishoudens',
  'lt.naceS.U': 'Extraterritoriaal',
  'lt.next.title': 'Volgende stappen',
  'lt.next.verifyContacts': 'Contactpersonen verifiëren',
  'lt.next.verifyingContacts': 'Contactpersonen verifiëren …',
  'lt.next.contactsVerified': '{n} contactpersonen geverifieerd',
  'lt.next.contactVerified': 'Contactpersoon geverifieerd',
  'lt.next.openPlan': 'Plan openen',
  'lt.next.generatingPlan': 'Acquisitieplan genereren …',
  'lt.next.credit': '1 credit',
  'lt.next.retry': 'Opnieuw proberen',
  'lt.next.verifyFirst': 'Verifieer eerst de contactpersonen',
  'lt.next.failedHint': 'Laatste poging mislukt: je kunt het opnieuw proberen.',
  'lt.profileLeads': 'Leads · {name}',
  'lt.profileSub': '{n} leads · alle queries van deze doelgroep komen hier binnen',
  'lt.profileSubOne': '1 lead · alle queries van deze doelgroep komen hier binnen',
  'lt.queryClear': 'Filter opheffen',
  'lt.queryLabel': 'Gefilterd op Query:',
  'lt.resetToast': 'Beoordeling voor {c} teruggezet',
  'lt.ring.match': 'Match {pct}%',
  'lt.ring.rejected': 'Afgewezen: geteld als 0',
  'lt.rm.cancel': 'Annuleren',
  'lt.rm.header': 'Lead verwerpen',
  'lt.rm.noteOptional': 'Notitie voor Leadscraper (optioneel)',
  'lt.rm.noteRequired': 'Gelieve kort te beschrijven (verplicht)',
  'lt.rm.placeholderOpt':
    'Wat heeft Leadscraper over het hoofd gezien of verkeerd beoordeeld? (Hoe concreter, hoe beter het systeem leert.)',
  'lt.rm.placeholderReq': 'Bijv. "Concurrent: verkopen vergelijkbare oplossing"',
  'lt.rm.sub': 'Vertel ons waarom: Leadscraper leert hiervan en levert volgende keer beter.',
  'lt.rm.submit': 'Lead verwerpen',
  'lt.rr.already_known': 'Kennen we al',
  'lt.rr.already_known.hint': 'Al in CRM of eerder gecontacteerd (geen leersignaal)',
  'lt.rr.bad_data': 'Verkeerde gegevens',
  'lt.rr.bad_data.hint': 'Adres, naam of contactinfo klopt niet',
  'lt.rr.no_buying_signal': 'Geen herkenbare behoefte',
  'lt.rr.no_buying_signal.hint':
    'Geen trigger-events, geen openstaande vacatures, geen groeisignaal',
  'lt.rr.not_operator': 'Geen operator',
  'lt.rr.not_operator.hint':
    'Bureau, tussenpersoon of projectontwikkelaar in plaats van operationele aanbieder',
  'lt.rr.other': 'Andere reden',
  'lt.rr.other.hint': 'Beschrijf hieronder kort waarom (vrije tekst)',
  'lt.rr.wrong_industry': 'Verkeerde sector',
  'lt.rr.wrong_industry.hint': 'Leadscraper heeft het bedrijfsgebied verkeerd ingeschat',
  'lt.rr.wrong_ownership': 'Verkeerde eigendomsstructuur',
  'lt.rr.wrong_ownership.hint':
    'Dochteronderneming in plaats van familiebedrijf, verkeerde rechtsvorm enz.',
  'lt.rr.wrong_region': 'Verkeerde locatie',
  'lt.rr.wrong_region.hint': 'Vestigingsplaats past niet bij de zoekopdracht',
  'lt.rr.wrong_role': 'Verkeerde contactpersoon',
  'lt.rr.wrong_role.hint': 'Persoon of rol is niet de beslisser',
  'lt.rr.wrong_size': 'Verkeerde bedrijfsgrootte',
  'lt.rr.wrong_size.hint': 'Te klein, te groot of concern in plaats van mkb',
  'lt.tip.accepted': 'Geaccepteerd: klik om op te heffen',
  'lt.tip.contacts': '{n} contactpersonen tonen',
  'lt.tip.dragCol': 'Kolombreedte slepen',
  'lt.tip.openCompany': 'Bedrijfsdetails openen',
  'lt.tip.openLead': 'Lead-details openen',
  'lt.tip.rejected': 'Verworpen: klik om op te heffen',
  'lt.tip.softKeep': 'Mogelijk relevant: Leadscraper heeft hier onzekerheid, zie details',
  'lt.tip.unseen': 'Nog niet bekeken',
  // AddCompanyManualModal — handmatig toevoegen via URL
  'lt.manual.modal.eyebrow': 'Pipeline · handmatig',
  'lt.manual.modal.title': 'Bedrijf toevoegen',
  'lt.manual.modal.desc':
    'Leadscraper verifieert de website en haalt basisgegevens van het bedrijf op. De lead komt daarna in {phase}, van waaruit je contactpersonen + een acquisitieplan kunt ophalen.',
  'lt.manual.modal.phase': '„Bedrijf toegevoegd"',
  'lt.manual.modal.websiteLabel': 'Website',
  'lt.manual.modal.placeholder': 'bijv. heuerlogistics.de',
  'lt.manual.modal.hint':
    'We proberen de website te bereiken. Bij een fout wordt geen credit gebruikt.',
  'lt.manual.modal.cancel': 'Annuleren',
  'lt.manual.modal.close': 'Sluiten',
  'lt.manual.modal.submit': 'Toevoegen',
  'lt.manual.modal.submitting': 'Toevoegen …',
  'lt.manual.modal.creditOne': '{n} credit',
  'lt.manual.modal.creditMany': '{n} credits',
  'lt.manual.modal.errEmpty': 'Voer een website in.',
  'lt.manual.modal.errInvalid': 'Dit lijkt geen geldige website (bijv. heuerlogistics.de).',

  'mem.cancel': 'Annuleren',
  'mem.editHint': 'Leadscraper gebruikt deze uitspraak vanaf de volgende sorteringsronde.',
  'mem.editKicker': 'Geleerde aanname corrigeren',
  'mem.editTitle': 'Hoe moet Leadscraper dit leren?',
  'mem.param.contact': 'Contactpersoon',
  'mem.param.extras': "Extra's",
  'mem.param.leads': 'Leads',
  'mem.param.location': 'Locatie',
  'mem.param.sector': 'Sector',
  'mem.profile': 'Profiel',
  'mem.save': 'Aanname opslaan',
  'mem.screenLabel': 'Memory',
  'mem.screenLabelEmpty': 'Memory · leeg',
  'mem.toast.confirmed': 'Aanname bevestigd.',
  'mem.toast.corrected': 'Correctie opgeslagen.',
  'mem.toast.forgotten': 'Aanname vergeten.',
  'mem.today': 'Vandaag',

  'mob.abo': 'Abonnement & Credits',
  'mob.acct.aria': 'Mijn account',
  'mob.active': 'Actief',
  'mob.back': '← Terug',
  'mob.changePassword': 'Wachtwoord wijzigen',
  'mob.changePlan': 'Plan wijzigen',
  'mob.detail.contacts': 'Contactpersonen ({n})',
  'mob.detail.fits': '✓ Past',
  'mob.detail.label.email': 'E-mail',
  'mob.detail.label.phone': 'Telefoon',
  'mob.detail.label.website': 'Website',
  'mob.detail.notFitting': '✗ Past niet',
  'mob.detail.rejected': '✗ Afgewezen',
  'mob.detail.section.company': 'Bedrijf',
  'mob.fb.fits': '✓ Past',
  'mob.fb.rejected': '✗ Afgewezen',
  'mob.home.activeProfile': 'Actieve doelgroep',
  'mob.home.cta.newSearch': 'Nieuwe zoekopdracht starten',
  'mob.home.emptyHint': 'Start een nieuwe zoekopdracht of wissel van doelgroep.',
  'mob.home.newLeads': 'Nieuwe Leads',
  'mob.home.stat.fits': 'Past',
  'mob.home.stat.leads': 'Leads',
  'mob.home.stat.matchRate': 'Match-rate',
  'mob.home.viewAll': 'Alle bekijken →',
  'mob.leads.cta.newSearch': 'Nieuwe zoekopdracht starten',
  'mob.leads.filter.all': 'Alle',
  'mob.leads.filter.fits': 'Past',
  'mob.leads.filter.open': 'Open',
  'mob.leads.filter.rejected': 'Afgewezen',
  'mob.leads.new': '＋ Nieuw',
  'mob.leads.title': 'Leads',
  'mob.logout': 'Uitloggen',
  'mob.logoutConfirm': 'Echt uitloggen?',
  'mob.more.help': 'Hulp & Contact',
  'mob.more.invoices': 'Facturen',
  'mob.more.label.email': 'E-mail',
  'mob.more.plan.monthly': 'Maandabonnement',
  'mob.more.plan.trial': 'Proefperiode',
  'mob.more.section.account': 'Mijn account',
  'mob.more.section.help': 'Hulp & App',
  'mob.more.title': 'Meer',
  'mob.more.toDesktop': 'Overschakelen naar desktop',
  'mob.more.toDesktop.value': 'Volledige functionaliteit',
  'mob.nav.account': 'Account',
  'mob.nav.home': 'Home',
  'mob.nav.leads': 'Leads',
  'mob.nav.profile': 'Doelgroepen',
  'mob.onDesktop': 'Op desktop',
  'mob.profile.active': 'Actief',
  'mob.profile.leadsCount': '{n} Leads',
  'mob.profile.newCount': '{n} nieuw',
  'mob.profile.stat.match': 'Match',
  'mob.profile.switchTo': 'Wisselen naar',
  'mob.profile.title': 'Doelgroepen',
  'mob.queryPlaceholder': 'bijv. bakkerijen, accountants, schoenenwinkels',
  'mob.search.askWho': 'Wie zoek je?',
  'mob.search.cancel': 'Annuleren',
  'mob.search.profileLabel': 'Doelgroep: {name}',
  'mob.search.region': 'Regio (optioneel)',
  'mob.search.regionPlaceholder': 'bijv. Noord-Holland, Amsterdam, Utrecht',
  'mob.search.start': 'Zoekopdracht starten',
  'mob.search.title': 'Nieuwe zoekopdracht',
  'mob.toast.accepted': '✓ Gemarkeerd als passend',
  'mob.toast.rejected': '✗ Afgewezen',
  'mob.toast.runStarted': 'Zoekopdracht gestart: komt over ~2 min',
  'mob.trialLeads': 'Test-Leads over',
  'mob.upgrade': 'Upgraden naar Pro',
  'mob.upgradeHint': 'Meer Leads + Planning',
  'mob.wizardHint':
    'Maak je eerste profiel aan op desktop: de wizard is nog niet beschikbaar op mobiel.',

  'mobile.empty.noContactData': 'Geen contactgegevens beschikbaar.',
  'mobile.empty.noOpenLeads': 'Geen openstaande Leads.',
  'mobile.empty.noProfileSelected': 'Geen doelgroep geselecteerd.',
  'mobile.empty.noProfileShort': 'Geen doelgroep.',
  'mobile.empty.nothingFound': 'Niets gevonden.',
  'mobile.note.label': 'Opmerking:',
  'mobile.note.scheduleDesktop': 'Planningen en doelgroep-geheugen bewerk je op desktop.',
  'mobile.tip.label': 'Tip:',
  'mobile.tip.profilesDesktop':
    'Meerdere doelgroepen (bijv. per sector of regio) maak je op desktop aan.',

  'ms.aud.computingBody':
    'Over enkele seconden beschrijft Leadscraper hier je doelgroep in eigen woorden.',
  'ms.aud.computingEyebrow': 'Leadscraper analyseert je beoordelingen',
  'ms.aud.computingTitle': 'Patroonherkenning loopt …',
  'ms.aud.derivedFrom': 'Afgeleid uit je {n} beoordelingen',
  'ms.aud.eyebrowS1': 'Eerste inschatting van Leadscraper',
  'ms.aud.eyebrowS2': 'Huidige inschatting van Leadscraper',
  'ms.aud.fallbackBody':
    'Zodra de heranalyse klaar is (over enkele seconden), verschijnt hier een concrete beschrijving van je doelgroep.',
  'ms.aud.fallbackEyebrow': 'Eerste inschatting van Leadscraper',
  'ms.aud.fallbackTitle':
    'Leadscraper werkt de inschatting momenteel bij met je laatste {n} beoordelingen.',
  'ms.aud.learnedLabel': 'Concreet geleerd',
  'ms.aud.lockedEyebrow': 'Doelgroep in Leadscraper-woorden',
  'ms.aud.lockedMock':
    'Je zoekt kleinere operators in NRW met actieve werving, directieniveau contacten, familiebedrijf met duidelijke focus op machinebouw.',
  'ms.aud.lockedPill': 'vanaf {n} beoordelingen',
  'ms.aud.nextReanalysis': ' · Volgende heranalyse bij {n}',
  'ms.aud.recomputeEyebrow': 'Leadscraper werkt je inschatting bij',
  'ms.aud.recomputeTitle':
    'Met je laatste beoordelingen wordt de inschatting opnieuw doorgerekend …',
  'ms.aud.trainS1':
    'Train de scraper verder en je krijgt **echt sterke resultaten**: elke beoordeling maakt Leadscraper preciezer.',
  'ms.aud.trainS2':
    'Train Leadscraper verder: **elke beoordeling scherpt de zoekopdrachten aan** die vanaf nu automatisch voor je draaien.',
  'ms.card.label': 'Leadscraper-status',
  'ms.card.ratings': '{n} / {threshold} beoordelingen',
  'ms.card.s2active': '{n} beoordelingen · actief in redenering',
  'ms.card.s2reanalysis': '{n} beoordelingen · wordt opnieuw geanalyseerd',
  'ms.cv.age': 'Bedrijfsleeftijd: {rule}',
  'ms.cv.bizModel': 'Bedrijfsmodel: {rule}',
  'ms.cv.buyingSignals': 'Koopsignalen: {rule}',
  'ms.cv.domainBlock': 'Uitsluiting: {rule}',
  'ms.cv.geo': 'Regio: {rule}',
  'ms.cv.industry': 'Sector: {rule}',
  'ms.cv.ownership': 'Eigendom: {rule}',
  'ms.cv.role': 'Contactpersoon: {rule}',
  'ms.cv.size': 'Grootte: {rule}',
  'ms.cv.techStack': 'Tech-stack: {rule}',
  'ms.donut.match': 'past',
  'ms.donut.matchRate': 'Trefpercentage',
  'ms.donut.noMatch': 'past niet',
  'ms.donut.ratings': 'Beoordelingen',
  'ms.donut.title': 'Beoordelingsstatus',
  'ms.error': 'Fout',
  'ms.msg.s0': 'Leert met je mee · {n}/{threshold} tot voorbeeld',
  'ms.msg.s1': 'Eerste indruk · {n}/{threshold} tot actief',
  'ms.msg.s2active': 'Actief gepersonaliseerd · {n} beoordelingen',
  'ms.msg.s2reanalysis': 'Wordt momenteel opnieuw geanalyseerd · {n}',
  'ms.stage0.eyebrow': 'Leert met je mee',
  'ms.stage1.eyebrow': 'Eerste indruk',
  'ms.stage2.eyebrow': 'Actief gepersonaliseerd',

  'nace.A': 'Land- en bosbouw, visserij',
  'nace.B': 'Winning van delfstoffen',
  'nace.C': 'Industrie',
  'nace.D': 'Productie en distributie van elektriciteit, gas, stoom en gekoelde lucht',
  'nace.E': 'Distributie van water; afval- en afvalwaterbeheer en sanering',
  'nace.F': 'Bouwnijverheid',
  'nace.G': "Groot- en detailhandel; reparatie van auto's en motorfietsen",
  'nace.H': 'Vervoer en opslag',
  'nace.I': 'Verschaffen van accommodatie en maaltijden',
  'nace.J': 'Informatie en communicatie',
  'nace.K': 'Financiële activiteiten en verzekeringen',
  'nace.L': 'Exploitatie van en handel in onroerend goed',
  'nace.M': 'Vrije beroepen en wetenschappelijke en technische activiteiten',
  'nace.N': 'Administratieve en ondersteunende dienstverlening',
  'nace.O': 'Openbaar bestuur en defensie; verplichte sociale verzekeringen',
  'nace.P': 'Onderwijs',
  'nace.Q': 'Menselijke gezondheidszorg en maatschappelijke dienstverlening',
  'nace.R': 'Kunst, amusement en recreatie',
  'nace.S': 'Overige dienstverlening',
  'nace.T': 'Huishoudens als werkgever',
  'nace.U': 'Extraterritoriale organisaties en lichamen',

  'naceShort.A': 'Land/Bos',
  'naceShort.B': 'Mijnbouw',
  'naceShort.C': 'Industrie',
  'naceShort.D': 'Energie',
  'naceShort.E': 'Water/Afval',
  'naceShort.F': 'Bouw',
  'naceShort.G': 'Handel',
  'naceShort.H': 'Vervoer/Opslag',
  'naceShort.I': 'Horeca',
  'naceShort.J': 'IT/Media',
  'naceShort.K': 'Financieel/Verz.',
  'naceShort.L': 'Vastgoed',
  'naceShort.M': 'Vrije beroepen',
  'naceShort.N': 'Overige diensten',
  'naceShort.O': 'Openb. bestuur',
  'naceShort.P': 'Onderwijs',
  'naceShort.Q': 'Zorgverlening',
  'naceShort.R': 'Kunst/Entertain.',
  'naceShort.S': 'Overige diensten',
  'naceShort.T': 'Priv. huishoudens',
  'naceShort.U': 'Extraterritoriaal',

  'nav.activeProfile': 'Actieve doelgroep',
  'nav.apiStatus.checking': 'API-status wordt gecontroleerd …',
  'nav.apiStatus.down': 'API niet bereikbaar: pagina herladen',
  'nav.apiStatus.ok': 'API bereikbaar',
  'nav.apiStatus.slow': 'API reageert traag',
  'nav.buyLeads': 'Leads nu kopen',
  'nav.cortex': 'Doelgroep',
  'nav.credits': 'Beschikbare Credits',
  'nav.credits.available': 'Beschikbaar',
  'nav.credits.label': 'Saldo',
  'nav.credits.remaining': 'Resterend',
  'nav.credits.total': 'Totaal',
  'nav.credits.upgrade': 'Upgrade',
  'nav.dashboard': 'Dashboard',
  'nav.deleteProfile': 'Doelgroep verwijderen',
  'nav.deleteProfileBody':
    'Alle leads, beoordelingen en geleerde patronen voor "{name}" worden permanent verwijderd. Deze actie kan niet ongedaan worden gemaakt.',
  'nav.deleteProfileBusy': 'Wordt verwijderd …',
  'nav.deleteProfileCta': 'Definitief verwijderen',
  'nav.deleteProfileError': 'Doelgroep kon niet worden verwijderd. Probeer het opnieuw.',
  'nav.deleteProfileInFlight':
    'Er loopt een zoekopdracht voor deze doelgroep. Wacht tot deze klaar is.',
  'nav.deleteProfileSuccess': 'Doelgroep verwijderd.',
  'nav.deleteProfileTitle': 'Doelgroep verwijderen?',
  'nav.feedbacks': 'Feedback',
  'nav.leads': 'Leads',
  'nav.matchRate': 'Trefpercentage',
  'nav.rated': 'beoordeeld',
  'nav.open': 'open',
  'nav.rateNudge.title': 'Ga naar de nog niet beoordeelde leads',
  'nav.allRated': 'Alles beoordeeld',
  'nav.newProfile': 'Nieuwe doelgroep aanmaken',
  'nav.onboardingRequired': 'Voltooi eerst de 3 onboarding-stappen.',
  'nav.openSettings': 'Instellingen & Learnings van "{name}" openen',
  'nav.profileName': 'Naam van de doelgroep',
  'nav.profileNameP': 'bijv. IT-Dienstverlener DACH',
  'nav.renameProfile': 'Doelgroep hernoemen',
  'nav.renameProfileSub': 'Kies een nieuwe naam voor deze doelgroep.',
  'nav.runs.footer': 'Klik op een doelgroep om de voortgang te zien. Je kunt verder werken.',
  'nav.runs.leadsReady': '{n} Lead{s} klaar',
  'nav.runs.many': '{n} zoekopdrachten lopen',
  'nav.runs.one': '1 zoekopdracht loopt',
  'nav.runs.title': 'Lopende zoekopdrachten',
  'nav.startSubscription': 'Abonnement starten',
  'nav.switchProfiles': 'Wisselen van doelgroep',

  'notif.act.edge': 'Grenscases bekijken',
  'notif.act.pattern': 'Bevestigen in Leadscraper',
  'notif.act.review': 'Naar de Leads',
  'notif.dismiss': 'Verbergen',
  'notif.edge.body':
    '{n} onzekere Leads bij {profile}: jouw oordeel verbetert Leadscraper het meest.',
  'notif.edge.title': 'Grenscases hebben je oordeel nodig',
  'notif.empty.sub': 'Leadscraper leert.',
  'notif.empty.title': 'Alles loopt goed.',
  'notif.kind.edge': 'Grenscase',
  'notif.kind.pattern': 'Patroon',
  'notif.kind.review': 'Review',
  'notif.pattern.back': 'Terug',
  'notif.pattern.badge': 'Geleerd patroon',
  'notif.pattern.confirmedLabel': 'Patroon bevestigd.',
  'notif.pattern.needsConfirm': 'Klopt dat?',
  'notif.pattern.no': 'Nee, afwijzen',
  'notif.pattern.rejectedLabel': 'Patroon afgewezen.',
  'notif.pattern.saveAndClose': 'Opslaan',
  'notif.pattern.stage2': 'Opgeslagen',
  'notif.pattern.title': 'Patroon herkend',
  'notif.pattern.whyLabel': 'Waarom? (optioneel)',
  'notif.pattern.whyPlaceholder': 'Helpt Leadscraper de nuance te leren, maar niet verplicht.',
  'notif.pattern.yes': 'Ja, klopt',
  'notif.review.body': 'Je hebt nog {n} onbeoordeelde Leads.',
  'notif.review.cta': 'Nu reviewen',
  'notif.review.title': 'Nieuwe Leads beoordelen',
  'notif.sub': 'Nudges, zodat Leadscraper preciezer wordt.',
  'notif.title': 'Meldingen',

  'np.abort': 'Annuleren',
  'np.audience': 'Doelgroep beschrijven',
  'np.audienceHint':
    'Hoe concreter, hoe beter de eerste sorteerrun. Je kunt dit later altijd aanpassen.',
  'np.audienceHintLong':
    'Schrijf het zoals je het aan een nieuwe verkoper zou uitleggen. Leadscraper gebruikt dit als basis voor de beoordeling, en leert bij uit elke feedback.',
  'np.audienceLabel': 'Doelgroepbeschrijving',
  'np.audienceP':
    'Voorbeeld: We willen middelgrote belastingadvieskantoren winnen voor onze recruiting-oplossing. Doel is een eerste gesprek met de directie.',
  'np.back': 'Terug',
  'np.briefingHelp.q1': 'Wat is je doel met deze doelgroep?',
  'np.briefingHelp.q2': 'Wat bied je aan?',
  'np.briefingHelp.q3': 'Waarom is jouw aanbod relevant voor deze doelgroep?',
  'np.briefingHelp.q4': 'Wat is je sterkste USP?',
  'np.briefingHelp.q5': 'Welke problemen los je op?',
  'np.briefingHelp.q6': 'Wie wil je als eerste benaderen?',
  'np.briefingHelp.q7': 'Welk kanaal werkt voor jou: e-mail, telefoon, LinkedIn?',
  'np.briefingHelp.q8': 'Wat moet de volgende stap zijn: antwoord, afspraak, demo, offerte?',
  'np.briefingHelp.q9': 'Wat moet vermeden worden in de benadering?',
  'np.briefingHelpFooter': 'Dit zijn geen verplichte velden, alleen hulp voor de vrije tekst.',
  'np.briefingHelpTitle': 'Handig voor Leadscraper',
  'np.coldStart': 'Koude start, geen seed-parameters',
  'np.coldStartDesc':
    'Het profiel start volledig leeg. Na ~20 feedbacks staan de eerste duidelijke uitspraken in Leadscraper.',
  'np.companySize': 'Bedrijfsgrootte',
  'np.companySizeP': 'bijv. 50–250 medewerkers',
  'np.continue': 'Verder',
  'np.create': 'Doelgroep aanmaken',
  'np.created': 'Doelgroep aangemaakt. Leadscraper is klaar.',
  'np.creating': 'Wordt aangemaakt …',
  'np.header': 'Nieuwe doelgroep',
  'np.headline': 'Doelgroep definiëren',
  'np.suggHeading': 'Suggesties voor je doelgroep',
  'np.suggHint':
    'Klikken past de suggestie toe. Je kunt wisselen, je eigen tekst typen of direct aanmaken.',
  'np.draftWriting': 'Leadscraper schrijft je briefing …',
  'np.draftErrorLabel': 'Opmerking:',
  'np.draftErrorFallback':
    'Het briefingconcept kon niet worden gegenereerd: je kunt handmatig verder schrijven.',
  'np.industry': 'Branche',
  'np.industryP': 'bijv. Verpakking, vouwdozen',
  'np.name': 'Naam van de doelgroep',
  'np.nameP': 'bijv. Vouwdoosproducenten NRW',
  'np.notes': 'Aanvullende opmerkingen',
  'np.notesP': 'Uitsluitingen, klanttypes, signaalwoorden …',
  'np.nothingYet': ': niets voorgedefinieerds. Leadscraper wordt gevormd door je feedback.',
  'np.optional': 'Optioneel',
  'np.region': 'Regio / provincie',
  'np.regionP': 'bijv. Noord-Holland, Nederland, heel Europa',
  'np.skip': 'Overslaan',
  'np.step1Sub':
    'Geef je profiel een duidelijke naam. Leadscraper gebruikt deze beschrijving als startpunt, voordat je feedback het patroon verfijnt.',
  'np.step1Title': 'Naar wie of wat ben je op zoek?',
  'np.step2Sub':
    'Optioneel: Leadscraper gebruikt deze informatie als basis. Het profiel leert bij zodra je leads beoordeelt.',
  'np.step2Title': 'Eerste parameters',
  'np.stepOf': 'Stap {n} van 2',
  'np.summaryTitle': 'Leadscraper start met',
  'np.title': 'Nieuwe doelgroep aanmaken',
  'np.whatHappens': 'Wat gebeurt er dan?',
  'np.whatHappensBody':
    'In het dashboard start je een <b>zoekopdracht</b> en kies je branche, regio en grootte. Leadscraper vindt passende bedrijven met contactpersonen en bouwt per lead een acquisitieplan op basis van deze briefing.',

  'offer.beta.pricing.intro': 'Beta-uitnodiging · 55 % korting op de eerste maand',

  'og.beta.cardCta': 'Beta-pakket activeren',
  'og.beta.cardFeature.1': '500 Leads / maand in Growth-omvang',
  'og.beta.cardFeature.2': 'Directe activering. Geen trial',
  'og.beta.cardFeature.3': 'Altijd opzegbaar met 1 klik',
  'og.beta.cardFoot': 'Kaart vereist · veilige betaling via Stripe',
  'og.beta.cardName': 'Je beta-pakket',
  'og.beta.feature.1.bold': '500 Leads',
  'og.beta.feature.1.lead': '',
  'og.beta.feature.1.tail': ' per maand, geverifieerde e-mails & telefoonnummers',
  'og.beta.feature.2': 'AI-targeting in natuurlijke taal',
  'og.beta.feature.3': 'CRM-integraties + CSV/Excel-export',
  'og.beta.feature.4': 'AVG-conform · Data in de EU',
  'og.beta.feature.5.bold': 'WhatsApp-toegang tot Janik',
  'og.beta.feature.5.lead': 'Directe ',
  'og.beta.feature.5.tail': ' bij vragen',
  'og.beta.narrativeBody':
    'We zoeken {profis} die ons systeem vroeg gebruiken, eerlijke feedback geven en meehelpen bepalen hoe Leadscraper zich ontwikkelt. In ruil betaal je {price} voor je eerste maand van ons Growth-pakket, in plaats van regulier 490 € — daarna geldt de reguliere prijs, altijd opzegbaar.',
  'og.beta.narrativePrice': 'slechts 220 €',
  'og.beta.narrativeProfis': '30 actieve verkoopprofessionals',
  'og.beta.narrativeTitle': 'Waarom dit aanbod?',
  'og.beta.priceNowSuffix': '/ eerste maand',
  'og.beta.priceFootnote': 'daarna {n} €/maand · altijd opzegbaar',
  'og.beta.priceOld': '{n} € / maand regulier',
  'og.beta.savings': 'Je bespaart {n} € in je eerste maand',
  'og.cancelAny': 'Altijd opzegbaar',
  'og.cta': '3 dagen gratis testen, {plan}',
  'og.ctaBeta': 'Beta-toegang veiligstellen, {price} € / maand',
  'og.ctaPlain': 'Verder met {plan}',
  'og.ctaSub':
    'Geen betaling in de eerste 3 dagen · Daarna {price},00 € / maand · {leads} test-Leads inbegrepen',
  'og.ctaSubPlain': '{price},00 € / maand · directe activering',
  'og.dsgvo': 'AVG-conform · Server NL',
  'og.eyebrow.beta': 'Persoonlijke beta-uitnodiging',
  'og.eyebrow.trial50': '50 Credits cadeau',
  'og.hlBanner.trial50.body':
    'Na plan-selectie krijg je direct {credits} op je account. Gebruik ze in de komende 3 dagen, als je niet opzegt, schakel je automatisch over naar het gekozen plan.',
  'og.hlBanner.trial50.credits': '{n} Credits',
  'og.hlBanner.trial50.title': 'Zo werkt je trial:',
  'og.later': 'Later beslissen →',
  'og.leadsIncl': '{n} Leads per maand inbegrepen',
  'og.maiOffer.cta': 'Mei-deal: 100 B2B Leads voor € 49 veiligstellen',
  'og.maiOffer.detail': 'Perfect om te proeven, zonder verplichtingen.',
  'og.maiOffer.feature.1': 'Geverifieerde e-mails & telefoonnummers',
  'og.maiOffer.feature.2': 'AI-targeting in natuurlijke taal',
  'og.maiOffer.feature.3': 'CRM-integraties + CSV/Excel-export',
  'og.maiOffer.feature.4': 'AVG-conform · Data in de EU',
  'og.maiOffer.feature.5': 'Vanaf maand 2: € 190/maand, opzegbaar met 1 klik',
  'og.maiOffer.leadsNum': '100',
  'og.maiOffer.leadsUnit': 'Leads / maand',
  'og.maiOffer.planName': 'Basic',
  'og.maiOffer.price': '€ 49',
  'og.maiOffer.priceNote': '€ 0,49 in plaats van € 1,90 per Lead, alleen deze maand.',
  'og.maiOffer.priceOriginal': 'In plaats van € 190 / maand',
  'og.maiOffer.priceSuffix': '/ maand',
  'og.moneyBack': '14-dagen-geld-terug',
  'og.perMonth': '€ / maand',
  'og.plan': 'Abonnement',
  'og.planBadge.recommended': 'Aanbevolen',
  'og.planCta.loading': 'Naar betaling …',
  'og.planCta.pick.basic': 'Basic kiezen',
  'og.planCta.pick.growth': 'Growth kiezen',
  'og.planCta.pick.starter': 'Starter kiezen',
  'og.planCta.trial.basic': '3 dagen gratis proberen',
  'og.planCta.trial.growth': '3 dagen gratis proberen',
  'og.planCta.trial.starter': '3 dagen gratis proberen',
  'og.planDetail.basic': 'Voor kleine verkoopteams die gericht opvolgen.',
  'og.planDetail.growth': 'Voor teams die outbound willen opschalen.',
  'og.planDetail.starter': 'Beste prijs-kwaliteitverhouding voor actieve teams.',
  'og.planFeature.basic.1': 'Geverifieerde e-mails & telefoonnummers',
  'og.planFeature.basic.2': 'AI-targeting in natuurlijke taal',
  'og.planFeature.basic.3': 'CRM-integraties + CSV/Excel-export',
  'og.planFeature.basic.4': 'AVG-conform · Data in de EU',
  'og.planFeature.growth.1': 'Alles van Starter',
  'og.planFeature.growth.2': '5× meer Leads per maand',
  'og.planFeature.growth.3': 'Persoonlijk onboarding gesprek',
  'og.planFeature.growth.4': 'Premium support direct met Janik',
  'og.planFeature.starter.1': 'Alles van Basic',
  'og.planFeature.starter.2': '2,5× meer Leads per maand',
  'og.planFeature.starter.3': 'Geprioriteerde Lead-queue',
  'og.planFeature.starter.4': 'E-mailsupport < 4 u',
  'og.planLeadsUnit': 'Leads / maand',
  'og.planPriceNote.basic.default': 'Komt neer op € 1,90 per Lead',
  'og.planPriceNote.basic.trial': 'Daarna {price}\u00A0€/maand · 100 Credits inbegrepen',
  'og.planPriceNote.growth.default': 'Komt neer op € 0,98 per Lead. Bespaar 48%',
  'og.planPriceNote.growth.trial':
    'Daarna {price}\u00A0€/maand · 500 Credits inbegrepen · Bespaar 48%',
  'og.planPriceNote.starter.default': 'Komt neer op € 1,16 per Lead. Bespaar 39%',
  'og.planPriceNote.starter.trial':
    'Daarna {price}\u00A0€/maand · 250 Credits inbegrepen · Bespaar 39%',
  'og.planPriceSuffix.default': '/ maand',
  'og.planPriceSuffix.trial': '/ maand na trial',
  'og.planPriceSuffix.trialToday': 'vandaag',
  'og.ready': 'Je account is klaar',
  'og.recommended': 'Aanbevolen',
  'og.split.badge.start': 'Perfect voor de start',
  'og.split.rating.note': '· Uitstekende gebruikersfeedback',
  'og.split.rating.score': '4.8 / 5.0',
  'og.split.trust.cancel': '1-klik opzegbaar',
  'og.split.trust.gdpr': 'AVG-conform',
  'og.step.activateBeta': 'Beta-pakket activeren',
  'og.step.created': 'Account aangemaakt',
  'og.step.pickPlan': 'Plan kiezen',
  'og.step.start': 'Aan de slag',
  'og.step.startTrial': '3 dagen gratis testen',
  'og.sub1': 'Kies je abonnement om Leadscraper',
  'og.sub1b': '3 dagen gratis te testen',
  'og.sub2': 'Geen betaling nu. Je kunt altijd tijdens de testperiode opzeggen.',
  'og.subtitle.beta':
    'Als beta-tester krijg je ons sterkste pakket (500 Leads per maand) voor een speciale prijs: je eerste maand kost 220 € in plaats van 490 €. Geen minimale looptijd, altijd opzegbaar.',
  'og.subtitle.default':
    'Drie plannen, dezelfde datakwaliteit. Kies hoeveel Leads je per maand nodig hebt: wisselen en opzeggen kan altijd met één klik.',
  'og.subtitle.mai':
    'In de eerste maand 74% besparen: daarna altijd met 1 klik wisselen of opzeggen.',
  'og.subtitle.trial50': '50 Leads cadeau, 3 dagen testen, altijd opzegbaar.',
  'og.title.beta.grad': 'handmatig geselecteerd',
  'og.title.beta.lead': 'Je bent ',
  'og.title.beta.tail': ' voor de beta.',
  'og.title.default.grad': 'start binnen 60 seconden',
  'og.title.default.lead': 'Kies je plan en ',
  'og.title.default.tail': '.',
  'og.title.mai.grad': 'oneerlijke concurrentievoordeel',
  'og.title.mai.lead': 'Je ',
  'og.title.mai.tail': ' begint hier.',
  'og.title.trial50.grad': 'nu cadeau',
  'og.title.trial50.lead': '50 B2B Leads ter waarde van € 100, ',
  'og.title.trial50.tail': '.',
  'og.trial': '3 dagen gratis testen',
  'og.trial50v2.cta': '50 Credits gratis veiligstellen',
  'og.trial50v2.detail': 'Genoeg Credits om Leadscraper volledig te testen.',
  'og.trial50v2.feature.1': 'Geverifieerde e-mails & telefoonnummers',
  'og.trial50v2.feature.2': 'AI-targeting in natuurlijke taal',
  'og.trial50v2.feature.3': 'CRM-integraties + CSV/Excel-export',
  'og.trial50v2.feature.4': 'AVG-conform · Data in de EU',
  'og.trial50v2.feature.5': 'Loopt door na 3 dagen, 1-klik opzegbaar',
  'og.trial50v2.leadsNum': '50',
  'og.trial50v2.leadsUnit': 'Leads in 3 dagen',
  'og.trial50v2.planName': 'Trial',
  'og.trial50v2.price': 'Gratis',
  'og.trial50v2.priceNote': 'Eindigt na 3 dagen of loopt door, 1-klik opzegbaar.',
  'og.trialIncl': 'incl.',
  'og.trialLeadsN': '{n} test-Leads',
  'og.trust.beta.lock.body': 'geen verborgen toeslagen',
  'og.trust.beta.lock.title': 'Beta-prijs in de eerste maand',
  'og.trust.cancel.body.default': 'Geen minimale looptijd',
  'og.trust.cancel.body.trial': 'Gratis tijdens trial',
  'og.trust.cancel.title.default': '1-klik opzegbaar',
  'og.trust.card.body.default': 'Veilige betaling via Stripe',
  'og.trust.card.body.trial': 'Pas na 3 dagen wordt afgeschreven',
  'og.trust.card.title.default': 'Kaart vereist',
  'og.trust.card.title.trial': 'Kaart voor activering',
  'og.trust.gdpr.body': 'Servers in de EU · alleen openbare bronnen',
  'og.trust.gdpr.title': 'AVG-conform',
  'og.welcome': 'Welkom, Janik.',

  'onb.step1Done': 'Leadscraper kent nu jouw aanbod: zie analyse hieronder',

  'onb.heroTitle': 'Jouw oneerlijke voorsprong begint hier',

  'onb.heroDesc':
    'In 3 stappen naar je eerste 10 leads. Leadscraper leert je echt kennen en levert je eindelijk leads die echt bij je passen.',

  'onb.helpCardTitle': 'Nieuw bij Leadscraper?',
  'onb.helpCardDesc':
    'Onze snelstartgids brengt je in een paar minuten van account en e-mail naar je eerste doelgroep.',
  'onb.helpCardCta': 'Lees de eerste stappen',
  'onb.helpCardDismissAria': 'Melding verbergen',

  'onb.stepLabel': 'Stap {n}',

  'onb.b2cLead': 'Leadscraper vindt alleen bedrijven, geen particuliere klanten.',

  'onb.b2cBody':
    'Uit je website-analyse blijkt dat je aan eindklanten verkoopt. De suggesties hieronder richten zich daarom op B2B-multiplicatoren (bijv. projectontwikkelaars, vastgoedbeheerders) in plaats van particulieren direct. Zonder passende B2B-laag is Leadscraper waarschijnlijk niet het juiste hulpmiddel voor je bedrijf.',

  'onb.step2LabelDone': 'Eerste doelgroep staat: Leadscraper heeft hem opgeslagen',

  'onb.step2LabelPending': 'Bepaal je eerste doelgroep: wie wil je precies als klant?',

  'onb.step2Cta': 'Doelgroep aanmaken',

  'onb.step2Badge': 'Nu aanmaken',

  'onb.step2Locked': 'Wacht op stap 1',

  'onb.step3Title': 'Eerste zoekopdracht',

  'onb.step3DescFull':
    'Zodra je eerste profiel klaar is, start je hier direct de zoekopdracht. Leadscraper vindt 10 leads in 30-90 seconden, precies de doelgroep die je net hebt aangemaakt.',

  'onb.step3Cta': 'Zoekopdracht starten',

  'onb.step3Badge': 'Nu starten',

  'onb.step3Locked': 'Wacht op stap 2',
  'onb.step1Pending':
    'Vertel Leadscraper kort over jezelf: een blik op je website is genoeg om te begrijpen wat je verkoopt',
  'onb.step2Desc':
    "Beschrijf je ideale klanten in 1-2 zinnen, bijv. 'Accountants in Noord-Holland, 3-15 medewerkers, directeuren'. Hieruit bouwt Leadscraper je zoekopdrachten, leert bij met elke feedback, en het profiel wordt wekelijks scherper.",
  'onb.step2Title': 'Maak je eerste doelgroep aan',
  'onb.step3Done': 'Eerste zoekopdracht loopt: Leadscraper levert je zo de eerste 10 Leads',
  'onb.step3Pending':
    'Zoekopdracht voor je doelgroep: Leadscraper levert 10 op maat gemaakte Leads',

  'pd.activeSince': 'Actief sinds {date}',
  'pd.company.analyze': 'Analyseren',
  'pd.company.analyzed': 'Leadscraper heeft je bedrijf geanalyseerd (Confidence {n}%).',
  'pd.company.analyzedAt': 'Geanalyseerd op {date}',
  'pd.company.analyzing': 'Analyseert...',
  'pd.company.cached': 'Profiel uit cache geladen.',
  'pd.company.cancel': 'Annuleren',
  'pd.company.change': 'Wijzigen',
  'pd.company.confidence': '{n}% zeker',
  'pd.company.costHint':
    'Kosten ~$0,015 per analyse. Re-analyse elke 30 dagen automatisch als je site wijzigt.',
  'pd.company.error': 'Analyse mislukt: probeer opnieuw.',
  'pd.company.inputDesc1':
    'Leadscraper leest jouw bedrijfspagina en onthoudt wat je verkoopt, aan wie je verkoopt, en welke argumenten je gebruikt. Bij elke Lead schrijft Leadscraper dan ',
  'pd.company.inputDesc2': ' in plaats van alleen "past bij de branche".',
  'pd.company.inputDescStrong': 'jouw op maat gemaakte pitch-strategie',
  'pd.company.inputTitle': 'Voer je eigen website in',
  'pd.company.knownTitle': 'Wat Leadscraper over je bedrijf weet',
  'pd.company.placeholder': 'https://mijn-bedrijf.nl',
  'pd.company.reanalyze': 'Nu re-analyseren',
  'pd.company.reanalyzing': 'Re-analyse…',
  'pd.company.sellLabel': 'Wat je verkoopt',
  'pd.company.staleAt': 'Re-analyse verschuldigd {date}',
  'pd.company.targetLabel': 'Aan wie',
  'pd.company.techDetails': 'Technische Details',
  'pd.company.valueLabel': 'Value-Props',
  'pd.cortex.comingSoon': 'binnenkort beschikbaar',
  'pd.cortex.sub': 'Waar Leadscraper het scherpst is in je targeting',
  'pd.cortex.title': 'Leadscraper-doelgroep',
  'pd.curve.coldSub': 'Cold',
  'pd.curve.currentRate': 'huidige trefferquote',
  'pd.curve.highPct':
    'Leadscraper raakt met {n}% zeer scherp: de leercurve tekent zich zodra verloopdgegevens over tijd binnenkomen. ',
  'pd.curve.highPctStrong': 'Alles volgens plan.',
  'pd.curve.inWeeks': 'in {n} weken',
  'pd.curve.learningActive': 'Leadscraper leert actief',
  'pd.curve.liftLabel': 'Verbetering sinds start',
  'pd.curve.liftSub': 'absoluut matchpercentage',
  'pd.curve.lockLabel': 'vanaf 50 beoordelingen',
  'pd.curve.lowPct':
    'Leadscraper verzamelt uit jouw {n} beoordelingen het verloop. Met meer gegevens wordt de trendlijn scherp.',
  'pd.curve.midPct':
    'Uit jouw {n} beoordelingen bouwt Leadscraper het verloop op: leercurve wordt met elke verdere run zichtbaarder.',
  'pd.curve.milestone200': '200 beoordelingen',
  'pd.curve.milestone200Sub': 'model gestabiliseerd',
  'pd.curve.milestone50': '50 beoordelingen',
  'pd.curve.milestone50Sub': 'eerste patronen',
  'pd.curve.mockAxisEnd': '50 beoordelingen',
  'pd.curve.mockTitle': 'Trefferquote over de laatste 50 beoordelingen',
  'pd.curve.noData': 'Nog te weinig gegevens.',
  'pd.curve.start': 'Start',
  'pd.curve.sub': 'Hoe het matchpercentage zich heeft ontwikkeld met elke beoordeling.',
  'pd.curve.subShort': 'Hoe de match rate zich ontwikkelt met elke beoordeling',
  'pd.curve.title': 'Leercurve',
  'pd.curve.today': 'Vandaag',
  'pd.curve.todaySub': '{n} beoordelingen',
  'pd.decisions.checked': '{n} kandidaten gecontroleerd',
  'pd.decisions.checkedSg': '{n} kandidaat gecontroleerd',
  'pd.decisions.delivered': '{n} geleverd',
  'pd.decisions.hint':
    'Zie je een patroon dat fout is? Herformuleer je query: Leadscraper neemt al deze beslissingen mee als leervoorbeeld voor de volgende run, zodra je het doelgroep-geheugen bevestigt.',
  'pd.decisions.more': '+ {n} meer ...',
  'pd.decisions.rejected': '{n} afgewezen',
  'pd.decisions.showAll': 'Alle afgewezenen tonen',
  'pd.decisions.showLess': 'Minder tonen',
  'pd.decisions.title': 'Leadscraper-beslissingen · laatste run',
  'pd.empty.cta': 'Naar dashboard',
  'pd.empty.desc1': 'Een doelgroep is ',
  'pd.empty.desc2':
    ': Leadscraper verzamelt hierin alle learnings uit je feedback. Maak je eerste doelgroep aan in het dashboard, daarna vind je hier alle patronen, aannames, afwijsredenen en runhistorie.',
  'pd.empty.descStrong': 'een leercontainer',
  'pd.empty.title': 'Nog geen doelgroep aangemaakt',
  'pd.hex.bizModel': 'Biz-model',
  'pd.hex.industry': 'Branche',
  'pd.hex.location': 'Locatie',
  'pd.hex.ownership': 'Eigendom',
  'pd.hex.role': 'Rol',
  'pd.hex.size': 'Grootte',
  'pd.leads.sub': 'Preview: de volledige lijst vind je in het Leads tabblad.',
  'pd.leads.title': 'Recente Leads',
  'pd.leads.viewAll': 'Alle bekijken',
  'pd.learn.calibratedHint': 'Leadscraper neemt jouw patronen nu actief mee in de redenering.',
  'pd.learn.coldStartHint':
    'Beoordeel meer Leads zodat Leadscraper jouw patronen begint te herkennen.',
  'pd.learn.earlyHint': 'Met elke verdere beoordeling wordt de patroonherkenning nauwkeuriger.',
  'pd.learn.emptyDesc1': 'Zodra je in de Lead-lijst op ',
  'pd.learn.emptyDesc2': ' of ',
  'pd.learn.emptyDesc3':
    ' klikt, leert Leadscraper jouw voorkeuren en toont hier wat het daaruit afleidt.',
  'pd.learn.emptyFit': 'geschikt',
  'pd.learn.emptyNotFit': 'niet geschikt',
  'pd.learn.emptyTitle': 'Nog geen feedback gegeven',
  'pd.learn.fits': 'Geschikt',
  'pd.learn.lastRating': 'Laatste beoordeling ',
  'pd.learn.loadError': 'Fout bij het laden',
  'pd.learn.loading': 'Feedback-leerstand laden...',
  'pd.learn.matchRate': 'Trefferquote',
  'pd.learn.matchRateSub': 'geschikt / beoordeeld',
  'pd.learn.matureMsg':
    'Profiel volledig gekalibreerd: Leadscraper behandelt jouw patronen bijna als regels.',
  'pd.learn.morePrefix': 'Nog ',
  'pd.learn.moreSuffix': ' beoordelingen tot niveau ',
  'pd.learn.narrativeHide': 'Brief aan de AI verbergen',
  'pd.learn.narrativeShow': 'Brief aan de AI tonen',
  'pd.learn.narrativeSub':
    'Precies deze tekst wordt bij de volgende run doorgegeven aan Leadscraper-AI, woordelijk.',
  'pd.learn.negative': 'negatief',
  'pd.learn.noData': 'Geen feedback-gegevens beschikbaar.',
  'pd.learn.noRating': 'Nog geen beoordeling',
  'pd.learn.notFits': 'Niet geschikt',
  'pd.learn.positive': 'positief',
  'pd.learn.rated': 'Beoordeeld',
  'pd.learn.ratingStatus': 'Beoordelings-status',
  'pd.learn.recentTitle': 'Recente beoordelingen',
  'pd.learn.stageCali': 'Gekalibreerd',
  'pd.learn.stageEarly': 'Lerend',
  'pd.learn.stageMature': 'Volwassen',
  'pd.learn.stageNext': 'volgende niveau',
  'pd.learn.topReasons': 'Meest voorkomende afwijzingsredenen',
  'pd.learn.topReasonsDesc1': 'Uit jouw ',
  'pd.learn.topReasonsDesc2':
    ' afwijzingen: Leadscraper onthoudt deze patronen en duwt vergelijkbare kandidaten bij de volgende run naar beneden.',
  'pd.learn.totalSub': '{n} totaal',
  'pd.openLeads': 'Leads openen',
  'pd.pat.actions': 'Acties',
  'pd.pat.confirm': 'Bevestigen',
  'pd.pat.confirmT': 'Bevestigen: als regel overnemen',
  'pd.pat.reject': 'Verwerpen',
  'pd.pat.rejectT': 'Verwerpen: patroon verwijderen',
  'pd.pat.remove': 'Verwijderen',
  'pd.pat.weaken': 'Verzwakken',
  'pd.patterns.medium': 'Gemiddeld: plausibel, wordt geobserveerd',
  'pd.patterns.strong': 'Sterk: betrouwbare regels',
  'pd.patterns.sub': 'Jouw voorkeuren, geëxtraheerd uit elke past / past niet beoordeling.',
  'pd.patterns.title': 'Wat Leadscraper heeft geleerd',
  'pd.patterns.weak': 'Zwak: vroege signalen',
  'pd.queries.dailyLegacy': 'Dagelijks (legacy)',
  'pd.queries.daysAgo': '{n} dagen geleden gestart',
  'pd.queries.emptySub':
    'Zodra je een zoekopdracht start, verschijnt deze hier, inclusief planning.',
  'pd.queries.emptyTitle': 'Nog geen zoekopdracht gestart voor deze doelgroep.',
  'pd.queries.everyH': 'Elke {n} u',
  'pd.queries.filterEmpty': "Geen query's in dit filter.",
  'pd.queries.hourly': 'Elk uur',
  'pd.queries.inDays': 'over {n} dagen',
  'pd.queries.inHours': 'over {n} u',
  'pd.queries.inMinutes': 'over {n} min.',
  'pd.queries.leadsDelivered': '{n} Leads geleverd',
  'pd.queries.manual': 'Eenmalig',
  'pd.queries.monthlyLegacy': 'Maandelijks (legacy)',
  'pd.queries.newSearch': 'Nieuwe zoekopdracht starten',
  'pd.queries.overdue': 'achterstallig',
  'pd.queries.paused': 'gepauzeerd',

  // W21/W22 Dossier — de doelgroeppagina als zelfschrijvend dossier
  // (Claude design handover 2026-07-03). Oppervlak 1: dossierkaart.
  'dos.eyebrow': 'Jouw doelgroep · geschreven door jou en Leadscraper',
  'dos.maturity.coldStart': 'Leert je kennen',
  'dos.maturity.early': 'Eerste beeld',
  'dos.maturity.calibrated': 'Gekalibreerd',
  'dos.maturity.mature': 'Volwassen',
  'dos.ratings': '{n} beoordelingen',
  'dos.matchRate': '{pct}% trefzekerheid',
  'dos.weak': 'zwak',
  'dos.edit.cta': 'Doelgroep bewerken',
  'dos.weave.youSearch': 'Je zoekt',
  'dos.weave.vorgabeLabel': 'Jouw opgave · uit je briefing',
  'dos.weave.withSize': 'met {size} medewerkers',
  'dos.weave.sizeValue': '{range} medewerkers',
  'dos.weave.inRegion': 'in {region}',
  'dos.weave.contact': 'contactpersoon',
  'dos.weave.prefers': 'bij voorkeur',
  'dos.weave.and': 'en',
  'dos.weave.weakHint': 'eerste aanwijzing:',
  'dos.legend.you': 'jouw opgave',
  'dos.legend.learned': 'geleerd: cijfer = bewijs, klikbaar',
  'dos.legend.weak': 'zwak (1–2 bewijzen)',
  'dos.emptyLearned':
    'Nog niets geleerd: beoordeel hieronder je eerste leads, dan schrijft dit dossier zichzelf verder.',
  'dos.heartbeat.active': 'Leert actief',
  'dos.heartbeat.waiting': 'Wacht op je eerste beoordelingen',
  'dos.heartbeat.since': 'sinds {date}',
  'dos.heartbeat.next': 'volgende analyse bij {n} beoordelingen',
  'dos.proof.title': 'Jouw {n} geaccepteerde bedrijven',
  'dos.proof.openAll': 'Alles bekijken in het board',
  'dos.error.learn': 'De leerdata is momenteel niet bereikbaar.',
  'dos.error.retry': 'Opnieuw laden',
  'dos.details.show': 'Alle {n} patronen in detail ↓',
  'dos.details.hide': 'Details verbergen',
  'dos.aside.patterns': 'Patronen in detail',
  'dos.kpi.title': 'Je doelgroep in cijfers',
  'dos.kpi.match': 'Trefkans',
  'dos.kpi.reachable': 'Bereikbaar',
  'dos.kpi.reachableSub': '{n} van {m} aanvragen',
  'dos.kpi.reachableTeaser': 'Na je eerste contactaanvraag',
  'dos.kpi.yield': 'Per zoekactie',
  'dos.kpi.yieldSub': '{n} zoekopdrachten',
  'dos.kpi.matchTeaser': 'vanaf {p} beoordelingen',
  'dos.journey.eyebrow': 'Zo ontstaat je dossier',
  'dos.journey.s1': 'Doelgroep beschreven',
  'dos.journey.s1Sub': 'Netjes vastgelegd: Leadscraper weet waarnaar het zoekt.',
  'dos.journey.s2': 'Ontvang je eerste leads',
  'dos.journey.s2Sub':
    'Start je eerste zoekopdracht: de eerste bedrijven staan er binnen enkele minuten.',
  'dos.journey.s2Done': '{n} leads staan klaar.',
  'dos.journey.s2Running': 'Je zoekopdracht loopt: de eerste bedrijven verschijnen hier zo.',
  'dos.journey.s2RunningBadge': 'Zoekopdracht loopt · meestal 5–12 min',
  'dos.journey.s3': 'Beoordeel je eerste {p} leads',
  'dos.journey.s3Progress': '{n} van {p} leads beoordeeld',
  'dos.journey.s3Sub':
    'Bij {p} beoordelingen schrijft Leadscraper hier zijn eerste inschatting: vanaf {a} stuurt je feedback elke zoekopdracht.',
  'dos.voice.preview':
    'Na je eerste {p} beoordelingen schrijft Leadscraper hier zijn inschatting van je doelgroep.',
  'dos.voice.more': 'Verder lezen',
  'dos.voice.less': 'Minder tonen',
  'dos.analysis.pending':
    'Leadscraper analyseert je {n} beoordelingen: de eerste inschatting verschijnt hier zo.',
  'dos.heartbeat.analysing': 'Analyseert je beoordelingen …',
  // Dossier — bewijs-popover
  'dos.popover.close': 'Sluiten',
  'dos.popover.evidence': '{n} bewijzen',
  'dos.popover.weakChip': 'zwak · {n} bewijzen',
  'dos.popover.view': 'bekijken ↗',
  'dos.popover.noExamples':
    'Voor dit patroon zijn geen losse bewijs-leads opgeslagen: het cijfer telt je beoordelingen.',
  'dos.popover.weakNote': 'Pas {n} bewijzen, telt nog voorzichtig mee in de zoekopdracht.',
  // Dossier — oppervlak 2: nu beoordelen
  'dos.rate.eyebrow': 'Nu beoordelen',
  'dos.rate.waiting': '{n} leads wachten op jouw oordeel',
  'dos.rate.waitingOne': '1 lead wacht op jouw oordeel',
  'dos.rate.openBoard': 'Alles openen in het board →',
  'dos.rate.sub':
    'Elke beoordeling scherpt het dossier aan, direct hier, zonder de pagina te verlaten.',
  'dos.rate.fits': 'Past bij mijn doelgroep',
  'dos.rate.fitsNot': 'Past niet',
  'dos.rate.view': 'bekijken',
  'dos.rate.acceptedCheck': '✓ Geaccepteerd',
  'dos.rate.learned': ', het dossier heeft geleerd:',
  'dos.rate.flowsIn': ', telt mee in de volgende analyse.',
  'dos.rate.undo': 'Ongedaan maken',
  'dos.rate.whyQuestion': 'Wat klopte er niet? Eén tik is genoeg: Leadscraper leert ervan.',
  'dos.rate.noReason': 'Doorgaan zonder reden',
  'dos.rate.allDone':
    'Alles beoordeeld: nieuwe leads verschijnen hier zodra een zoekopdracht ze levert.',
  'dos.rate.rejectedCheck': '✗ Uitgesorteerd',
  'dos.rate.avoidedLearned': ', het dossier vermijdt voortaan:',
  'dos.reason.industry': 'Verkeerde branche',
  'dos.reason.tooBig': 'Te groot',
  'dos.reason.tooSmall': 'Te klein',
  'dos.reason.region': 'Verkeerde regio',
  'dos.reason.role': 'Verkeerde rol',
  'dos.reason.other': 'Anders',
  // Dossier — oppervlak 3: volgende zoekopdrachten
  'dos.sug.eyebrow': 'Afgeleid van jouw patronen',
  'dos.sug.title': 'Jouw volgende zoekopdrachten',
  'dos.sug.basis.expansion': 'Uitbreiding',
  'dos.sug.basis.crossSell': 'Cross-sell',
  'dos.sug.basis.zoomOut': 'Uitzoomen',
  'dos.sug.basis.patternHint': 'Patroon-hint',
  'dos.sug.basis.salesFit': 'Sales-fit',
  'dos.sug.tier.veryStrong': 'zeer sterk',
  'dos.sug.tier.strong': 'sterk',
  'dos.sug.tier.solid': 'solide',
  'dos.sug.tier.hypothesis': 'zwak',
  'dos.sug.fitLabel': 'verwachte passing',
  'dos.sug.start': 'Zoekopdracht starten',
  'dos.sug.history': '{n} eerdere zoekopdrachten',
  'dos.sug.historyOne': '1 eerdere zoekopdracht',
  'dos.sug.showHistory': 'Geschiedenis bekijken →',

  'pd.queries.showAll': 'Alles tonen',
  'pd.queries.sub': 'Klik opent details, planning en geschiedenis van de zoekopdracht.',
  'pd.queries.title': 'Zoekqueries van deze doelgroep',
  'pd.queries.tomorrow': 'morgen',
  'pd.queries.unnamed': 'Naamloze zoekopdracht',
  'pd.queries.weeklyLegacy': 'Wekelijks (legacy)',
  'pd.ratings': '{n} beoordelingen',
  'pd.rej.agency_not_operator': 'Bureau i.p.v. exploitant',
  'pd.rej.consultant_not_operator': 'Consultant i.p.v. exploitant',
  'pd.rej.duplicate_previous_session': 'Al geleverd',
  'pd.rej.insufficient_data': 'Te weinig gegevens',
  'pd.rej.learned_rejection_pattern': 'Komt overeen met je afwijzingspatroon',
  'pd.rej.low_confidence': 'Te onzeker',
  'pd.rej.outside_radius': 'Buiten radius',
  'pd.rej.wrong_company_form': 'Verkeerde rechtsvorm',
  'pd.rej.wrong_industry': 'Verkeerde branche',
  'pd.rej.wrong_region': 'Verkeerde regio',
  'pd.rej.wrong_role': 'Verkeerde functie',
  'pd.rej.wrong_size': 'Verkeerde grootte',
  'pd.runs': '{n} zoekopdrachten',
  'pd.screenLabel': 'Doelgroepdetails',
  'pd.side.accepted': '({n} passend)',
  'pd.side.feedbacks': 'Beoordelingen',
  'pd.side.firstRun': 'Eerste run',
  'pd.side.focus': 'Zoekfocus',
  'pd.side.lastRun': 'Laatste run',
  'pd.side.lastRunLeads': '{n} Leads',
  'pd.side.leadsTotal': 'Leads totaal',
  'pd.side.matchMiss': 'Passend / Niet',
  'pd.side.matchRate': 'Matchpercentage',
  'pd.side.next1.d': 'Bij {pct}% matchpercentage lonen 50–100 nieuwe Leads zich.',
  'pd.side.next1.t': 'Zoekopdracht starten',
  'pd.side.next2.d': 'Zo leert Leadscraper sneller.',
  'pd.side.next2.t': 'Onbevestigde patronen controleren',
  'pd.side.next3.d': 'Hoe meer beoordelingen, hoe preciezer.',
  'pd.side.next3.t': 'Feedback blijven geven',
  'pd.side.patterns': 'Patronen',
  'pd.side.patternsSub': '{strong} sterk · {medium} gemiddeld',
  'pd.side.reasons': 'Veelvoorkomende afwijzingsredenen',
  'pd.side.recommended': 'Aanbevolen',
  'pd.side.snapshot': 'In één oogopslag',
  'pd.target.contacts': 'Contactpersonen',
  'pd.target.excluded': 'Uitgesloten',
  'pd.target.industry': 'Branche',
  'pd.target.leads': 'Leads',
  'pd.target.patterns': 'Patronen',
  'pd.target.queries': "Query's",
  'pd.target.region': 'Regio',
  'pd.target.size': 'Grootte',
  'pd.target.sub': 'Wat Leadscraper bij elke zoekopdracht als basis gebruikt.',
  'pd.target.title': 'Doelgroep',
  'pd.time.daysAgo': '{n} dagen geleden',
  'pd.time.hoursAgo': '{n} u geleden',
  'pd.time.justNow': 'zojuist',
  'pd.time.minsAgo': '{n} min geleden',
  'pd.toast.confirmed': 'Patroon bevestigd, wordt vanaf nu als betrouwbare regel toegepast',
  'pd.toast.rejected': 'Patroon verworpen',
  'pd.toast.removed': 'Patroon verwijderd',
  'pd.toast.weakened': 'Patroon verzwakt, wordt opnieuw geobserveerd',

  'price.afterThen': 'Daarna {price} / maand · altijd opzegbaar',
  'price.badge.popular': 'Populair',
  'price.badge.recommended': 'Aanbevolen',
  'price.badge.yourPlan': 'Jouw plan',
  'price.ctaStartTrial': '3 dagen gratis starten',
  'price.ctaSwitchPlan': 'Abo wijzigen',
  'price.ctaCurrentPlan': 'Huidig plan',
  'price.ctaTopUp': 'Nu opladen',
  'price.heroSub': 'Meer Leads, precies wanneer je ze nodig hebt.',
  'price.heroTrial': 'Je oneerlijke concurrentievoordeel begint hier.',
  'price.leads': 'Leads',
  'price.monthlyCancelable': 'maandelijks opzegbaar',
  'price.oneTime': 'eenmalig',
  'price.pack.1000.tag': 'Perfect voor de start',
  'price.pack.10000.tag': 'Voor continue leadgeneratie',
  'price.pack.5000.tag': 'Voor eerste geschaalde campagnes',
  'price.pack.50000.tag': 'Voor hoge volumes en teams',
  'price.perLead': '€ / Lead',
  'price.perMonth': '/maand',
  'price.perMonthLong': '/ maand',
  'price.plan.basic.f1': '100 gekwalificeerde Leads per maand',
  'price.plan.basic.f2': '1 actieve doelgroep',
  'price.plan.basic.f3': 'Leadscraper-AI met continu leren',
  'price.plan.basic.f4': 'CRM-integraties (HubSpot, Pipedrive, Salesforce …)',
  'price.plan.basic.f5': 'E-mail support',
  'price.plan.basic.tag': 'Om te starten met één doelgroep',
  'price.plan.growth.f1': '500 gekwalificeerde Leads per maand',
  'price.plan.growth.f2': 'Onbeperkt doelgroepen',
  'price.plan.growth.f3': 'Leadscraper-AI met team-Memory',
  'price.plan.growth.f4': 'Alle CRM-integraties + Webhooks',
  'price.plan.growth.f5': 'Toegewezen Account Manager',
  'price.plan.growth.f6': 'API-toegang',
  'price.plan.growth.tag': 'Voor scalerende verkoopteams',
  'price.plan.starter.f1': '250 gekwalificeerde Leads per maand',
  'price.plan.starter.f2': '3 actieve doelgroepen',
  'price.plan.starter.f3': 'Leadscraper-AI met geprioriteerd leren',
  'price.plan.starter.f4': 'Alle CRM-integraties',
  'price.plan.starter.f5': 'Geprioriteerde support',
  'price.plan.starter.f6': 'Export naar CSV, XLSX, JSON',
  'price.plan.starter.tag': 'Perfect voor de start',
  'price.selected': 'Gekozen:',
  'price.subOneoffDesc':
    'Extra Leads als eenmalig pakket, geen looptijd, geen verplichtingen. Credits vervallen niet.',
  'price.subTrialDesc':
    '3 dagen gratis testen: met echte Leads, je eigen profielen, je eigen Leadscraper-Memory. Onbruikbare Leads? Krijg je terug, zonder vragen.',
  'price.tab.afterSub': '(na abo)',
  'price.tab.lockNote': 'Beschikbaar na abo-start',
  'price.tab.oneoff': 'Eenmalige pakketten',
  'price.tab.sub': 'Abonnementen',
  'price.testLeads': 'Test-Leads',
  'price.then': 'daarna',
  'price.trial3days': '3 dagen gratis',
  'price.trialIncl': 'incl.',
  'price.trust.cancel.s': 'Maandelijks opzegbaar, geen verborgen kosten, geen minimale looptijd.',
  'price.trust.cancel.t': 'Altijd opzegbaar',
  'price.trust.gdpr.s': 'Alle data EU-gehost, versleuteld, geen doorgifte aan derden.',
  'price.trust.gdpr.t': 'AVG-conform',
  'price.trust.refund.s': 'Als een Lead niet past, krijg je de Credit direct terug.',
  'price.trust.refund.t': 'Onbruikbare Leads? Terug.',

  'pricing.beta.headline': 'Je Beta-toegang tot Leadscraper',
  'pricing.beta.subText':
    'Growth-plan met 55 % korting op de eerste maand, exclusief voor beta-testers.',
  'pricing.mai.headline': 'Je oneerlijke concurrentievoordeel begint hier.',
  'pricing.mai.subText':
    'In de eerste maand 74% besparen: daarna altijd met 1 klik wisselen of opzeggen.',
  'pricing.trial50.headline': '50 B2B Leads ter waarde van € 100. Nu cadeau.',
  'pricing.trial50.subText': '50 Leads cadeau, 3 dagen testen, altijd opzegbaar.',

  'reject.alreadyKnown': 'Kennen we al',
  'reject.alreadyKnown.hint':
    'Al in je CRM of eerder gecontacteerd, geen leersignaal en telt niet mee voor je matchpercentage.',
  'reject.badData': 'Verkeerde gegevens',
  'reject.badData.hint': 'Adres, naam of contactinfo klopt niet',
  'reject.noBuyingSignal': 'Geen herkenbare behoefte',
  'reject.noBuyingSignal.hint': 'Geen trigger-events, geen vacatures, geen groei-signaal',
  'reject.notOperator': 'Geen operator',
  'reject.notOperator.hint':
    'Bureau, bemiddelaar of projectontwikkelaar i.p.v. operationele aanbieder',
  'reject.other': 'Andere reden',
  'reject.other.hint': 'Schrijf hieronder kort waarom (vrije tekst)',
  'reject.wrongIndustry': 'Verkeerde sector',
  'reject.wrongIndustry.hint': 'Leadscraper heeft het bedrijfsveld verkeerd herkend',
  'reject.wrongOwnership': 'Verkeerde eigendomsstructuur',
  'reject.wrongOwnership.hint':
    'Dochteronderneming i.p.v. familiebedrijf, verkeerde rechtsvorm o.i.d.',
  'reject.wrongRegion': 'Verkeerde locatie',
  'reject.wrongRegion.hint': 'Vestigingsplaats/provincie past niet bij de zoekopdracht',
  'reject.wrongRole': 'Verkeerde contactpersoon',
  'reject.wrongRole.hint': 'Persoon of rol is niet de beslisser',
  'reject.wrongSize': 'Verkeerde bedrijfsgrootte',
  'reject.wrongSize.hint': 'Te klein, te groot of concern i.p.v. mkb',

  'rel.daysAgo': '{n} dagen geleden',
  'rel.hAgo': '{n} u geleden',
  'rel.minAgo': '{n} min geleden',
  'rel.now': 'zojuist',
  'rel.weeksAgo': '{n} weken geleden',
  'rel.yesterday': 'gisteren',

  'repeat.amountHint': 'Meer Leads = bredere dekking, minder Leads = hogere kwaliteit per Lead.',
  'repeat.amountLabel': 'Hoeveel Leads wil je?',
  'repeat.cancel': 'Annuleren',
  'repeat.paramsLabel': 'Parameters van deze run',
  'repeat.prediction.basedOn': 'gebaseerd op je huidige match rate',
  'repeat.prediction.credits': 'Credits',
  'repeat.prediction.matches': 'verwachte matches',
  'repeat.prediction.time': 'geschatte looptijd',
  'repeat.prediction.title': 'Verwacht resultaat',
  'repeat.preset': 'Suggesties',
  'repeat.start': 'Zoekrun starten',
  'repeat.sub': 'Parameters zijn vooraf ingevuld: pas ze aan of start direct opnieuw.',
  'repeat.title': 'Zoekrun herhalen',
  'repeat.toast': 'Zoekrun gestart: resultaten binnen enkele minuten.',

  'res.acceptedNote': 'Leadscraper leert uit deze acceptatie.',
  'res.breadcrumb': 'Zoekresultaten · {profile}',
  'res.cancel': 'Annuleren',
  'res.density.comfortable': 'Comfortabel',
  'res.density.compact': 'Compact',
  'res.employees': 'Medewerkers',
  'res.fb.all': 'Alle',
  'res.fb.new': 'Nieuw voor jou',
  'res.fb.status': 'Feedback-status',
  'res.filter': 'Filter',
  'res.fit': 'Past',
  'res.footer':
    'Leadscraper heeft nog {count} andere vermeldingen onderzocht. De hier getoonde zijn degenen die het beste passen bij je eerdere feedback.',
  'res.fromMem': 'uit jouw geheugen: "{text}"',
  'res.learning.body':
    'Nieuw signaal over de laatste twee weken: je accepteert bedrijven met eigen druk- of stantechniek vaker dan pure confectiebedrijven.',
  'res.learning.title': 'Wat Leadscraper nu leert',
  'res.location': 'Locatie',
  'res.new': 'Nieuw',
  'res.notFit': 'Past niet',
  'res.openDetails': 'Details openen →',
  'res.pickReason': 'Reden kiezen →',
  'res.reasonHint': 'Eén klik is genoeg: jouw reden verscherpt wat je morgen ziet.',
  'res.rejectedNote': 'Reden opgeslagen. Dit verscherpt jouw geheugen.',
  'res.sector': 'Sector',
  'res.summary':
    '{count} Leads uit 412 bekeken. Elk komt met een zin waarom hij bij je past: jouw "past / past niet" verscherpt wat je morgen ziet.',
  'res.title': 'Leads: {profile}',
  'res.toast.accepted': '"{company}" opgeslagen als Past. Leadscraper scherpt je doelgroep aan.',
  'res.toast.rejected': 'Reden "{reason}" opgeslagen. Vergelijkbare Leads komen minder vaak voor.',
  'res.uncertainty': 'Leadscraper is hier {score}: {text}.',
  'res.whyNotTitle': 'Waarom past deze Lead niet?',

  'run.complete': 'Zoekopdracht voltooid: {count} Leads geleverd.',
  'run.completeEmpty':
    'Zoekopdracht voltooid: geen passende bedrijven gevonden. Preciseer je doelgroep of probeer een andere regio.',
  'run.cta.broaden_query': 'Zoekopdracht breder formuleren',
  'run.cta.edit_query': 'Zoekopdracht aanpassen',
  'run.cta.retry': 'Opnieuw proberen',
  'run.failed.body':
    'Technische storing bij de laatste zoekopdracht. Wacht 1-2 minuten en probeer het opnieuw. Als het weer vastloopt, laat het ons weten.',
  'run.failed.title': 'Leadscraper is vastgelopen',
  'run.no_leads_delivered': 'Geen passende Leads geleverd',
  'run.no_results.body':
    'Je zoektermen leveren op Google geen passende Nederlandse B2B-bedrijven op. Probeer meer gangbare begrippen, bijv. "meubelmaker" in plaats van "meubelmanufactuur", of breid de regio uit.',
  'run.no_results.title': 'Voor je zoekopdracht zijn geen resultaten gevonden op het web',
  'run.partial_yield.body':
    'Leadscraper heeft minder dan 10 resultaten gevonden. Voor meer volume: beschrijving ruimer formuleren of bredere regio kiezen.',
  'run.partial_yield.title': '{delivered}/{total} Leads geleverd',
  'run.searching': '🧠 Leadscraper zoekt voor je…',
  'run.too_strict.body':
    'Leadscraper vond bedrijven, maar geen daarvan matcht je doelgroep goed. Misschien is je beschrijving te nauw: neem bijv. een grotere regio, verruim het aantal medewerkers of laat details weg.',
  'run.too_strict.title': '{reasoned} kandidaten getoetst: geen enkele paste bij je doelgroep',

  'runs.delivered': '{n} Leads geleverd',
  'runs.deliveredOne': '1 Lead geleverd',
  'runs.empty': 'Nog geen runs voor deze zoekopdracht.',
  'runs.evaluated': '{n} beoordeeld',
  'runs.failed': 'mislukt',
  'runs.harvested.body':
    'Eerdere zoekruns hebben al {n} passende bedrijven opgeleverd: Leadscraper kent deze resultaten al. Nieuwe resultaten ontstaan wanneer nieuwe bedrijven in je doelgroep online zichtbaar worden. De planning pikt ze automatisch op.',
  'runs.harvested.title': 'Doelgroep voorlopig uitgeput',
  'runs.last': 'laatste',
  'runs.loadError': 'Fout bij laden',
  'runs.loadFailed': 'Kon geschiedenis niet laden: {err}',
  'runs.loading': 'Geschiedenis laden…',
  'runs.noHits': 'geen hits',
  'runs.running': 'draait nu',
  'runs.unfeasible': 'niet uitvoerbaar',

  'sched.autoPush': 'Nieuwe Leads automatisch naar CRM pushen',
  'sched.autoPushNoCRM':
    'Je moet eerst een CRM verbinden in de accountinstellingen om auto-push te gebruiken.',
  'sched.autoPushSub':
    'Zodra Leadscraper een geplande run voltooit, worden alle gevonden Leads automatisch naar je verbonden CRM gestuurd.',
  'sched.daily': 'Dagelijks',
  'sched.dailySub': 'Elke dag op hetzelfde tijdstip',
  'sched.day.fri': 'Vrijdag',
  'sched.day.fri.short': 'Vr',
  'sched.day.mon': 'Maandag',
  'sched.day.mon.short': 'Ma',
  'sched.day.sat': 'Zaterdag',
  'sched.day.sat.short': 'Za',
  'sched.day.sun': 'Zondag',
  'sched.day.sun.short': 'Zo',
  'sched.day.thu': 'Donderdag',
  'sched.day.thu.short': 'Do',
  'sched.day.tue': 'Dinsdag',
  'sched.day.tue.short': 'Di',
  'sched.day.wed': 'Woensdag',
  'sched.day.wed.short': 'Wo',
  'sched.dayOfMonth': 'Dag van de maand',
  'sched.monthly': 'Maandelijks',
  'sched.monthlySub': 'Elke maand op de gekozen datum',
  'sched.nextRun': 'Volgende run',
  'sched.once': 'Eenmalig',
  'sched.onceSub': 'Nu eenmalig uitvoeren',
  'sched.rel.inDays': 'over {n} dagen',
  'sched.rel.overdue': 'achterstallig',
  'sched.rel.soon': 'binnenkort',
  'sched.rel.tomorrow': 'morgen',
  'sched.section': 'Herhaling',
  'sched.sectionSub': 'Laat Leadscraper deze zoekrun regelmatig automatisch uitvoeren.',
  'sched.time': 'Starttijd',
  'sched.toast.created': 'Geplande zoekrun aangemaakt: loopt automatisch verder.',
  'sched.toast.deleted': 'Geplande run verwijderd.',
  'sched.toast.paused': 'Geplande run gepauzeerd.',
  'sched.toast.resumed': 'Geplande run hervat.',
  'sched.weekday': 'Weekdag',
  'sched.weekly': 'Wekelijks',
  'sched.weeklySub': 'Elke week op de gekozen dag',

  'schedCard.creditsHint':
    'max. {n} Credits / dag, zodra er geen nieuwe Leads meer in je doelgroep worden gevonden, draait Leadscraper zonder verbruik leeg.',
  'schedCard.errorToast': 'Opslaan mislukt: {err}',
  'schedCard.freq.every': 'Elke {n} uur',
  'schedCard.freq.everyShort': 'elke {n} u',
  'schedCard.freq.hourly': 'Elk uur',
  'schedCard.freq.everyMinute': 'Elke minuut (test)',
  'schedCard.minuteTestHint':
    'Testmodus, draait ~elke minuut zodra de scheduler-tick loopt. Alleen staging.',
  'schedCard.freq.hourlyShort': 'elk uur',
  'schedCard.leadsPerDay': '~{n} Leads / dag',
  'schedCard.nextLabel': 'volgende run {when}',
  'schedCard.nextRun.days': 'over {n} dagen',
  'schedCard.nextRun.hours': 'over {n} u',
  'schedCard.nextRun.min': 'over {n} min.',
  'schedCard.nextRun.overdue': 'achterstallig',
  'schedCard.nextRun.tomorrow': 'morgen',
  'schedCard.noRepeat': 'Geen herhaling',
  'schedCard.offBody': 'Eenmalig: je start zelf wanneer je wilt.',
  'schedCard.onBody': 'Draait op de achtergrond. Nieuwe hits komen automatisch in je Leads-lijst.',
  'schedCard.perWeek': '≈ {n} / week',
  'schedCard.repeat': 'Deze zoekopdracht herhalen',
  'schedCard.save': 'Opslaan',
  'schedCard.savedToast': 'Planning opgeslagen.',
  'schedCard.saving': 'Opslaan…',

  'schedRuns.col.action': '',
  'schedRuns.col.crm': 'CRM-Push',
  'schedRuns.col.frequency': 'Frequentie',
  'schedRuns.col.leads': 'Leads/Run',
  'schedRuns.col.nextRun': 'Volgende run',
  'schedRuns.col.params': 'Parameters',
  'schedRuns.count': 'actief',
  'schedRuns.crm.no': 'Uit',
  'schedRuns.crm.yes': 'Actief',
  'schedRuns.delete': 'Verwijderen',
  'schedRuns.empty.sub':
    'Activeer "Herhaling" bij de volgende zoekrun om regelmatig nieuwe Leads te krijgen.',
  'schedRuns.empty.title': 'Nog geen geplande runs',
  'schedRuns.freq.daily': 'Dagelijks · {time}',
  'schedRuns.freq.monthly': '{day}e van de maand · {time}',
  'schedRuns.freq.weekly': '{day} · {time}',
  'schedRuns.pause': 'Pauzeren',
  'schedRuns.resume': 'Hervatten',
  'schedRuns.status.paused': 'Gepauzeerd',
  'schedRuns.sub': 'Terugkerende runs die automatisch nieuwe leads aan deze doelgroep toevoegen.',
  'schedRuns.title': 'Geplande zoekruns',

  'so.close.btn': 'Op de achtergrond laten doorlopen',
  'so.close.hint': 'Je kunt doorwerken: Leadscraper meldt zich wanneer nieuwe Leads gereed zijn.',
  'so.funnel.analyzed': 'Diepgaand geanalyseerd',
  'so.close.trust': 'Alleen openbare bronnen · elk gegeven wordt in de lead onderbouwd.',
  'so.funnel.evaluated': 'Beoordeeld',
  'so.funnel.identified': 'Geïdentificeerd',
  'so.funnel.ready': 'Gereed',
  'so.hero.elapsed': 'Tijd sinds start:',
  'so.hero.inFocus': 'Bedrijven in focus',
  'so.hero.preparing': 'Leadscraper controleert jouw verzoek',
  'so.hero.reflecting': 'Leadscraper bedenkt een nieuw plan',
  'so.hero.round': '(Ronde {n})',
  'so.hero.searching': 'Leadscraper zoekt voor jou',
  'so.live.title': 'Leadscraper werkt live',
  'so.query.title': 'Jouw zoekopdracht',
  'so.reflector.title': 'Leadscraper heeft de eerste aanpak verworpen',
  'so.step.delivery.sub': 'Top-matches worden voor jou gesorteerd + geleverd',
  'so.step.delivery.title': 'Leads samenstellen',
  'so.step.discovery.sub': 'Top-kandidaten uit Duitse webbronnen',
  'so.step.discovery.title': 'Bedrijven identificeren',
  'so.step.done.sub': 'Zoekopdracht voltooid',
  'so.step.done.title': 'Klaar',
  'so.step.enriching.sub': 'Acquisitieplan, scores + diepgaand onderzoek naar de 10 Leads',
  'so.step.enriching.title': 'Cortex verrijkt nog',
  'so.step.enriching.title.light': 'Basisgegevens verifiëren',
  'so.step.hydration.sub': 'Websites + Impressum + Carrière + Team + Nieuws',
  'so.step.hydration.title': 'Bedrijven diepgaand analyseren',
  'so.step.planning.sub': 'Jouw learnings analyseren + zoekstrategieën plannen',
  'so.step.planning.title': 'Leadscraper onthoudt',
  'so.step.reasoning.sub': 'Leadscraper toetst elke kandidaat aan je doelgroep',
  'so.step.reasoning.title': 'Leadscraper beoordeelt',

  'src.derived': 'Door Leadscraper',
  'src.directory': 'Directory',
  'src.news': 'Vakpers',
  'src.official': 'Officieel',
  'src.web': 'Bedrijfswebsite',

  'trial.afterNote': 'Daarna loopt je {plan}-abonnement automatisch door, altijd opzegbaar.',
  'trial.day1': 'Nog 1 dag',
  'trial.daysN': 'Nog {n} dagen',
  'trial.freeTest': 'gratis testen.',
  'trial.leadsLeft': '{left} / {total} test-Leads over',
  'trial.phase': 'Testfase',
  'trial.secureSub': 'Abonnement veiligstellen',
  // LEA-324: SEPA subscription "payment processing" banner.
  'bill.sepaProcessing.badge': 'Betaling wordt verwerkt',
  'bill.sepaProcessing.title': 'Je SEPA-betaling wordt verwerkt: je toegang is al vrijgegeven.',
  'bill.sepaProcessing.note':
    'De incasso kan 2–5 werkdagen duren. Je kunt Leadscraper nu al volledig gebruiken.',

  // ─── Transactional email — shared strings ────────────────────────────────
  // LEA-295: machine-translated from de.ts/en.ts. Informal "je" register to
  // match existing app strings. Native-speaker review pending before
  // production rollout (see staging-verification runbook).
  'email.shared.brand.name': 'Leadscraper',
  'email.shared.founder.name': 'Janik Deimann',
  'email.shared.founder.title': 'Oprichter, Leadscraper',
  'email.shared.reply_note': 'Vragen? Beantwoord gewoon deze e-mail.',
  'email.sepa-payment-failed.subject': 'Je SEPA-betaling is mislukt',
  'email.sepa-payment-failed.preheader': 'De incasso van {{amount_formatted}} is teruggeboekt.',
  'email.sepa-payment-failed.badge': 'Betaling mislukt',
  'email.sepa-payment-failed.hero': 'Je incasso<br>is teruggeboekt.',
  'email.sepa-payment-failed.greeting': 'Hallo {{first_name}},',
  'email.sepa-payment-failed.intro':
    'de SEPA-incasso voor je creditpakket is bij je bank niet gelukt.',
  'email.sepa-payment-failed.credits_line':
    'Daarom hebben we {{credits_revoked}} credits weer van je account afgehaald.',
  'email.sepa-payment-failed.retry_line':
    'Als je de credits nodig hebt, kun je het pakket gewoon opnieuw kopen in je account.',
  'email.sepa-payment-failed.button': 'Leadscraper openen',
  'email.sepa-payment-failed.detail.pack_label': 'Pakket',
  'email.sepa-payment-failed.detail.amount_label': 'Bedrag',
  'email.shared.footer.transactional':
    'Je ontvangt deze e-mail omdat je je hebt aangemeld voor een Leadscraper-account. Dit transactionele bericht maakt deel uit van de contractrelatie en kan niet worden afgemeld.',
  'email.shared.footer.legal':
    'Deimann Com GmbH &middot; Randstraße 75 &middot; 22525 Hamburg &middot; Duitsland<br />Bestuurder: Janik Deimann &middot; HRB 164162 (AG Hamburg) &middot; Btw-nr. DE332747716 &middot; © {{year}}',

  // ─── Transactional email — welcome ───────────────────────────────────────
  'email.welcome.subject': 'Welkom bij Leadscraper, {{first_name}} 👋',
  'email.welcome.title': 'Welkom bij Leadscraper',
  'email.welcome.preheader': 'Welkom aan boord: je eerste leads binnen 5 minuten.',
  'email.welcome.badge': 'Account klaar',
  'email.welcome.hero': 'Fijn dat je er bent,<br>{{first_name}}.',
  'email.welcome.subhead':
    'Je account is ingesteld en je eerste credits staan klaar: laten we beginnen.',
  'email.welcome.steps.title': 'Aan de slag in 5 stappen',
  'email.welcome.steps.1.title': 'Voeg je website toe',
  'email.welcome.steps.1.body':
    'Zodat de agent begrijpt waar je bedrijf naartoe gaat, en waar hij op moet letten.',
  'email.welcome.steps.2.title': 'Definieer je doelgroep',
  'email.welcome.steps.2.body':
    'Branche, regio, bedrijfsgrootte, functietitel: hoe specifieker, hoe beter de matches.',
  'email.welcome.steps.3.title': 'Start je eerste lead-zoekopdracht',
  'email.welcome.steps.3.body':
    'De agent onderzoekt, verrijkt en levert de eerste bedrijven direct in je dashboard.',
  'email.welcome.steps.4.title': 'Beoordeel de leads',
  'email.welcome.steps.4.body':
    'Duim omhoog of omlaag: de agent leert van elke beoordeling wat bij je past.',
  'email.welcome.steps.5.title': 'Start de volgende opdracht',
  'email.welcome.steps.5.body':
    'Bij elke ronde worden de resultaten merkbaar scherper, tot ze 100 % bij je passen.',
  'email.welcome.cta.primary': 'Naar het dashboard',
  'email.welcome.signoff.line': 'Vragen? Reageer gewoon op deze e-mail: ik lees mee.',

  // ─── Transactional email — subscription-cancelled ────────────────────────
  'email.subscription-cancelled.subject': 'Jammer dat je gaat, {{first_name}}: opzegging bevestigd',
  'email.subscription-cancelled.title': 'Je abonnement is opgezegd',
  'email.subscription-cancelled.preheader': 'We hebben je opzegging ontvangen.',
  'email.subscription-cancelled.badge': 'Opzegging bevestigd',
  'email.subscription-cancelled.hero': 'Jammer dat je gaat,<br>{{first_name}}.',
  'email.subscription-cancelled.subhead':
    'We hebben je opzegging ontvangen. Je toegang tot het {{plan_name}}-plan blijft actief tot {{access_until}}.',
  'email.subscription-cancelled.subhead_trial':
    'We hebben je opzegging ontvangen. Je proefperiode is beëindigd en er wordt niets afgeschreven.',
  'email.subscription-cancelled.note_trial':
    'Als je later toch verder wilt, kun je je abonnement in je account opnieuw activeren.',
  'email.subscription-cancelled.summary.plan_label': 'Plan',
  'email.subscription-cancelled.summary.until_label': 'Toegang tot',
  'email.subscription-cancelled.note':
    'Tot dan behoud je volledige toegang. Daarna worden je gegevens verwijderd volgens ons privacybeleid.',
  'email.subscription-cancelled.signoff.line':
    'Wat hadden we beter kunnen doen? Reageer gewoon op deze e-mail: ik lees mee.',
  'email.subscription-cancelled.cta.primary': 'Terug naar het product &amp; reactiveren',
  'email.subscription-cancelled.cta.note':
    'Je komt direct in het dashboard waar je je abonnement weer kunt activeren.',
  'email.subscription-cancelled.footer.transactional':
    'Je ontvangt deze e-mail als bevestiging van je opzegging. Dit transactionele bericht maakt deel uit van de contractrelatie en kan niet worden afgemeld.',

  // ─── Transactional email — payment-failed / dunning (LEA-304, AI-translated from DE master) ─────
  'email.payment-failed.subject': 'Je betaling is mislukt: werk je gegevens bij',
  'email.payment-failed.title': 'Betaling mislukt: werk je gegevens bij',
  'email.payment-failed.preheader':
    'We konden {{amount_formatted}} voor je {{plan_name}}-abonnement niet incasseren. Werk je betaalgegevens bij.',
  'email.payment-failed.badge': 'Betaling mislukt',
  'email.payment-failed.hero': 'Je betaling is niet gelukt, {{first_name}}.',
  'email.payment-failed.subhead':
    'We konden <strong style="color:#0B0F19;">{{amount_formatted}}</strong> voor je {{plan_name}}-abonnement niet incasseren. Werk je betaalgegevens bij om een onderbreking van je leads te voorkomen.',
  'email.payment-failed.summary.plan_label': 'Plan',
  'email.payment-failed.summary.amount_label': 'Openstaand bedrag',
  'email.payment-failed.summary.attempt_label': 'Poging',
  'email.payment-failed.summary.attempt_value': '{{attempt_count}} van 3',
  'email.payment-failed.summary.next_label': 'Volgende poging',
  'email.payment-failed.cta.primary': 'Betaalgegevens nu bijwerken',
  'email.payment-failed.reassurance':
    'Het kost je geen minuut, daarna gaat alles gewoon door. Vragen? Reageer gewoon op deze e-mail.',
  'email.payment-failed.footer.transactional':
    'Je ontvangt deze e-mail omdat een betaling voor je Leadscraper-abonnement is mislukt. Dit transactionele bericht maakt deel uit van de contractrelatie en kan niet worden afgemeld.',

  // ─── Transactional email — trial-ending-soon (LEA-295) ─────
  'email.trial-winback.subject': 'Als het alleen de angst voor de afschrijving was …',
  'email.trial-winback.badge': 'Je account staat er nog',
  'email.trial-winback.hero': '30% korting als je<br>verder wilt.',
  'email.trial-winback.preheader':
    'Kom terug — 30% korting voor 3 maanden, je account staat er nog.',
  'email.trial-winback.greeting': 'Hoi {{first_name}},',
  'email.trial-winback.intro':
    'je hebt je proefperiode gisteren meteen beëindigd — helemaal prima, daar is de knop voor. Maar als het alleen was om een ongewenste afschrijving te vermijden: je account staat er nog, met alles wat je hebt ingericht.',
  'email.trial-winback.offer':
    'Wil je verder: {{plan_name}} met 30% korting voor 3 maanden. Geen nieuwe formulieren — je kaart staat al geregistreerd.',
  'email.trial-winback.button': 'Aanbod bekijken & heractiveren',
  'email.trial-winback.transparency':
    'De klik schrijft niets af — je ziet eerst de prijs en de afschrijvingsdatum en bevestigt daarna zelf. Link: {{winback_url}}',
  'email.trial-winback.signoff': 'Janik',
  'email.trial-ending-soon.cancel_note':
    'Wil je niet verder? Zeg op met één klik, vóór de eerste afschrijving: {{cancel_link}}',
  'email.trial-ending-soon.cancel_link_label': 'Proefperiode opzeggen',
  'email.trial-ending-soon.subject': 'Je proefperiode loopt bijna af',
  'email.trial-ending-soon.preheader': 'Proefperiode eindigt {{trial_ends_at}}: kies nu een plan.',
  'email.trial-ending-soon.greeting': 'Hoi {{first_name}},',
  'email.trial-ending-soon.intro':
    'je {{plan_name}}-proefperiode eindigt op {{trial_ends_at}}. Je hebt nog {{credits_remaining}} credits.',
  'email.trial-ending-soon.why':
    'Zodra de proefperiode eindigt, wordt je account alleen-lezen: je kunt je eerdere leads blijven bekijken, maar nieuwe zoekopdrachten worden gepauzeerd.',
  'email.trial-ending-soon.cta':
    'Werken de resultaten voor je? Kies nu een plan zodat alles soepel doorloopt.',
  'email.trial-ending-soon.button': 'Kies een plan',
  'email.trial-ending-soon.signoff': 'Janik',

  // ─── Transactional email — trial-ended (LEA-295) ─────
  'email.trial-ended.subject': 'Je proefperiode is afgelopen',
  'email.trial-ended.badge': 'Proefperiode voorbij',
  'email.trial-ended.hero': 'Je proefperiode<br>is voorbij.',
  'email.trial-ended.preheader': 'Je proefperiode is afgelopen: account alleen-lezen.',
  'email.trial-ended.greeting': 'Hoi {{first_name}},',
  'email.trial-ended.intro':
    'je {{plan_name}}-proefperiode is net afgelopen. Je account is nu alleen-lezen: je ziet nog al je eerdere leads, maar nieuwe zoekopdrachten zijn gepauzeerd.',
  'email.trial-ended.cta':
    'Kies een plan om direct verder te gaan. Je gegevens en leergeheugen blijven behouden.',
  'email.trial-ended.button': 'Kies een plan',
  'email.trial-ended.signoff': 'Tot snel.<br>Janik',

  // ─── Transactional email — verify-email (LEA-295) ─────
  'email.verify-email.subject': 'Bevestig je e-mailadres',
  'email.verify-email.badge': 'Bijna klaar',
  'email.verify-email.hero': 'Bevestig je<br>e-mailadres.',
  'email.verify-email.preheader': 'Bevestig je e-mail om Leadscraper te activeren.',
  'email.verify-email.greeting': 'Hoi {{first_name}},',
  'email.verify-email.body':
    'klik op de knop hieronder om je e-mail te bevestigen en je Leadscraper-account te activeren.',
  'email.verify-email.button': 'E-mail bevestigen',
  'email.verify-email.fallback_note': 'Werkt de knop niet? Plak deze link in je browser:',
  'email.verify-email.ttl_note': 'De link verloopt over {{verify_expires_in}}.',
  'email.verify-email.ttl_default': '24 uur',
  'email.verify-email.ignore_note':
    'Heb je geen Leadscraper-account aangemaakt? Negeer deze e-mail dan gewoon.',

  // ─── Transactional email — refund-confirmation (LEA-295) ─────
  'email.refund-confirmation.subject': 'Terugbetaling bevestigd',
  'email.refund-confirmation.preheader': 'Terugbetaling: {{amount_formatted}}',
  'email.refund-confirmation.greeting': 'Hoi {{first_name}},',
  'email.refund-confirmation.intro': 'we hebben je {{amount_formatted}} terugbetaald.',
  'email.refund-confirmation.refunded_line':
    'Geboekt op {{refunded_at}} op je oorspronkelijke betaalmethode. Afhankelijk van de bank verschijnt het bedrag binnen 3-10 werkdagen.',
  'email.refund-confirmation.clawback_yes':
    'Omdat de terugbetaling de bijbehorende credits annuleert, zijn {{credits_clawed_back}} credits van je account afgeschreven.',
  'email.refund-confirmation.clawback_no': 'Je credits blijven ongemoeid.',
  'email.refund-confirmation.reason_line': 'Reden: {{reason}}.',
  'email.refund-confirmation.outro': 'Vragen? Reageer gewoon op deze e-mail.',
  'email.refund-confirmation.footer':
    'Je ontvangt deze e-mail omdat er een terugbetaling voor je Leadscraper-account is uitgevoerd.',

  // ─── Transactional email — password-reset ────────────────────────────────
  'email.password-reset.subject': 'Wachtwoord opnieuw instellen: link geldig voor {{expires_in}}',
  'email.password-reset.title': 'Wachtwoord opnieuw instellen',
  'email.password-reset.preheader':
    'Stel je wachtwoord veilig opnieuw in. De link vervalt over {{expires_in}}.',
  'email.password-reset.badge': 'Wachtwoord opnieuw instellen',
  'email.password-reset.hero': 'Nieuw wachtwoord<br>instellen.',
  'email.password-reset.body':
    'Iemand heeft gevraagd om je wachtwoord opnieuw in te stellen. Als jij dat was, klik dan gewoon op de knop. Zo niet, negeer deze e-mail: je wachtwoord blijft ongewijzigd.',
  'email.password-reset.expires': 'De link vervalt over {{expires_in}}.',
  'email.password-reset.cta.primary': 'Wachtwoord opnieuw instellen',
  'email.password-reset.signoff.line':
    'Vragen over accountbeveiliging? Reageer gewoon op deze e-mail.',
  'email.password-reset.footer.transactional':
    'Om veiligheidsredenen bevat deze e-mail informatie over het verzoek. Deel deze met niemand. Deze veiligheidsmelding maakt deel uit van de contractrelatie en kan niet worden afgemeld.',

  // ─── Transactional email — security-alert ────────────────────────────────
  'email.security-alert.subject': 'Beveiligingsmelding: {{event}}',
  'email.security-alert.title': 'Beveiligingsmelding',
  'email.security-alert.preheader':
    'Beveiligingsmelding: {{event}}. Als jij dat niet was, stel nu je wachtwoord opnieuw in.',
  'email.security-alert.badge': 'Beveiligingsmelding',
  'email.security-alert.hero': 'Er is iets veranderd op<br>je account.',
  'email.security-alert.subhead':
    'Hallo {{first_name}}, we hebben zojuist een beveiligingsrelevante actie gedetecteerd: <strong style="color:#0B0F19;">{{event}}</strong>. Als jij dat was, is alles in orde: je kunt deze e-mail negeren.',
  'email.security-alert.detail.time_label': 'Tijd (UTC)',
  'email.security-alert.detail.ip_label': 'IP-adres',
  'email.security-alert.detail.browser_label': 'Browser',
  'email.security-alert.warning.line':
    '<strong style="color:#881337;">Was jij dat niet?</strong> Stel onmiddellijk je wachtwoord opnieuw in en controleer je accountactiviteit.',
  'email.security-alert.cta.primary': 'Wachtwoord nu opnieuw instellen',
  'email.security-alert.signoff.line':
    'Vragen over accountbeveiliging? Reageer gewoon op deze e-mail: ik lees elk bericht.',
  'email.security-alert.footer.transactional':
    'Om veiligheidsredenen bevat deze e-mail informatie over de actie. Deel deze met niemand. Deze veiligheidsmelding maakt deel uit van onze servicevoorwaarden en kan niet worden afgemeld.',
  // LEA-295 bug-fix: see note in de.ts. Machine-translated, pending native review.
  'email.security-alert.event.password_reset': 'Wachtwoord opnieuw ingesteld',
  'email.security-alert.event.account_deletion_requested':
    'Accountverwijdering aangevraagd (30 dagen respijtperiode)',
  'email.security-alert.event.password_changed': 'Wachtwoord gewijzigd',
  'email.security-alert.firstname_fallback': 'daar',
  // ── Phase-Trigger-UI (Welle G66 i18n — Pricing-v2) ──
  'phase.creditOne': 'credit',
  'phase.creditMany': 'credits',
  'phase.retry': 'Opnieuw proberen',
  'phase.cancel': 'Annuleren',
  'phase.confirm': 'Bevestigen',
  'phase.running': 'Bezig …',
  'phase.btn.running': 'bezig …',
  'phase.unknownError': 'Onbekende fout',
  'phase.errorLabel': 'Fout:',
  'phase.gate.loadingConnect': 'Contactpersonen worden gezocht …',
  'phase.gate.loadingPitch': 'Volledige insights worden gegenereerd …',
  'phase.gate.loadingHint':
    'Dit duurt meestal 30-60 seconden. Je kunt de pagina verlaten: we laten het je weten zodra het klaar is.',
  'phase.gate.failConnect': 'Onderzoek mislukt',
  'phase.gate.failPitch': 'Genereren van insights mislukt',
  'phase.gate.failHint': 'Probeer het opnieuw: er worden geen extra credits in rekening gebracht.',
  'phase.connect.title': 'Contactpersonen & directe gegevens ontgrendelen',
  'phase.connect.desc':
    'We zoeken tot 3 beslissers met direct e-mailadres, direct telefoonnummer en LinkedIn-URL. Bronnen worden meegeleverd (AVG-audittrail).',
  'phase.connect.cta': 'Contactpersonen vinden',
  'phase.connect.runtime': 'Duur: ~30-60 seconden',
  'phase.pitch.title': 'Volledige insights & acquisitieplan ontgrendelen',
  'phase.pitch.desc':
    'Gepersonaliseerd acquisitieplan met 6 secties: wat het bedrijf doet, waarom juist deze lead, actualiteit (triggergebeurtenissen), klantreferenties, hooks voor je verkoopmail.',
  'phase.pitch.cta': 'Volledige insights genereren',
  'phase.pitch.runtime': 'Duur: ~20-40 seconden',
  'phase.locked.confirmQuestion': 'Bevestigen: {credits} afschrijven voor "{action}"?',
  'phase.deepen.title': 'Verdiep deze lead',
  'phase.deepen.descConnectDone':
    'Contactpersonen zijn geladen. Laad nu volledige insights voor het acquisitieplan + de tech stack.',
  'phase.deepen.descDefault':
    'Geïdentificeerd. Laad contactpersonen of ga direct naar volledige insights, afgerekend per klik.',
  'phase.deepen.pricingError':
    'Prijscatalogus kon niet worden geladen: terugvallen op standaardprijzen.',
  'phase.deepen.directPitch': 'Volledige insights direct laden (zonder contactpersonen)',
  'phase.btn.connect': '+ Contactpersonen vinden ({credits})',
  'phase.btn.pitch': '+ Volledige insights ({credits})',
  'phase.toast.connectLoading': 'Contactpersonen worden geladen.',
  'phase.toast.pitchLoading': 'Volledige insights worden geladen.',
  'phase.toast.noCredits': 'Geen credits meer. Vul aan of upgrade je abonnement.',
  'phase.toast.connectSoon': 'Contactzoeken komt binnenkort, wordt ontgrendeld met golf F2.2.',
  'phase.toast.pitchSoon': 'Volledige insights komen binnenkort, worden ontgrendeld met golf F2.3.',
  'phase.toast.error': 'Fout: {msg}',
  'phase.toast.unexpected': 'Onverwachte fout. Probeer het opnieuw.',
  'phase.dialog.connectTitle': 'Contactpersonen vinden?',
  'phase.dialog.pitchTitle': 'Volledige insights laden?',
  'phase.dialog.connectDesc':
    'We zoeken beslissers (e-mail, telefoon, LinkedIn) voor deze lead. Het resultaat is meestal binnen 1-2 minuten beschikbaar.',
  'phase.dialog.pitchDesc':
    'We genereren het acquisitieplan, de tech stack, triggerzinnen en Sparkle-velden voor deze lead. Het resultaat is meestal binnen 1-2 minuten beschikbaar.',
  'phase.dialog.close': 'Dialoogvenster sluiten',
  'phase.dialog.costNote':
    'Deze actie kost {credits}. Een verbruikte credit wordt niet automatisch terugbetaald.',
  'phase.dialog.confirmDeduct': 'Ja, {credits} afschrijven',
  // ── LeadDetail Rest-Strings (Welle G66.2 i18n) ──
  'det.src.impressum': 'Colofon',
  'det.src.handelsregister': 'Handelsregister',
  'det.src.subPage': 'Teampagina',
  'det.src.dorkEnrich': 'Webonderzoek',
  'det.src.geminiGrounding': 'AI-onderzoek',
  'det.confReason.deepResearchConfirmed': 'bevestigd via onderzoek',
  'det.confReason.handelsregisterOnly': 'alleen handelsregister',
  'det.confReason.nameMatch': 'naamovereenkomst',
  'det.confReason.multiSource': 'meerdere bronnen',
  'det.confReason.rankFallback': 'Discovery-ranking (dieponderzoek overgeslagen)',
  'det.confReason.rankFallbackLowConf': 'Discovery-ranking (dieponderzoek zonder resultaat)',
  'det.trust.authoritative': 'Geverifieerd uit een officiële bron (colofon/handelsregister)',
  'det.trust.semiAuth': 'Van de eigen bedrijfspagina (bijv. /team)',
  'det.trust.llm': 'Door AI uit website-inhoud gehaald',
  'det.trust.derived': 'Afgeleid uit andere gegevens (lage zekerheid)',
  'det.trust.sourceGeneric': 'Bron: {source}',
  'det.trust.confidence': 'betrouwbaarheid',
  'det.pReject.duplicate': 'Dubbel',
  'det.pReject.duplicateHint':
    'Persoon staat al in de lijst of naam komt niet overeen ("Werner Weber Kurt Richter")',
  'det.pReject.wrongRole': 'Verkeerde rol',
  'det.pReject.wrongRoleHint': 'Persoon heeft niet de beslissingsbevoegdheid die we zoeken',
  'det.pReject.inactive': 'Niet meer actief',
  'det.pReject.inactiveHint': 'Persoon is gewisseld, met pensioen, enz.',
  'det.pReject.wrongData': 'Onjuiste gegevens',
  'det.pReject.wrongDataHint': 'E-mail/telefoon onjuist of onbereikbaar',
  'det.pReject.betterContact': 'Andere persoon is beter',
  'det.pReject.betterContactHint': 'Er is een geschiktere contactpersoon bij dit bedrijf',
  'det.pReject.private': 'Niet benaderen',
  'det.pReject.privateHint': 'Wil deze persoon niet benaderen (geen learning)',
  'det.toast.personFeedbackRealOnly': 'Persoonsfeedback is alleen beschikbaar voor echte leads.',
  'det.toast.removeFailed': 'Verwijderen mislukt: probeer het opnieuw.',
  'det.toast.backendUnavailable': 'Backend niet beschikbaar: herlaad de app.',
  'det.toast.planRegenerating':
    'Acquisitieplan wordt opnieuw gegenereerd met de huidige briefing …',
  'det.toast.phaseAlreadyRunning': '{phase} loopt al, een moment geduld.',
  'det.available': 'beschikbaar',
  'det.unavailable': 'niet beschikbaar',
  'det.primary': 'Primair',
  'det.sourcePrefix': 'Bron:',
  'det.dataViaWebResearch': 'Gegevens via openbaar webonderzoek',
  'det.openLink': '{label} openen',
  'det.openLinkedin': 'LinkedIn-profiel van {name} openen',
  'det.openXing': 'XING-profiel van {name} openen',
  // ── LeadsTable Rest-Strings (Welle G66.3 i18n) ──
  'lt.trigErr.noContacts':
    'We konden geen contactpersonen vinden. Geen credit in rekening gebracht.',
  'lt.trigErr.insufficientCredits': 'Niet genoeg credits. Vul aan.',
  'lt.trigErr.phaseRunning': 'Deze fase loopt al, even wachten.',
  'lt.trigErr.phaseCompleted': 'Deze fase is al voltooid.',
  'lt.trigErr.triggerFailed': 'Activering mislukt: {msg}',
  'lt.cta.findContacts': 'Contactpersonen vinden · 1 credit',
  'lt.cta.createPlan': 'Acquisitieplan maken · 1 credit',
  'lt.cta.openOutreach': 'Wervingsbericht openen',
  'lt.verifyStuck': 'Verificatie hangt: herlaad de pagina en probeer opnieuw.',
  'lt.verifyFailed': 'Verificatie van contactpersonen mislukt.',
  'lt.planFailed': 'Het acquisitieplan kon niet worden aangemaakt.',
  'lt.softKeepAria': 'Mogelijk: klik voor details',
  'lt.manual.toast.backendUnavailable': 'Backend niet beschikbaar: probeer het later opnieuw.',
  'lt.manual.toast.added': '{name} toegevoegd',
  'lt.manual.toast.alreadyExists': '{name} bestaat al: ik open hem voor je.',
  'lt.manual.toast.switchProfile': 'Wissel eventueel van doelgroep: de lead staat mogelijk elders.',
  'lt.manual.toast.addFailed': 'Toevoegen mislukt.',
  'lt.manual.companyFallback': 'Bedrijf',
  // ── Dashboard Rest-Strings (Welle G66.4 i18n) ──
  'dash.cancel.requested': 'Annulering aangevraagd, wordt bij het volgende checkpoint van kracht.',
  'dash.cancel.failed': 'Annuleren mislukt',
  'dash.cancel.titleNoRun': 'Run-ID nog niet beschikbaar',
  'dash.cancel.titleCancel': 'Zoekrun annuleren',
  'dash.cancel.inFlight': 'Annuleren …',
  'dash.cancel.confirm': 'Echt annuleren?',
  'dash.refreshing': 'Vernieuwen …',
  'dash.run.noCredits': 'Geen credits: sluit een abonnement af.',
  'dash.run.startSub': 'Abonnement starten',
  'dash.sugg.region': 'Regio:',
  'dash.sugg.contact': 'Contactpersoon:',
  'dash.sugg.extra': 'Extra:',
  'dash.sugg.why': 'Waarom:',
  // ── Bestandskunden-Exclude (A1, 2026-06-02) ──
  'acct.exclude.title': 'Bestaande klanten uitsluiten',
  'acct.exclude.desc':
    'Voeg domeinen toe die je al kent (bijv. je CRM-export). Ze worden uit de resultaten van ALLE zoekopdrachten gefilterd: één domein per regel.',
  'acct.exclude.placeholder': 'bedrijf.nl\nvoorbeeld-bv.nl\nklant.com',
  'acct.exclude.count': '{n} domeinen uitgesloten van alle zoekopdrachten',
  'acct.exclude.save': 'Lijst opslaan',
  'acct.exclude.saved': 'Uitsluitingslijst opgeslagen ({n} domeinen)',
  // ── Agent-Chat / Cockpit (LEA-435 Wave B) ──
  'agent.nav': 'Assistent',
  'agent.tab.chat': 'Chat',
  'agent.tab.workspace': 'Werkruimte',
  'agent.boot': 'Moment — je assistent start op …',
  'agent.thinking': 'Denkt na …',
  'agent.turnError': 'Dat lukte net niet — probeer het zo nog een keer.',
  'agent.budgetExhausted':
    'Het chattegoed van je account is voor vandaag op. Morgen gaat het automatisch verder — je credits en leads blijven ongemoeid.',
  'agent.artifact.eyebrow': 'Doelgroep',
  'agent.artifact.draftBadge': 'Concept',
  'agent.artifact.createdBadge': 'Zojuist aangemaakt',
  'agent.artifact.industry': 'Branche',
  'agent.artifact.region': 'Regio',
  'agent.artifact.size': 'Grootte',
  'agent.artifact.exclusions': 'Uitsluitingen',
  'agent.artifact.any': 'maakt niet uit',
  'agent.bootError': 'De assistent is momenteel niet bereikbaar. Herlaad de pagina.',
  'agent.empty.title': '{greeting} — waarmee kan ik je helpen?',
  'agent.greet.morning': 'Goedemorgen',
  'agent.greet.day': 'Hallo',
  'agent.greet.evening': 'Goedenavond',
  'agent.empty.sub':
    'Beschrijf gewoon welke klanten je zoekt — ik bouw de zoekopdracht, vraag je goedkeuring en we bespreken de resultaten samen.',
  'agent.starter.find': 'Ik zoek nieuwe klanten — help me mijn doelgroep te bepalen',
  'agent.starter.describe': 'Analyseer mijn website en stel passende doelgroepen voor',
  'agent.starter.review': 'Laat mijn laatste leads zien en laten we ze doornemen',
  'agent.composer.placeholder': 'Bericht aan je assistent …',
  'agent.composer.send': 'Versturen',
  'agent.composer.stop': 'Stop',
  'agent.composer.hint': 'Enter om te versturen · Shift+Enter voor een nieuwe regel',
  'agent.scroll.end': 'Naar het einde',
  'agent.confirm.title': 'Goedkeuring: {action}',
  'agent.confirm.approve': 'Goedkeuren',
  'agent.confirm.deny': 'Afwijzen',
  'agent.tool.analyze': 'Website analyseren',
  'agent.tool.analyzeReference': 'Referentiesite bekijken',
  'agent.tool.draft': 'Doelgroep-concept',
  'agent.tool.createProfile': 'Profiel aanmaken',
  'agent.tool.startRun': 'Zoekopdracht starten',
  'agent.tool.runStatus': 'Zoekstatus',
  'agent.tool.listLeads': 'Leads laden',
  'agent.tool.getLead': 'Lead-details',
  'agent.tool.connect': 'Contactpersonen vinden',
  'agent.tool.pitch': 'Wervingsplan maken',
  'agent.tool.feedback': 'Feedback vastleggen',
  'agent.tool.credits': 'Creditsaldo',
  'agent.tool.exclude': 'Bedrijven uitsluiten',
  'agent.tool.cancelApproval': 'Goedkeuring intrekken',
  'agent.tool.cancelPlan': 'Zoekplan stoppen',
  'agent.support.open': 'Support',
  'agent.support.title': 'Supportchat openen — er antwoordt een mens',
  'agent.ws.title': 'Jouw doelgroepen',
  'agent.ws.new': 'Nieuw',
  'agent.ws.empty': 'Hier verschijnen de doelgroep-profielen die we samen in de chat aanmaken.',
  'agent.ws.openLeads': 'Leads bekijken',
  // Kopieren / Umbenennen / Datei-Anhang (LEA-435 Usability-Welle)
  'agent.msg.copy': 'Kopiëren',
  'agent.msg.copied': 'Gekopieerd',
  'agent.sessions.rename': 'Dubbelklik om te hernoemen',
  'agent.composer.attach': 'Klantenlijst toevoegen (CSV/XLSX)',
  'agent.attach.none': 'Geen bedrijfsdomeinen gevonden in het bestand.',
  'agent.attach.xlsxFailed': 'Kan het Excel-bestand niet lezen. Probeer een CSV-bestand.',
  'agent.attach.saved':
    'Ik heb mijn klantenlijst geüpload: {n} bedrijfsdomeinen zijn nu uitgesloten van alle toekomstige zoekopdrachten (bijv. {examples}).',
  'agent.attach.saveFailed':
    'Ik heb mijn klantenlijst geüpload ({n} bedrijfsdomeinen), maar het opslaan als uitsluitingslijst is mislukt.',
  // Session-Verlauf + Relativzeit (LEA-435 Multi-Session)
  'agent.sessions.new': 'Nieuwe chat',
  'agent.sessions.empty': 'Nog geen gesprekken.',
  'agent.sessions.untitled': 'Nieuw gesprek',
  'agent.sessions.delete': 'Verwijderen',
  // LEA-448
  'agent.sessions.deleteConfirm': 'Dit gesprek verwijderen? Dit kan niet ongedaan worden gemaakt.',
  'agent.artifact.radius': 'straal {n} km',
  'agent.leads.companyContactHint':
    'Bedrijfscontact uit het impressum — geen persoonlijke contactpersoon.',
  'agent.run.stalled': 'Duurt langer dan gewoonlijk…',
  'agent.run.interrupted': '{n} bedrijven geleverd — zoekopdracht eerder beëindigd',
  'agent.run.qualifierDown':
    'Onze kwalificatiestap was even niet beschikbaar — dat lag aan ons, niet aan je criteria. Een nieuwe zoekopdracht is de moeite waard.',
  'agent.run.recheck': 'Opnieuw controleren',
  // LEA-448 round-4
  'agent.cost.startRun':
    'tot {n} credits — alleen daadwerkelijk geleverde bedrijven tellen; afgewezen bedrijven worden nooit in rekening gebracht',
  'agent.cost.startRunRescue':
    'tweede poging na een mager resultaat — telt niet als extra zoekopdracht; zoals altijd worden alleen geleverde bedrijven in rekening gebracht (tot {n} credits)',
  'agent.cost.connect':
    '{n} credit — contactpersonen (naam, functie, e-mail, telefoon) voor dit bedrijf uit openbare bronnen',
  'agent.cost.pitch':
    '{n} credit — acquisitieplan (onderzoek + kant-en-klaar eerste bericht) voor dit bedrijf',
  // LEA-704: reveal-model pricing (Om QA 26.10.).
  'agent.cost.startRunReveal':
    'gratis — zoeken kost niets, je betaalt pas als je een contactpersoon ontgrendelt',
  'agent.cost.scheduleReveal':
    'gratis — elke zoekopdracht · {cadence} · pauzeert vanzelf na {k} zoekopdrachten op rij zonder nieuwe bedrijven of als je tegoed leeg is · je kunt hem altijd stoppen',
  'agent.cost.connectReveal':
    'gratis — contactpersonen worden opgezocht en zijn zichtbaar na het ontgrendelen',
  'agent.cost.pitchReveal': 'gratis — het acquisitieplan zit bij het ontgrendelen inbegrepen',
  'agent.cost.startRunPlan':
    '{runs} zoekopdrachten na elkaar, elk tot {per} credits — samen tot {n} credits voor tot {leads} bedrijven; alleen daadwerkelijk geleverde bedrijven tellen, het plan stopt na een mager resultaat',
  'agent.cost.connectBatch':
    'tot {n} credits — contactpersonen (naam, functie, e-mail, telefoon) voor {count} bedrijven uit openbare bronnen; een bedrijf zonder bereikbaar contact wordt niet in rekening gebracht',
  'agent.cost.pitchBatch':
    'tot {n} credits — acquisitieplannen (onderzoek + kant-en-klaar eerste bericht) voor {count} bedrijven',
  'agent.sessions.history': 'Geschiedenis',
  'agent.sessions.close': 'Sluiten',
  'agent.time.now': 'zojuist',
  'agent.time.min': '{n} min geleden',
  'agent.time.hour': '{n} u geleden',
  'agent.time.day': '{n} d geleden',
  // ── Live-Fortschrittskarte (LEA-435) ──
  'agent.run.running': 'Zoekopdracht loopt',
  'agent.run.finalizing': 'Laatste hand — bijna klaar …',
  'agent.run.preparing': 'Zoekopdracht wordt voorbereid …',
  'agent.run.done': 'Zoekopdracht voltooid',
  'agent.run.failed': 'Zoekopdracht mislukt',
  'agent.run.cancelled': 'Zoekopdracht geannuleerd',
  'agent.run.delivered': '{n} / {total} bedrijven geleverd',
  'agent.run.reviewCta': 'Leads bekijken',
  'agent.run.dismiss': 'Verbergen',
  'agent.run.step.planning': 'Planning',
  'agent.run.step.discovery': 'Ontdekking',
  'agent.run.step.hydration': 'Verrijking',
  'agent.run.step.reasoning': 'Beoordeling',
  'agent.run.step.delivery': 'Levering',
  'agent.run.won': '{n} verse leads voor je!',
  'agent.run.empty': 'Geen passende bedrijven gevonden',
  'agent.rescue.head.zero': 'Deze zoekopdracht heeft geen passende bedrijven gevonden.',
  'agent.rescue.head.lowOne':
    'Deze zoekopdracht heeft maar 1 passend bedrijf gevonden — dat kun je al bekijken.',
  'agent.rescue.head.low':
    'Deze zoekopdracht heeft maar {n} passende bedrijven gevonden — die kun je al bekijken.',
  'agent.rescue.cause.ours':
    'Dat lag aan ons, niet aan je doelgroep: de zoekopdracht is om technische redenen niet goed afgerond.',
  'agent.rescue.cause.oursQualifier':
    'Dat lag aan ons, niet aan je doelgroep: onze controlestap was tijdens de zoekopdracht niet bereikbaar, dus de gevonden bedrijven zijn niet beoordeeld.',
  'agent.rescue.cause.fewFound':
    'In het zoekgebied ({area}) hebben we maar weinig bedrijven gevonden die bij je beschrijving passen. Dat zegt meer over ons bereik daar dan over je markt.',
  'agent.rescue.cause.harvested':
    'De bedrijven die we vonden, ken je al: ze zijn je bij eerdere zoekopdrachten geleverd of staan op je lijst met bekende bedrijven.',
  'agent.rescue.cause.harvestedLow':
    'De andere bedrijven die we vonden, ken je al: ze zijn je bij eerdere zoekopdrachten geleverd of staan op je lijst met bekende bedrijven.',
  'agent.rescue.cause.tooBroad':
    'Je doelgroep noemt geen concrete branche. Zonder branche weet het onderzoek niet welke bedrijven het moet controleren.',
  'agent.rescue.cause.filtered':
    'We hebben bedrijven gevonden, maar geen enkel voldeed aan je criteria (branche, grootte of regio).',
  'agent.rescue.cause.filteredLow':
    'De andere bedrijven die we vonden, voldeden niet aan je criteria (branche, grootte of regio).',
  'agent.rescue.cause.unknown': 'We konden niet met zekerheid vaststellen waar het aan lag.',
  'agent.rescue.freeRule':
    'Mislukte zoekopdrachten kosten nooit iets: zonder geleverd bedrijf wordt niets in rekening gebracht. En de nieuwe poging telt niet als extra zoekopdracht.',
  'agent.rescue.pick': 'Mijn voorstel — één klik start de nieuwe zoekopdracht:',
  'agent.rescue.noOption.tooBroad':
    'Noem me een concrete branche of een vak, dan scherpen we de doelgroep samen aan.',
  'agent.rescue.noOption.wide':
    'Het zoekgebied is al zo ruim als zinvol is — een nieuwe poging met dezelfde criteria levert waarschijnlijk niets nieuws op.',
  'agent.rescue.thin.zero':
    'Ook de tweede poging heeft geen passende bedrijven opgeleverd. Dat wijst erop dat er voor deze combinatie maar heel weinig openbaar vindbare bedrijven zijn — een nieuwe poging met dezelfde criteria zou daar niets aan veranderen.',
  'agent.rescue.thin.low':
    'Ook de tweede poging heeft nauwelijks passende bedrijven opgeleverd ({n} geleverd). Dat wijst erop dat er voor deze combinatie maar weinig openbaar vindbare bedrijven zijn — een nieuwe poging met dezelfde criteria zou daar niets aan veranderen.',
  'agent.rescue.thin.next':
    'Een andere invalshoek is zinvoller — bijvoorbeeld een verwante branche of een andere regio.',
  'agent.rescue.opt.same': 'Dezelfde zoekopdracht opnieuw starten',
  'agent.rescue.opt.widen': 'Zoekgebied uitbreiden: {area} (in plaats van alleen {from})',
  'agent.rescue.opt.dach': 'Zoekgebied uitbreiden: Duitsland, Oostenrijk en Zwitserland',
  'agent.rescue.opt.dachFrom':
    'Zoekgebied uitbreiden: Duitsland, Oostenrijk en Zwitserland (in plaats van alleen {from})',
  'agent.rescue.opt.industry': 'Opnieuw zoeken met branche ‘{industry}’',
  'agent.rescue.chip.market': 'Laten we ‘{market}’ als doelgroep proberen',
  'agent.rescue.chip.rethink': 'Help me de doelgroep opnieuw te bedenken',
  'agent.rescue.unavailable': 'Deze tweede poging is niet meer beschikbaar',
  'agent.rescue.card.note':
    'Telt niet als extra zoekopdracht — zoals altijd worden alleen geleverde bedrijven in rekening gebracht',
  'agent.rescue.card.noteFree': 'Gratis tweede poging — telt niet als extra zoekopdracht',
  'agent.rescue.oursRetryLater':
    'Probeer het over een paar minuten opnieuw — niet geleverde bedrijven worden nooit in rekening gebracht.',
  'agent.rescue.card.used': 'Gestart',
  'agent.rescue.card.aria': 'Voorstellen voor een tweede poging',
  'agent.rescue.preparing': 'Ik kijk waar het aan lag …',
  // ── Momentum-Leiste (LEA-435) ──
  'agent.momentum.label': 'Je momentum',
  'agent.momentum.audiences': 'Doelgroepen',
  'agent.momentum.searches': 'Zoekopdrachten',
  'agent.momentum.leads': 'Leads',
  'agent.momentum.contacts': 'Contacten',
  'agent.momentum.pitches': 'Outreach',
  // ── Lead-Bewert-Deck (LEA-435) ──
  'agent.leads.title': 'Jouw leads — welke passen?',
  'agent.leads.rated': '{done}/{total} beoordeeld',
  'agent.leads.accept': 'Past',
  'agent.leads.reject': 'Past niet',
  'agent.leads.accepted': 'Past',
  'agent.leads.rejected': 'Past niet',
  'agent.leads.contacts': '{n} contacten',
  'agent.leads.openAll': 'Alles in detail bekijken',
  'agent.leads.done': 'Sterk — allemaal beoordeeld! Dat verscherpt je volgende zoekopdracht.',
  'agent.leads.chainConnect': '→ Vind de beslissers voor je resultaten ({n})',
  'agent.leads.chainMsg': 'Zoek de contactpersonen voor: {names}. (leadIds: {ids})',
  // ── Erfolgs-Puls (LEA-435) ──
  'agent.pulse.hitRate': 'Trefferpercentage {pct}%',
  'agent.pulse.rising': 'stijgt',
  'agent.pulse.detail': '{accepted} van {rated} leads passen · {profiles} doelgroepen',
  'agent.pulse.nudge':
    'Beoordeel je leads met 👍/👎 — dan leer ik je trefferpercentage en word ik met elke zoekopdracht beter.',
  // ── Aktions-Chips (LEA-435) ──
  'agent.chip.confirmDraft': 'Ja, zo aanmaken',
  'agent.chip.adjustDraft': 'Doelgroep aanpassen',
  'agent.chip.startRun': 'Zoekopdracht starten',
  'agent.chip.reviewLeads': 'Leads bekijken',
  'agent.chip.msg.confirmDraft': 'Ja, maak het profiel precies zo aan.',
  'agent.chip.msg.adjustDraft': 'Ik wil de doelgroep nog aanpassen.',
  'agent.chip.msg.startRun': 'Start nu de zoekopdracht voor dit profiel.',
  'agent.chip.msg.startRunNamed': 'Start nu de zoekopdracht voor de doelgroep "{name}".',
  'agent.chip.msg.reviewLeads': 'Laten we de geleverde leads doornemen.',
  // ── Editierbare Firmen-Karte (#122, 2026-06-02) ──
  'common.remove': 'Verwijderen',
  'dash.cortex.editHint':
    'Verwijder chips met × of voeg passende toe: zo sluit Leadscraper beter aan op je aanbod (max. 8 per kolom).',
  'dash.cortex.descLabel': 'Beschrijving',
  'dash.cortex.changeUrl': 'Andere website analyseren',
  'dash.cortex.editSaved': 'Bedrijfsprofiel bijgewerkt',
  'dash.cortex.addPlaceholder': 'toevoegen…',
  'dash.cortex.capReached': 'Max. 8 bereikt',
  'pd.target.edit': 'Opnieuw beschrijven',
  'pd.target.editHint':
    'Beschrijf je ideale klanten in 1–2 zinnen. Leadscraper leidt branche, regio en contactpersoon opnieuw af.',
  'pd.target.editPlaceholder':
    'bijv. verpakkingsfabrikanten, landelijk, 50–250 medewerkers, directie',
  'pd.target.reparsing': 'Leadscraper denkt na …',
  'pd.target.saved': 'Doelgroep bijgewerkt',
  'pd.target.saveError': 'Bijwerken mislukt: probeer opnieuw.',
  'common.close': 'Sluiten',
  'common.selected': 'Geselecteerd',
  'credit.balanceTitle': 'Je creditsaldo',
  'credit.available': 'beschikbaar',
  'det.trigger.cat.serviceRadius': 'Servicegebied',
  'det.trigger.cat.specialization': 'Specialisatie',
  'det.trigger.cat.capacity': 'Capaciteit',
  'det.trigger.cat.history': 'Geschiedenis',
  'det.trigger.cat.partnership': 'Partnerschap',
  'det.trigger.cat.certification': 'Certificering',
  'det.trigger.cat.other': 'Overig',
  'lead.removeContactTitle': 'Waarom verwijderen?',
  'lead.actionNeedPlan': 'Genereer eerst een acquisitieplan',
  'lead.actionNoEmail': 'Geen e-mailadres voor de geprioriteerde contactpersoon',
  // scraper run experience + API errors (LEA-302) — see de.ts for context
  'scraper.act.loadProfile': 'Laad je profiel + eerdere beoordelingen …',
  'scraper.act.firstFeedbacks':
    'Eerste beoordelingen verzamelen: vanaf 10 leert Cortex je afkeur-/acceptatiepatronen.',
  'scraper.act.feedbacksCollected':
    '{seen} beoordelingen verzameld: Personalisatie wordt actief vanaf {activeAt} beoordelingen per profiel. Deze run loopt nog zonder patroon-overschrijving.',
  'scraper.act.patternsActive':
    '{seen} beoordelingen · {accepted} acceptatiepatronen · {rejected} afwijzingspatronen actief in de redenering',
  'scraper.act.planning':
    'Plan zoekstrategie: welke zoekbronnen + zoekopdrachten dekken je verzoek het beste af?',
  'scraper.act.aiSearchTempError':
    'AI-zoeken had een tijdelijk probleem (netwerk/timeout). Probeer opnieuw.',
  'scraper.act.aiSearchUnavailable':
    'AI-zoeken momenteel niet beschikbaar (configuratieprobleem). Neem contact op met support.',
  'scraper.act.aiSearchBadFormat': 'AI-zoeken leverde ongeldig formaat. Probeer opnieuw.',
  'scraper.act.aiSearchFailed': 'AI-zoeken mislukt ({reason}). Probeer opnieuw.',
  'scraper.act.reasonUnknown': 'onbekend',
  'scraper.act.researcherAnalyzing': 'AI-Researcher analyseert je zoekopdracht…',
  'scraper.act.researcherFound': 'AI-Researcher: {n} geverifieerde bedrijven geïdentificeerd',
  'scraper.act.goal': 'Doel: {goal}',
  'scraper.act.strategy': 'Strategie: {strategy}',
  'scraper.act.reasoning': 'Redenering: {reasoning}',
  'scraper.act.srcCurated': '⭐ Gecureerde bron',
  'scraper.act.srcOwn': '💡 Eigen voorstel',
  'scraper.act.srcKindRegister': 'Register',
  'scraper.act.srcKindDirectory': 'Gids',
  'scraper.act.srcKindPortal': 'Portaal',
  'scraper.act.source': '{tag}: {label} [{kind}]',
  'scraper.act.googleSearch': 'Google-zoekopdracht: "{q}"',
  'scraper.act.googleMaps': 'Google Maps: "{q}"{location}',
  'scraper.act.googleNews': 'Google News: "{q}"',
  'scraper.act.researcherEnough':
    'AI-Researcher heeft genoeg ({n} bedrijven): sla aanvullende Google-zoekopdrachten over',
  'scraper.act.researcherIdentified':
    'AI-Researcher identificeerde {n} bedrijven: sla Google-zoekopdrachten over',
  'scraper.act.researcherNone':
    'AI-Researcher vond geen passende bedrijven: zoekopdracht is zeer niche. Probeer een breder profiel of minder specifieke regio.',
  'scraper.act.companyIdentified': 'Bedrijf geïdentificeerd: {name} ({i}/{total})',
  'scraper.act.enrichBasics':
    'Verrijk {n} bedrijven met basisgegevens (adres, grootte, tech-stack)...',
  'scraper.act.enrichCompany': 'Verrijk bedrijf {idx}/{total}: {domain}',
  'scraper.act.phase1Light':
    'Fase-1-Light: {n} bedrijven geïdentificeerd in {secs}s. Adres/grootte/details worden indien nodig later gescraped.',
  'scraper.act.serperExhausted':
    '⚠ Serper-credits uitgeput: Discovery beperkt. Bijvullen op serper.dev/dashboard.',
  'scraper.act.mapsHits': '{n} Maps-resultaten voor "{query}"',
  'scraper.act.searchHitsCollected': '{n} resultaten uit Google-zoekopdracht verzameld',
  'scraper.act.directoriesFound': '{n} branchegidsen gevonden: extraheer vermelde bedrijven…',
  'scraper.act.searchingPortal': 'Doorzoek {host} naar vermelde bedrijven…',
  'scraper.act.minedCompanies': '{n} bedrijven uit {portal} geëxtraheerd',
  'scraper.act.onlyPortals':
    'Geen operationele bedrijven geïdentificeerd: alle resultaten waren portalen',
  'scraper.act.queryInfeasible': 'Cortex acht de query niet haalbaar: {reason}',
  'scraper.act.rethinking': 'Cortex denkt opnieuw na (ronde {round}): {reason}',
  'scraper.act.searchingPortalNew': 'Doorzoek {host} (nieuwe planstap)…',
  'scraper.act.minedPortalRound': '{n} bedrijven uit {host} (reflector-ronde {round})',
  'scraper.act.backlogResumed': '{n} backlog-kandidaten uit eerdere runs hervat',
  'scraper.act.companiesIdentifiedAgg':
    '{n} ondernemingen geïdentificeerd ({rescued}/{attempted} uit aggregator-portalen gered): start diepteanalyse',
  'scraper.act.companiesIdentified': '{n} ondernemingen geïdentificeerd: start diepteanalyse',
  'scraper.act.handelsregisterChecked': 'Handelsregister-uittreksel gecontroleerd: {hrb}',
  'scraper.act.scanningWebsite': 'Scan website: {domain}',
  'scraper.act.relatedPages': "{n} aanvullende pagina's geanalyseerd: {domain}",
  'scraper.act.deepAnalysis': 'Diepgaande bedrijfsanalyse: {name}',
  'scraper.act.pipelineStarted':
    'Pipeline gestart: {n} kandidaten gaan parallel door hydratatie + beoordeling',
  'scraper.act.allDroppedPrefilter':
    'Alle {n} gevonden bedrijven werden als niet-passend verworpen (branche/regio). Preciseer je doelgroep of probeer een andere regio.',
  'scraper.act.noCompaniesFound':
    'Discovery heeft geen bedrijven voor deze zoekopdracht gevonden. Preciseer je doelgroep.',
  'scraper.act.phase1OnlyRun':
    'Alleen-fase-1-run: {n} Leads geïdentificeerd. Fase 2 + 3 werden overgeslagen.',
  'scraper.act.leadsDeliveredEnriching':
    '{n} Leads geleverd: Cortex verrijkt nog (acquisitieplan, scores, diepgaand onderzoek)',
  'scraper.act.deeperResearch': 'Diepgaander onderzoek: {name}, {findings} uit {sources} bronnen',
  'scraper.act.coldStart': 'Cold-start (geen eerdere runs)',
  'scraper.act.runHistory':
    '{runs} eerdere runs · {delivered} reeds geleverd · {dropped} reeds verworpen',
  'scraper.act.buyerProfile': 'Koperprofiel: {narrative} (Betrouwbaarheid: {confidence})',
  'scraper.act.confHigh': 'hoog',
  'scraper.act.confMid': 'gemiddeld',
  'scraper.act.confLow': 'laag',
  'scraper.act.subsidiary':
    'DACH-dochteronderneming herkend: {domain} ({src}), wordt gebruikt voor contactpersoon-zoeken.',
  'scraper.act.subsidiarySrcDirect': 'direct gecontroleerd',
  'scraper.act.subsidiarySrcGoogle': 'via Google-onderzoek',
  'scraper.rq.harvestedMsg':
    'Doelgroep voorlopig uitgeput: eerdere zoekruns hebben al {prior} passende bedrijven geleverd.',
  'scraper.rq.harvestedRec':
    'Cortex heeft de bekende bedrijven al gevonden. Nieuwe treffers ontstaan wanneer nieuwe bedrijven in je doelgroep online zichtbaar worden: de planning pikt ze automatisch op.',
  'scraper.rq.noMarketMsg':
    'Slechts {n} bedrijven gevonden op het hele web voor deze zoekopdracht. Deze doelgroep lijkt niet publiek vindbaar te zijn, mogelijk te specifiek of interne bedrijfsgegevens.',
  'scraper.rq.noMarketRec':
    'Probeer breder te formuleren of combineer met look-alike-branches. Planning loont niet voor deze query.',
  'scraper.rq.tooNicheMsg':
    'Slechts {n} potentiële bedrijven in de markt: je doelgroep is zeer niche.',
  'scraper.rq.tooNicheRec':
    'Planning loont alleen bij doelgroepen met 50+ ondernemingen. Overweeg bredere regio of meer branche-varianten.',
  'scraper.rq.qualifierDownMsg':
    'De AI-beoordeling was tijdens deze zoekopdracht niet bereikbaar, waardoor de {n} gevonden bedrijven niet beoordeeld konden worden — een technisch probleem aan onze kant, geen oordeel over jouw markt.',
  'scraper.rq.qualifierDownRec':
    'Start de zoekopdracht over een paar minuten opnieuw. Je criteria hoef je niet aan te passen — deze keer is geen enkel bedrijf daadwerkelijk beoordeeld.',
  'scraper.rq.unmatchedMsg':
    '{n} bedrijven geanalyseerd: geen kwam overeen met je criteria (branche, grootte, regio).',
  'scraper.rq.unmatchedRec':
    'Beschrijving controleren: te strenge criteria? Look-alike-acceptatie helpt niet omdat geen look-alikes plausibel waren.',
  'scraper.sum.delivered':
    '{n} Leads geleverd ({hard} zeker{softFrag}) uit {total} geanalyseerde bedrijven.',
  'scraper.sum.softFragment': ', {soft} mogelijk relevant',
  'scraper.sum.deliveredNiche':
    '{n}/10 Leads geleverd: de doelgroep is niche (slechts {total} bedrijven in de markt geïdentificeerd).',
  'scraper.sum.nicheRec':
    'Bij terugkerende planning normaal: nieuwe treffers ontstaan over tijd. Als je meer volume nodig hebt: overweeg bredere regio of verwante branches.',
  'scraper.sum.deliveredDropped':
    '{n}/10 Leads geleverd: Cortex heeft {dropped} andere kandidaten als niet-passend verworpen.',
  'scraper.sum.droppedRec':
    'Als je meer volume wilt: beschrijving losser formuleren of look-alikes/soft-keeps accepteren.',
  'scraper.sum.deliveredMixed': '{n}/10 Leads geleverd: gemengde opbrengst uit {total} bedrijven.',
  'scraper.sum.mixedRec':
    'Bij terugkerende planning normaal: Cortex verzamelt met de tijd meer treffers.',
  'scraper.sum.noneMatched': '{total} bedrijven geanalyseerd: geen kwam overeen met je criteria.',
  'scraper.sum.noneMatchedRec':
    'Beschrijving controleren: te strenge criteria of andere regio proberen.',
  'scraper.mem.active': 'Actief gepersonaliseerd · {n} beoordelingen',
  'scraper.mem.analyzing': 'Wordt momenteel opnieuw geanalyseerd · {n} beoordelingen',
  'scraper.mem.firstImpression': 'Eerste indruk · {n}/{active} tot actief',
  'scraper.mem.learning': 'Leert met je mee · {n}/{preview} tot voorbeeld',
  'scraper.reflector.fallback':
    'Reflector niet beschikbaar: query gemeld als niet-uitvoerbaar zodat gebruiker niet eindeloos wacht.',
  // LEA-543: Zielgruppe sind Privatpersonen — Leadscraper findet nur Unternehmen.
  // Server-seitig lokalisiert via tForLang, zusammen unter 240 Zeichen (die
  // Fehler-Antwort wird im Client bei 300 Zeichen abgeschnitten).
  'apierr.b2cOnly':
    'Leadscraper vindt bedrijven en de beslissers daarbinnen — particulieren leveren we niet.',
  'apierr.b2cPivot': 'Een werkbaar alternatief: {pivot}',
  'apierr.junkQuery':
    'Beschrijf concreet WIE je zoekt, bijv. "Bakkerijen in Amsterdam" of "Belastingadviseurs Noord-Holland 5-50 medewerkers". Generieke termen zoals "B2B", "Test", "Profiel" of teksten met typefouten worden niet geaccepteerd.',
  'apierr.invalidWebsite': 'Voer een geldige website in (bijv. mijn-bedrijf.nl)',
  'apierr.noUserCompanyStep1': 'Eerst website analyseren (Stap 1).',
  'apierr.noUserCompany': 'Eerst website analyseren.',
  'apierr.insufficientPhase': 'Je hebt {cost} Credit(s) nodig voor deze fase. Huidig: {credits}.',
  // LEA-704: reveal-model pricing (Om QA 26.10.).
  'apierr.pitchRequiresReveal':
    'Ontgrendel eerst de contactpersonen van dit bedrijf — het acquisitieplan is inbegrepen.',
  'apierr.planGenFailed': 'Acquisitieplan kon niet worden gegenereerd. Geen Credit verbruikt.',
  'apierr.urlParse': 'URL kon niet worden geparseerd.',
  'apierr.urlIncomplete': 'Geef een volledige URL op.',
  'apierr.dupCompany': 'Dit bedrijf heb je al aangemaakt{nameSuffix}.',
  'apierr.dupCompanySuffix': ' ({name})',
  'apierr.manualUnreachable':
    'Website was niet bereikbaar bij aanmaken: gegevens konden niet worden opgehaald.',
  'apierr.manualPhase1Failed':
    'Fase 1 mislukt (website niet bereikbaar). Probeer opnieuw via "Gegevens bijwerken".',
  'apierr.cancelRequested': 'Annulering aangevraagd. Wordt uitgevoerd bij het volgende checkpoint.',
  'apierr.noCredits': 'Geen Credits beschikbaar. Sluit een abonnement af of koop Credits bij.',
  'apierr.rescueNotAvailable':
    'De gratis tweede poging voor deze zoekopdracht is niet (meer) beschikbaar.',
  'apierr.intentParse':
    'Kon uit je beschrijving "{desc}" geen concrete branche extraheren. Wees preciezer, bijv. in plaats van "Amsterdam" → "Bakkerijen in Amsterdam" of "Belastingadviseurs in Amsterdam".',
  // i18n localization batch (LeadDetail / acquisition plan)
  'det.acquisitionPlan': 'Acquisitieplan',
  'det.creatingPlan': 'Cortex maakt je acquisitieplan…',
  'det.planLoadTime': 'Meestal 30-60 seconden: geen herladen nodig, verschijnt automatisch',
  'det.planUncertaintyWarning': 'Let op: plantekst bevat onzekerheden',
  'det.companyClassification': 'Bedrijfsclassificatie',
  'det.opportunities': 'Kansen',
  'det.risksAndDealbreakers': "Risico's / dealbreakers",
  'det.channelMix': 'Kanaalmix · 7-daagse reeks',
  'ld.sparkle.sampleMessageLabel': 'Voorbeeldbericht voor eerste contact',
  'ld.sparkle.sampleMessageCopied': 'Voorbeeldbericht gekopieerd.',
  'common.copy': 'kopiëren',
  'ld.sparkle.messageSubject': 'Onderwerp: ',
  'ld.lean.urteil': 'Waarom deze lead',
  'ld.lean.winkel': 'Jouw invalshoek',
  'ld.lean.kontakte': 'Wie eerst',
  'ld.lean.nachricht': 'Eerste contact: klaar om te versturen',
  'ld.lean.nachrichtShort': 'Concept eerste contact',
  'ld.lean.telefon': 'Telefoonopening',
  'ld.lean.check': 'Voor het versturen',
  'ld.lean.copyAI': 'Kopiëren voor AI',
  'ld.lean.copyAITitle':
    'Kopieert het plan, publiek onderzochte bedrijfs- en contactgegevens en je aanbodprofiel als handover voor ChatGPT, Claude & co.',
  'ld.lean.copiedAI': 'Handover gekopieerd: plak hem in je AI-tool',
  'ld.lean.varMain': 'Aanbevolen',
  'ld.lean.sendMail': 'Als e-mail versturen',
  'ld.lean.sendMailTitle':
    'Opent je e-mailprogramma met {addr}, onderwerp en tekst vooraf ingevuld',
  'ld.lean.zentrale': 'Centrale',
  'ld.lean.nameNotPublic': 'naam niet openbaar',
  'ld.lean.verifiziert': 'geverifieerd',
  'ld.lean.chEmail': 'E-mail',
  'ld.lean.chTelefon': 'Telefoon',
  'ld.lean.chLinkedIn': 'LinkedIn',
  'ld.lean.chXing': 'Xing',
  'ld.ai.instructions':
    'Jij bent mijn sales-copiloot voor precies deze ene lead. Hieronder staan alle gegevens die mijn tool (Leadscraper) uit openbare bronnen heeft onderzocht en als acquisitieplan heeft voorbereid: gebruik ze direct, vraag er niet eerst om.\n\nMarkeringen: ✓ = openbaar bevestigd (website, colofon, LinkedIn, register), ~ = aanname zonder harde bron. Houd dit onderscheid aan en verzin niets over het bedrijf of de contactpersoon.\n\nJe kunt me helpen het eerste bericht aan te scherpen, een belscript te bouwen, bezwaren te oefenen of de follow-up voor te bereiden.',
  'ld.ai.secLead': 'Lead',
  'ld.ai.secData': 'Beschikbare data',
  'ld.ai.secContacts': 'Contacten',
  'ld.ai.secCompany': 'Mijn bedrijf',
  'ld.ai.secPlan': 'Acquisitieplan',
  'ld.ai.secUncertain': 'Onzekerheden & verifiëren',
  'ld.ai.secTask': 'Wat ik van je nodig heb',
  'ld.ai.taskBody':
    'Begin meteen: scherp het eerste bericht hierboven aan in mijn toon en stel ÉÉN concrete verbetering voor die mijn responskans verhoogt.',
  'ld.ai.company': 'Bedrijf',
  'ld.ai.industry': 'Branche',
  'ld.ai.size': 'Omvang',
  'ld.ai.region': 'Regio',
  'ld.ai.dataAsOf': 'Datastand: onderzocht op {date}',
  'det.recommendedNextStep': 'Aanbevolen volgende stap',
  'det.botProtectionWarning':
    'Deze website had botbescherming actief: we konden de impressum-/contactpagina niet rechtstreeks scrapen. De hier getoonde gegevens hebben we samengesteld uit openbare bronnen (Google, branchegidsen) en kunnen minder nauwkeurig zijn dan directe impressumgegevens.',
  'det.possibleNotVerified': 'Mogelijk: niet 100% verifieerbaar',
  'det.noJustificationYet':
    'Nog geen motivatie: voor deze lead kon de buyer matching niet worden uitgevoerd (gebruikersprofiel onvolledig of website onbereikbaar). Start fase 2/3 om meer gegevens op te halen.',
  'det.offering': 'Aanbod',
  'det.nicheSignals': 'Nichesignalen',
  'det.niche.signalsOne': '1 signaal',
  'det.niche.signalsMany': '{n} signalen',
  'det.vatId': 'Btw-nr.: ',
  'det.revenue': 'Omzet ',
  'det.agency': 'Bureau',
  'det.distributor': 'Distributeur',
  'det.stack': 'Stack:',
  'det.webDesign': 'Webdesign:',
  'det.masteryBusiness': 'Meesterbedrijf',
  'det.guild': 'Gilde: ',
  'det.imprintVerified': '✓ Impressum geverifieerd',
  'det.sealsOfQuality': 'Keurmerken:',
  'det.social': 'Social:',
  'det.verifyingContacts': 'Contacten verifiëren…',
  'det.inferringPattern': 'Patroon wordt afgeleid…',
  'det.emailPatternPlaceholder': '{voornaam}.{achternaam}@bedrijf.de',
  'det.sales': 'Verkoop',
  'det.marketing': 'Marketing',
  'det.engineering': 'Techniek',
  'det.finance': 'Financiën',
  'det.management': 'Directie',
  'det.procurist': 'Procuratiehouder',
  'det.contactRemoved': 'verwijderd, wordt niet meer geleverd.',
  'det.percentSure': '% zeker',
  'det.foundIn': 'gevonden in:',
  'det.recommendedChannel': 'Aanbevolen kanaal',
  'det.tier1': 'Tier 1 · direct bereikbaar',
  'det.tier2': 'Tier 2 · profielkanaal',
  'det.tier3': 'Tier 3 · via centrale',
  'det.tier4': 'Tier 4 · back-upcontact',
  'det.tier5': 'Tier 5 · alleen bedrijfsrouting',
  'det.inferred': '⚠ vermoed',
  'det.companyCentral': '(Bedrijfscentrale)',
  'det.quality.title': 'Leadkwaliteit',
  'det.quality.company': 'Bedrijf',
  'det.quality.contact': 'Contact',
  'det.quality.noContacts':
    'Geen beslissers publiek verifieerbaar voor dit bedrijf: Leadscraper verzint geen contacten.',
  'det.quality.companyFitPlain': 'Branche, regio en grootte passen bij je zoekopdracht.',
  'det.quality.companyFitSoft':
    'Branche en regio passen, nog niet op elk criterium helemaal eenduidig.',
  'det.quality.noContactsCentral': 'Het blijft bereikbaar via de centrale (zie contact).',
  'det.quality.outreach': 'Outreach',
  'det.quality.lockedContactVerify': 'Verifieer eerst het contact',
  'det.quality.lockedPlanCreate': 'Maak eerst het acquisitieplan',
  'ld.sparkle.conversationOpener': 'Gespreksopener',
  'ld.sparkle.openerCopied': 'Opener gekopieerd.',
  'lt.next.contactVerificationStarted': 'Contactverificatie gestart …',
  'lt.next.contactVerificationLabel': 'Contactverificatie',
  'lt.next.planGenerationStarted': 'Generatie van acquisitieplan gestart …',
  'lt.next.planGenerationLabel': 'Generatie van acquisitieplan',
  'lt.next.verifiedNoContacts': 'Geverifieerd: geen contacten gevonden',
  // LEA-379 i18n#5 (Om QA): lead-card loading status — these keys existed only in
  // de/en, so NL fell back to German. Copy is tweakable — flag Janik if off.
  'lt.loading.connecting': 'Contactpersonen worden gezocht …',
  'lt.loading.planning': 'Acquisitieplan wordt gegenereerd …',
  'lt.loading.adding': 'Toevoegen …',
  'lt.loading.verifying': 'Verifiëren …',
  'lt.loading.connectingLive': 'Contactpersonen worden geverifieerd …',
  'lt.loading.planningLive': 'Acquisitieplan wordt opgesteld …',
  'det.size.employees': 'medewerkers',
  'det.since': 'sinds ',

  // ── Prism-funnel (Stage C i18n-extractie, /dev/prism-demo) ───────────────
  // Algemeen / kicker
  'prism.kicker.account': 'Account aangemaakt',
  'prism.kicker.waiting': 'Je eerste klanten wachten op je',
  'prism.audienceFallback': 'je doelgroep',
  // LEA-379 i18n#4 (Om QA): Stripe checkout line-item, localized per session lang.
  'billing.tripwire.lineItem.name': 'Leadscraper: 50 Leads-startpakket',
  'billing.tripwire.lineItem.desc': '50 geverifieerde leads, klaar om te benaderen.',
  'prism.a11y.close': 'Sluiten',
  // Stap 1 — Doelgroep
  'prism.target.eyebrow': 'Stap 1 van 3 · Doelgroep',
  'prism.target.title': 'Wie wil je bereiken?',
  'prism.target.titleGrad': 'Wij vinden ze direct.',
  'prism.target.sub':
    'Beschrijf je doelgroep in één zin: je live zoekopdracht stemt zich er precies op af.',
  'prism.target.label': 'Je doelgroep',
  'prism.target.placeholder': 'bijv. eigenaren van accountantskantoren in Amsterdam',
  'prism.target.chip.steuer': 'Accountantskantoren in Amsterdam',
  'prism.target.chip.agentur': 'Marketingbureaus in Rotterdam',
  'prism.target.chip.handwerk': 'Installatiebedrijven in Utrecht',
  'prism.target.chipQuery.steuer': 'Eigenaren van accountantskantoren in Amsterdam',
  'prism.target.chipQuery.agentur': 'Oprichters van marketingbureaus in Rotterdam',
  'prism.target.chipQuery.handwerk': 'Installatiebedrijven in Utrecht',
  'prism.target.tip':
    '💡 Het sterkst: branche + regio, bijv. „tandartsen in Eindhoven". Ook rollen zoals „directeuren in het mkb" begrijpen we.',
  'prism.target.suggestion': 'Bedoel je bijv. „{suggestion}"?',
  'prism.target.validating': 'Je doelgroep wordt gecheckt…',
  'prism.target.cta': 'Doelgroep vinden',
  'prism.target.foot': 'Gratis · nog geen betaalgegevens nodig',
  'prism.target.errFallback': 'Dit lijkt nog niet op een doelgroep.',
  // Stap 2 — Website
  'prism.website.eyebrow': 'Stap 2 van 3 · Website',
  'prism.website.title': 'Je website:',
  'prism.website.titleGrad': 'zodat de AI je begrijpt',
  'prism.website.sub':
    'De website van je eigen bedrijf, zodat we begrijpen wat je verkoopt en welke klanten bij je passen.',
  'prism.website.label': 'Website-URL',
  'prism.website.placeholder': 'https://jouwbedrijf.nl',
  'prism.website.hint':
    'Nog geen eigen website? Sla deze stap dan over. De zoektocht loopt dan alleen op je doelgroep.',
  'prism.website.errInvalid': 'Dit lijkt nog niet op een webadres, bijv. „jouwbedrijf.nl".',
  'prism.website.cta': 'Website analyseren',
  'prism.website.foot': 'Wordt alleen geanalyseerd · niets wordt gepubliceerd',
  // Analysefase
  'prism.analyzing.reading': 'De AI leest je website…',
  'prism.analyzing.wait': 'Je doelgroep wordt aangescherpt…',
  'prism.analyze.step1': 'Website live geladen en uitgelezen',
  'prism.analyze.step2': 'Businessmodel herkend',
  'prism.analyze.step3': 'Aanbod en waardepropositie geanalyseerd',
  'prism.analyze.step4': 'Ideale doelgroep afgeleid',
  // Stap 3 — Vragen
  'prism.questions.eyebrow': 'Laatste stap · Fijnslijpen',
  'prism.questions.back': '← Terug',
  'prism.questions.title': 'Even bevestigen:',
  'prism.questions.titleGrad': 'vraag {num} van {total}',
  'prism.questions.q1': 'Hoe groot moeten de bedrijven zijn?',
  'prism.questions.q1o1': 'Tot 50 medewerkers',
  'prism.questions.q1o2': 'Meer dan 50',
  'prism.questions.q1o3': 'Maakt niet uit',
  'prism.questions.q2': 'Moeten de bedrijven gespecialiseerd zijn?',
  'prism.questions.q2o1': 'Ja, op één segment',
  'prism.questions.q2o2': 'Breed opgesteld',
  'prism.questions.q2o3': 'Maakt niet uit',
  'prism.questions.q3': 'Waar moeten de bedrijven zitten?',
  'prism.questions.q3o1': 'Alleen mijn regio',
  'prism.questions.q3o2': 'Landelijk',
  'prism.questions.q3o3': 'Maakt niet uit',
  'prism.questions.yes': 'Ja, precies',
  'prism.questions.no': 'Niet echt',
  'prism.questions.foot': 'Hoe preciezer je antwoord, hoe raker je eerste leads.',
  // Zoekfase
  'prism.searching.label': 'Bedrijven gevonden in je doelgroep…',
  // Wave 2: concrete/procedural so the endless rotation doesn't feel "stuck" —
  // 6 true process steps instead of 4.
  'prism.searching.wait1': 'Resultaten worden op relevantie gecheckt…',
  'prism.searching.wait2': 'Zwakke resultaten worden eruit gefilterd…',
  'prism.searching.wait3': 'Dubbele resultaten worden vergeleken…',
  'prism.searching.wait4': 'Websites worden op bereikbaarheid gecheckt…',
  'prism.searching.wait5': 'Locaties worden vergeleken…',
  'prism.searching.wait6': 'Bedrijfsprofielen worden samengevoegd…',
  'prism.search.step1': 'Zoekopdrachten voor je doelgroep gepland',
  'prism.search.step2': 'Bedrijven verzameld via web- en kaartzoekopdrachten',
  'prism.search.step3': 'Portalen, gidsen en dubbelen verwijderd',
  'prism.search.step4': 'Match van de beste treffers met je doelgroep beoordeeld',
  'prism.search.step5': 'Websites van de sterkste treffers live gecheckt',
  'prism.search.step6': 'Regio en bedrijfstype van de sterkste treffers gecontroleerd',
  'prism.search.step7': 'Zwakke treffers verwijderd',
  'prism.search.step8': 'Resultaat op plausibiliteit gecheckt',
  'prism.search.step9': 'Sterkste resultaten samengesteld',
  'prism.search.n.companies': '{count} bedrijven',
  'prism.search.n.ap': '{count} contacten',
  'prism.search.n.valid': '{count} geldig',
  'prism.search.n.revenue': '~{count} mln €',
  'prism.search.n.top': 'Top 50',
  // Fit-labels
  'prism.score.perfect': 'Perfecte fit',
  'prism.score.outstanding': 'Uitstekende fit',
  'prism.score.veryStrong': 'Zeer sterke fit',
  'prism.score.good': 'Goede fit',
  'prism.score.titleAttr': 'Fit-score {score}/100',
  // Verfijnscherm (zwakke resultaten)
  'prism.refine.title': 'Nog niet genoeg treffers: laten we dit aanscherpen.',
  'prism.refine.body': 'Voor {audience} hebben we nog niet genoeg overtuigende bedrijven gevonden.',
  'prism.refine.hint1': 'Maak je doelgroep specifieker, het best',
  'prism.refine.hintStrong': 'branche + regio',
  'prism.refine.hint2':
    '(bijv. „accountantskantoren in Amsterdam", „tandartspraktijken in Utrecht", „bouwbedrijven in Rotterdam"). Hoe concreter, hoe meer echte bedrijven we voor je vinden.',
  'prism.refine.try': 'Deze werken al goed, één klik verder:',
  // F9: 429-scherm — dagelijks quotum, eerlijk benoemd (geen kwaliteits-refine).
  'prism.rateLimit.title': 'Je hebt je daglimiet voor live zoekopdrachten bereikt.',
  'prism.rateLimit.body':
    'Dit heeft niets met je doelgroep te maken — we begrenzen het aantal gratis live zoekopdrachten per dag. Je doelgroep en website blijven bewaard.',
  'prism.rateLimit.reset': 'Je quotum wordt om {time} teruggezet.',
  'prism.rateLimit.cta': 'Terug naar het begin',
  // D2 (LEA-430): „welkom terug"-hervatting + eerlijke timer-variant.
  'prism.resume.title': 'Welkom terug!',
  'prism.resume.body': 'Je zoekopdracht voor {audience} is klaar — je resultaat is opgeslagen.',
  'prism.resume.cta': 'Resultaat bekijken',
  'prism.resume.dismiss': 'Nieuwe zoekopdracht starten',
  'prism.resume.saved': 'Je selectie is opgeslagen — geen tijdsdruk.',
  'prism.understood.title': 'Je bedrijf, begrepen',
  'prism.understood.opps': 'Kansen',
  // Wave 2: label above the highlighted "why now" line.
  'prism.understood.momentumLabel': 'Waarom nu:',
  // DEPRECATED (Wave 2): "Let op" is no longer rendered (legacy bundles).
  'prism.understood.risks': 'Let op',
  'prism.understood.demoModel': 'B2B-dienst die mkb helpt nieuwe klanten te winnen.',
  'prism.understood.demoOpp1': 'Duidelijk afgebakende niche met hoge klantwaarde',
  'prism.understood.demoOpp2': 'Weinig gespecialiseerde concurrentie in de regio',
  'prism.understood.demoOpp3': 'Beslissers direct bereikbaar (kleine teams)',
  'prism.understood.demoRisk1': 'Lange besluitvorming in het mkb',
  'prism.understood.demoRisk2': 'Eerste contact heeft een concrete aanleiding nodig',
  'prism.seed.badge': 'Startpakket',
  'prism.seed.working': '{delivered}/{total} leads geleverd',
  'prism.seed.workingSub':
    'Dit duurt 10 tot 30 minuten. Nieuwe leads verschijnen automatisch. Exporteer het liefst pas als ze er allemaal zijn.',
  'prism.seed.creditsNote':
    'Je {total} startcredits worden onderweg ingewisseld: 1 credit per afgerond lead.',
  'prism.seed.done': 'Alle {delivered} leads staan in je account.',
  'prism.seed.donePartial':
    '{delivered} leads geleverd: resterende credits blijven als tegoed staan.',
  'prism.refine.cta': 'Doelgroep nu aanscherpen',
  // Resultaat (aha)
  // Wave 2: the real kept-count now carries the headline.
  'prism.results.foundSuffix': 'bedrijven gevonden in je doelgroep',
  // #4 (Quickwins): gepersonaliseerde variant — {audience} komt als kant-en-klaar
  // »citaat« uit de client (nooit verbuigen, gate zit client-side).
  'prism.results.foundSuffixAud': 'bedrijven gevonden voor {audience}',
  // DEPRECATED (#13): "only X match" undersells the engine and contradicts
  // the 50-unlock — replaced by topLine (abundance + curation).
  'prism.results.matched': '{count} passen bij je doelgroep',
  // #13: story = we show the strongest matches, the market has more of them.
  'prism.results.topLine': 'Hieronder: je sterkste resultaten op basis van match.',
  // Wave 2: crossfade label target for the number morph (reserved; the
  // "live gecheckt" framing currently carries foundSuffix).
  'prism.results.checkedLabel': 'daarvan live gecheckt, je sterkste',
  // DEPRECATED (Wave 2): replaced by prism.results.matched.
  'prism.results.checked': '{count} daarvan hebben we al live gecheckt',
  'prism.results.unlockHint': 'Ontgrendel je eerste',
  'prism.results.unlockOffer': '{n} passende bedrijven voor € 49',
  'prism.results.disclaimer':
    'Schatting van het marktpotentieel op basis van je live-analyse: precies deze bedrijven vinden we voor jou.',
  'prism.results.stat.checked': 'bedrijven gevonden',
  // Wave 2: new real stat labels.
  'prism.results.stat.onTarget': 'passen bij je doelgroep',
  // #13: market-abundance tile instead of "X match" — real engine estimate
  // (market.projected_range_dach); tile is omitted when no estimate exists.
  'prism.results.stat.market': 'bedrijven in je markt (schatting)',
  'prism.results.stat.avgFit': 'Gem. fit-score van je sterkste resultaten',
  // DEPRECATED (Wave 2): synthetic tiles — no longer rendered.
  'prism.results.stat.contacts': 'contacten vindbaar',
  'prism.results.stat.revenue': 'omzetpotentieel doelgroep',
  'prism.results.chart.sizeTitle': 'Bedrijven naar grootte',
  'prism.results.chart.sizeMuted': 'in je doelgroep',
  'prism.results.chart.emp1': '1–9 mdw',
  'prism.results.chart.emp2': '10–49 mdw',
  'prism.results.chart.emp3': '50–199 mdw',
  'prism.results.chart.emp4': '200+ mdw',
  'prism.results.chart.qualityTitle': 'Datakwaliteit van je leads',
  'prism.results.chart.qualityMuted': 'vandaag gecheckt',
  'prism.results.chart.mail': 'Geverif. mail',
  'prism.results.chart.dial': 'Doorkiesnummer',
  'prism.results.chart.decider': 'Beslissers',
  'prism.results.insights.title': 'Potentieel en timing van je doelgroep',
  'prism.results.insights.openRate': 'Gem. openrate van geverifieerde B2B-mails',
  'prism.results.insights.bestTimeValue': 'di–do · 9–11 uur',
  'prism.results.insights.bestTime': 'Beste contactmoment in deze branche',
  'prism.results.insights.dealValue': 'Gem. orderwaarde per gewonnen klant',
  'prism.results.insights.competitionValue': 'laag',
  'prism.results.insights.competition': 'Concurrentie op koude acquisitie in je regio',
  'prism.results.why.title': 'Goede timing:',
  'prism.results.why.p1': 'In je doelgroep werden recent',
  'prism.results.why.strong': '18% meer nieuwe beslissers',
  'prism.results.why.p2':
    'actief: de ideale fase voor het eerste contact, vóór de concurrentie volgt.',
  'prism.results.timing.title': 'Waarom dit precies het juiste moment is',
  'prism.results.timing.legend': 'Beste contactfase in je doelgroep, nu',
  'prism.timing.text':
    'In {month} is de bereikbaarheid bij {who} uit ervaring het hoogst: budgetten voor het komende kwartaal worden nu verdeeld en beslissers nemen de telefoon op. Wie nu het eerste contact legt, is er vóór de concurrentie in {next} aanhaakt.',
  // Maanden (seizoensgrafiek + timing-tekst)
  'prism.month.now': 'Nu',
  'prism.month.short.1': 'jan',
  'prism.month.short.2': 'feb',
  'prism.month.short.3': 'mrt',
  'prism.month.short.4': 'apr',
  'prism.month.short.5': 'mei',
  'prism.month.short.6': 'jun',
  'prism.month.short.7': 'jul',
  'prism.month.short.8': 'aug',
  'prism.month.short.9': 'sep',
  'prism.month.short.10': 'okt',
  'prism.month.short.11': 'nov',
  'prism.month.short.12': 'dec',
  'prism.month.long.1': 'januari',
  'prism.month.long.2': 'februari',
  'prism.month.long.3': 'maart',
  'prism.month.long.4': 'april',
  'prism.month.long.5': 'mei',
  'prism.month.long.6': 'juni',
  'prism.month.long.7': 'juli',
  'prism.month.long.8': 'augustus',
  'prism.month.long.9': 'september',
  'prism.month.long.10': 'oktober',
  'prism.month.long.11': 'november',
  'prism.month.long.12': 'december',
  // Gratis lead
  'prism.freelead.tag': 'Je eerste lead, van ons',
  'prism.freelead.verified': 'geverifieerd',
  'prism.freelead.lockedChip': '🔒 Contactpersoon en contactgegevens na het ontgrendelen',
  'prism.freelead.note1': 'Zo ziet',
  'prism.freelead.noteStrong': 'elk',
  'prism.freelead.note2':
    'van je {n} passende bedrijven eruit: een echte contactpersoon met e-mail of telefoon. De overige {rest} ontgrendel je in de volgende stap.',
  'prism.freelead.alt1': 'Dit bedrijf past bij je doelgroep. Bij ontgrendeling verrijken we',
  'prism.freelead.altStrong': 'echte contactpersonen met e-mail of telefoon',
  'prism.freelead.alt2': ', voor alle {n}.',
  // Lead-rijen
  'prism.lead.ap': 'Contactpersonen',
  'prism.lead.inclDeciders': 'na ontgrendelen',
  'prism.results.moreStrong': '≈{count} meer',
  'prism.results.moreRest': 'gevonden. Contacten zoeken we op nadat je ontgrendelt.',
  'prism.results.planTitle': 'Je acquisitieplan om te starten:',
  'prism.results.planBody':
    'de {n} sterkste bedrijven eerst, contactpersonen met e-mail of telefoon, te exporteren als CSV of Excel.',
  'prism.results.cta': 'Mijn {n} passende bedrijven ontgrendelen',
  'prism.results.detailsLink': 'Wat zit er precies in?',
  'prism.results.foot': '€ 49 vandaag · {n} passende bedrijven · vanaf dag 4: € 290/maand, altijd opzegbaar',
  // Paywall
  'prism.paywall.step2': 'Ontgrendelen',
  'prism.paywall.step3': 'Aan de slag',
  'prism.paywall.resPrefix': 'Je',
  'prism.paywall.resStrong': '50 leads',
  'prism.paywall.resSuffix': 'zijn voor jou gereserveerd',
  'prism.paywall.resExpired':
    'Reservering verlopen: we houden je zoekopdracht nog even voor je vast.',
  'prism.paywall.eyebrow': '{count} bedrijven gevonden: klaar om te ontgrendelen',
  'prism.paywall.title1': 'Ontgrendel je eerste',
  'prism.paywall.titleGrad': '{n} passende bedrijven',
  'prism.paywall.title2': 'nu.',
  // #4 (Quickwins): gepersonaliseerde H1-variant ({audience} = klaar »citaat«).
  'prism.paywall.title2Aud': 'voor {audience} nu.',
  'prism.paywall.sub1': 'We hebben',
  'prism.paywall.subStrong1': '{count} bedrijven',
  'prism.paywall.sub2': 'voor {audience} gevonden. De',
  'prism.paywall.subStrong2': '{n} sterkste',
  'prism.paywall.sub3':
    'wachten op je. Contactpersonen en contactgegevens zoeken we op nadat je ontgrendelt.',
  // Lead-kluis
  'prism.vault.title': 'Je {n} sterkste bedrijven staan klaar',
  // Wave 2: 3-stage story from real numbers — {count}=discovery.kept
  // (live gecheckt), {audience}=typed target audience.
  // #13: no more "exactly X match" (contradicted "50 strongest" and shrank
  // the market) — {onTarget} stays as an unused-but-compatible placeholder.
  'prism.vault.sub':
    'Uit {count} gevonden bedrijven voor {audience}: hier zijn je {n} sterkste. Contactpersonen en contactgegevens zoeken we op nadat je ontgrendelt.',
  'prism.vault.locked': 'vergrendeld',
  'prism.vault.blurEmail': 'contact@bedrijf.nl',
  // Wave 2: real remaining count from the scored pool instead of a static "+45".
  'prism.vault.more': '+ {count} meer gevonden bedrijven: vergrendeld',
  'prism.vault.cta': 'Alle {n} ontgrendelen, € 49',
  'prism.vault.reassure': '€ 49 vandaag · vanaf dag 4: € 290/maand · altijd opzegbaar',
  // Founder-kaart + video
  'prism.founder.head': 'Een persoonlijk bericht van de oprichter',
  'prism.founder.quote':
    '„Hoi, ik ben Janik. Tijdens je hele testperiode begeleid ik je persoonlijk, en de instap is bewust laag geprijsd, zodat je Leadscraper rustig kunt uitproberen. Geef ons de kans: ik weet zeker dat we bij je passen."',
  'prism.founder.role': 'Oprichter · Leadscraper',
  'prism.video.playAria': 'Demovideo afspelen',
  'prism.video.chip': 'Live demo · 10:04',
  'prism.video.title': 'Kijk hoe Janik je eerste leads vindt',
  'prism.video.cta': 'Bekijk de demo: echte zoekopdracht, echt dashboard',
  'prism.video.iframeTitle': 'Live demo · Leadscraper',
  // Tijdlijn (zo verloopt je test)
  'prism.timeline.title': 'Zo verloopt je test van 3 dagen',
  'prism.timeline.today': 'Vandaag',
  'prism.timeline.todayStrong': '€ 49 vandaag',
  'prism.timeline.todayRest': ': {n} passende bedrijven ontgrendeld, binnen 10 tot 30 minuten in je account.',
  'prism.timeline.days13': 'Dag 1–3',
  'prism.timeline.testP1': 'Je test met echte leads.',
  'prism.timeline.testStrong': '3 dagen de tijd',
  'prism.timeline.testP2': ': past het niet, dan zeg je met 1 klik op, geen cent extra.',
  'prism.timeline.day4': 'Vanaf dag 4',
  'prism.timeline.aboP1': 'Daarna loopt je plan met',
  'prism.timeline.aboStrong': '250 credits voor € 290/maand',
  'prism.timeline.aboP2': ' door — altijd opzegbaar.',
  // Vergelijkingsblok
  'prism.versus.title': 'Waarom Leadscraper, en niet de gebruikelijke weg',
  'prism.versus.oldTitle': 'De gebruikelijke weg',
  'prism.versus.old1': 'Uren handmatig googelen of verouderde lijsten kopen',
  'prism.versus.old2': 'Hoge bounce-rate, AVG-grijs gebied',
  'prism.versus.old3': 'Contactpersonen moeizaam zelf bij elkaar zoeken',
  'prism.versus.old4': '€ 1.000–1.500/maand + jaarcontract (Cognism, Dealfront)',
  'prism.versus.old5': 'Weken tot het eerste antwoord',
  'prism.versus.newTitle': 'Met Leadscraper',
  'prism.versus.new1': '{n} passende bedrijven binnen 10 tot 30 minuten, afgestemd op je doelgroep',
  'prism.versus.new2': 'E-mailadressen technisch gecontroleerd, telefoon waar beschikbaar',
  'prism.versus.new3': 'Contactpersonen direct meegeleverd',
  'prism.versus.new4': '€ 49 testen · maandelijks opzegbaar · geen jaarcontract',
  'prism.versus.new5': 'Vandaag exporteren, morgen aanschrijven',
  'prism.versus.foot1': 'Hetzelfde werk waarvoor anderen',
  'prism.versus.footStrong1': 'weken',
  'prism.versus.foot2': 'en',
  'prism.versus.footStrong2': 'ruim € 1.000/maand',
  'prism.versus.foot3': 'betalen, bij jou vandaag, als test voor',
  'prism.versus.footStrong3': '€ 49',
  // ROI-paneel
  'prism.roi.title': 'Wat je {n} passende bedrijven je opleveren',
  'prism.roi.row1': 'Leads met contactpersonen, binnen 10 tot 30 minuten klaar',
  'prism.roi.row2': 'Je inzet vandaag',
  'prism.roi.row3': 'Al één gewonnen klant levert',
  'prism.roi.row3v': 'een veelvoud terug',
  'prism.roi.hl1': 'Eén',
  'prism.roi.hlStrong': 'enkele',
  'prism.roi.hl2':
    'klant uit je eerste {n} passende bedrijven verdient de € 49 vele malen terug: alles daarna is voorsprong.',
  'prism.roi.perLead': 'per kant-en-klare lead',
  'prism.roi.stat2v': '10–30 min',
  'prism.roi.stat2': 'in plaats van weken research',
  'prism.roi.stat3v': '3 dagen',
  'prism.roi.stat3': 'proeftijd voordat het abonnement start',
  // Prijskaart
  'prism.plan.badge': 'Instapaanbieding · 3 dagen proberen',
  'prism.plan.leadsUnit': 'passende bedrijven · contactpersonen binnen 10 tot 30 minuten',
  'prism.plan.anchor': 'Zelf uitgezocht: ~10 uur handwerk',
  'prism.plan.priceSuffix': 'vandaag',
  'prism.price.netVat': 'excl. btw',
  'prism.plan.perLeadStrong': 'minder dan € 1',
  'prism.plan.f1': 'E-mailadressen technisch gecontroleerd, telefoon waar beschikbaar',
  'prism.plan.f2': 'Contactpersonen per bedrijf, voor zover openbaar vindbaar',
  'prism.plan.f3': 'Export als CSV of Excel, CRM-koppeling mogelijk',
  'prism.plan.cta': 'Nu ontgrendelen, € 49',
  'prism.plan.secure': 'Veilig betalen via Stripe · SSL-versleuteld',
  'prism.plan.subnote': 'Altijd met 1 klik opzegbaar in je account.',
  'prism.plan.gbCondition': 'Garantievoorwaarden: zie § 7 van de',
  'prism.guarantee.title': 'Geld-terug-garantie',
  'prism.guarantee.sub':
    'Binnen de 3 proefdagen betalen we je € 49 terug: mail naar support@leadscraper.eu, vul ons korte feedbackformulier in, en met de terugbetaling beëindigen we ook je abonnement. Alleen voor deze instapaanbieding.',
  'prism.legal.agb': 'algemene voorwaarden',
  'prism.legal.agbUrl': 'https://www.leadscraper.de/nl/algemene-voorwaarden',
  'prism.legal.privacyUrl': 'https://www.leadscraper.de/nl/privacybeleid',
  'prism.legal.privacy': 'Privacyverklaring',
  // Reviewband (klantquotes blijven bewust onvertaald)
  'prism.reviews.title': 'Salesteams die al zijn overgestapt',
  // Vertrouwensbalk
  'prism.trust.payStrong': '€ 49 vandaag',
  'prism.trust.payRest': '· kaart, PayPal, Apple & Google Pay, veilig via Stripe',
  'prism.trust.cancelStrong': 'Altijd opzegbaar',
  'prism.trust.cancelRest': '· met 1 klik in je account, geen opzegtermijn, geen vragen',
  'prism.trust.dataStrong': 'Alleen openbare data',
  'prism.trust.dataRest': '· AVG by design · servers in de EU',
  // FAQ
  'prism.faq.title': 'Veelgestelde vragen',
  'prism.faq.q1': 'Wat gebeurt er na de 3 dagen?',
  'prism.faq.a1':
    'Vanaf dag 4 loopt je plan met 250 credits voor € 290/maand door, altijd met één klik opzegbaar. Je beslist dus rustig tijdens de 3 dagen.',
  'prism.faq.q2': 'Kan ik altijd opzeggen?',
  'prism.faq.a2':
    'Ja, maandelijks: één klik in je account, zonder termijn en zonder vragen. Zeg je op binnen de 3 proefdagen, dan betaal je alleen de € 49. Daarna loopt je toegang tot het einde van de betaalde maand.',
  'prism.faq.q3': 'Waar komen de leads vandaan? Is dit AVG-conform?',
  'prism.faq.a3':
    'Uitsluitend uit openbaar beschikbare bedrijfsdata. AVG by design: verwerking en servers uitsluitend in de EU.',
  'prism.faq.q4': 'Wat als de leads niet passen?',
  'prism.faq.a4':
    'Binnen de 3 proefdagen betalen we je € 49 terug als je ons korte feedbackformulier invult (AV § 7). Mail naar support@leadscraper.eu; met de terugbetaling beëindigen we je abonnement. Daarna is terugbetaling niet meer mogelijk, maar je kunt het abonnement altijd opzeggen.',
  'prism.faq.q5': 'Krijg ik echte contactpersonen?',
  'prism.faq.a5':
    'Ja: per bedrijf opgezochte contactpersonen met e-mailadres of telefoonnummer. De e-mailadressen worden technisch gecontroleerd; dat elke mailbox bestaat, kunnen we niet garanderen. Vinden we voor een bedrijf geen bereikbaar contact, dan wordt daarvoor niets berekend.',
  // Founder-regel
  'prism.founderline.strong': 'Eigenaar-geleid vanuit Hamburg',
  'prism.founderline.rest': ': Janik Deimann, oprichter',
  'prism.founderline.sub': 'Deimann Com GmbH · Bij ons bereik je mensen, geen ticketwachtrij.',
  'prism.founderline.ask': 'Nog twijfels? Mail ons: support@leadscraper.eu, een mens antwoordt.',
  // Vaste koopbalk
  'prism.sticky.leads': '{n} passende bedrijven ·',
  'prism.sticky.today': 'vandaag · vanaf dag 4: € 290/maand',
  'prism.sticky.cta': 'Nu ontgrendelen',
  // Inline checkout
  'prism.checkout.eyebrow': 'Instapaanbieding · € 49 vandaag',
  'prism.checkout.title': '{n} passende bedrijven · nu ontgrendelen',
  'prism.checkout.sumPrice': '€ 49 vandaag',
  'prism.checkout.sumDesc': '{n} passende bedrijven ontgrendeld, 3 dagen proberen',
  'prism.checkout.after': 'vanaf dag 4',
  'prism.checkout.monthly': '€ 290 / maand',
  'prism.checkout.reassure3d':
    'Zeg je binnen de 3 dagen op, dan betaal je alleen de € 49. Je leads blijven van jou: je kunt ze ook daarna bekijken en exporteren.',
  'prism.checkout.deliverNote':
    'In deze zoekopdracht staan {count} passende bedrijven klaar. Een credit telt alleen als we een contactpersoon vinden; de rest van je 50 credits gebruik je voor verdere zoekopdrachten.',
  'prism.checkout.cancelNote': 'Abonnement altijd opzegbaar, één klik.',
  'prism.checkout.invite':
    'We nodigen je uit: 50 leads eenmalig tegen kostprijs, alleen om te starten, zodat je Leadscraper risicoloos kunt testen.',
  'prism.checkout.or': 'of met kaart',
  'prism.checkout.tabCard': 'Kaart',
  'prism.checkout.tabSepa': 'SEPA-incasso',
  'prism.checkout.cardholder': 'Kaarthouder',
  'prism.checkout.cardholderPh': 'Jan Jansen',
  'prism.checkout.cardNumber': 'Kaartnummer',
  'prism.checkout.expiry': 'Vervaldatum',
  'prism.checkout.expiryPh': 'MM / JJ',
  'prism.checkout.country': 'Land',
  'prism.checkout.countryDe': 'Duitsland',
  'prism.checkout.countryAt': 'Oostenrijk',
  'prism.checkout.countryCh': 'Zwitserland',
  'prism.checkout.paying': 'Activeren…',
  'prism.checkout.embedLoading': 'Veilige betaling laden …',
  'prism.checkout.payCta': '{n} passende bedrijven ontgrendelen, € 49',
  'prism.checkout.securePrefix': 'Veilig betalen via',
  'prism.checkout.secureSuffix': '· SSL-versleuteld',
  // Wave 2: generic button reference — the live CTA of the PaymentElement
  // (locked zone) reads "Doorgaan naar betaling", not "50 leads ontgrendelen".
  'prism.checkout.fine1': 'Door op de knop hierboven te klikken accepteer je de',
  'prism.checkout.fine2':
    'evenals de automatische verlenging als Starter-abonnement (250 credits / € 290 per maand) vanaf dag 4, altijd met één klik opzegbaar. Dit aanbod is uitsluitend bedoeld voor ondernemers en zakelijke gebruikers (B2B, § 14 Duits BW). Alle prijzen netto excl. wettelijke btw. Geld-terug-garantie: alleen voor deze instapaanbieding, alleen binnen de 3 proefdagen en met ingevuld feedbackformulier (AV § 7).',
  // Succes-scherm
  'prism.success.title': '{n} passende bedrijven ontgrendeld',
  'prism.success.body':
    'Je {n} passende bedrijven zijn ontgrendeld. De contactpersonen volgen binnen 10 tot 30 minuten, te exporteren als CSV/CRM. Vanaf dag 4 loopt je Starter-abonnement (250 credits/maand), maandelijks opzegbaar.',
  'prism.success.cta': 'Aan de slag',

  // --- LEA-379 i18n backfill (2026-07-06): keys that previously fell back to
  //     German (packages/i18n index.ts fallback). Machine-translated from EN/DE,
  //     billing/cancel copy pending Janik wording review. ---
  'acct.plan.downgradeScheduled': 'Planwijziging gepland',
  'acct.plan.downgradeScheduledDetail':
    'Je gaat op {date} over naar {plan}. Tot dan behoud je je huidige plan, en je credits blijven behouden.',
  'acct.plan.downgradeCancel': 'Wijziging annuleren',
  'acct.plan.downgradeCanceling': 'Wordt geannuleerd …',
  // LEA-555 — trial intercept.
  // LEA-557 — retention discount (30% x 3 Monate).
  // LEA-558 — VIP-Einrichtung (990-€-Vergleichswert nur in der Copy).
  // LEA-560 — Win-back-Banner.
  'acct.winback.title': 'Je welkom-terug-aanbod',
  'acct.winback.body':
    '{plan} met 30% korting voor 3 maanden. De checkout toont prijs en afschrijvingsdatum voordat er iets gebeurt.',
  'acct.winback.cta': 'Naar de checkout',
  'acct.winback.starting': 'Openen …',

  // LEA-524 — Pausendauer + Wiederaufnahme-Datum.
  'acct.cancel.save.offerTitle': 'Voordat je opzegt — misschien past een van deze beter',
  'acct.cancel.save.offerSub': 'Geen druk. Opzeggen blijft één klik weg.',
  'acct.cancel.pauseMonthsLabel': 'Pauzeren voor',
  'acct.cancel.pauseMonths1': '1 maand',
  'acct.cancel.pauseMonths': '{n} maanden',
  'acct.cancel.pauseResumeHint':
    'Je abonnement loopt op {date} automatisch door — vanaf dan wordt er weer afgeschreven.',
  'acct.cancel.pausedDetailUntil':
    'Er wordt niets afgeschreven. Je behoudt toegang en je resterende credits. Je abonnement loopt op {date} automatisch door; je kunt altijd eerder hervatten.',
  'acct.cancel.pausedNoteUntil':
    'Gepauzeerd tot {date}, geen afschrijving. Je credits blijven bruikbaar.',

  'acct.cancel.trial.vipTitle': 'Janik richt je account persoonlijk in',
  'acct.cancel.trial.vipBody':
    'Doelgroepen, zoekprofielen, eerste zoekopdrachten — de oprichter richt je account persoonlijk met je in. Een dienst ter waarde van € 990 — gratis voor jou als je de test voortzet.',
  'acct.cancel.trial.vipCta': 'Persoonlijke inrichting aanvragen',
  'acct.cancel.trial.vipRequesting': 'Aanvragen …',
  'acct.cancel.trial.vipDoneTitle': 'Aanvraag verstuurd',
  'acct.cancel.trial.vipDoneBody':
    'Janik neemt binnen 24 uur persoonlijk contact met je op. Je proefperiode loopt gewoon door — er is niets opgezegd en niets afgeschreven.',

  'acct.cancel.save.discountTitle': '30% korting voor de komende 3 maanden',
  'acct.cancel.save.discountBody':
    'Blijf en betaal drie maanden lang 30% minder — de korting staat direct op je abonnement, je kaart blijft zoals hij is, geen nieuwe checkout.',
  'acct.cancel.save.discountCta': '30% korting activeren',
  'acct.cancel.save.discounting': 'Activeren …',
  'acct.cancel.save.discountDoneTitle': 'Korting is actief',
  'acct.cancel.save.discountDoneBody':
    'Je volgende drie maandfacturen zijn 30% lager. Daarna loopt je abonnement door tegen de normale prijs — opzeggen kan nog altijd met één klik.',

  'acct.cancel.trial.interceptTitle': 'Wacht even — je proefperiode loopt nog tot {date}.',
  'acct.cancel.trial.interceptTitleNoDate': 'Wacht even — je proefperiode loopt nog.',
  'acct.cancel.trial.interceptSub': 'Tot dan wordt er niets in rekening gebracht.',
  'acct.cancel.trial.reminderTitle': 'We herinneren je op tijd',
  'acct.cancel.trial.reminderBody':
    'Je hoeft niets te noteren of te onthouden. We mailen je 24 uur voordat het afloopt — en als je niet verder wilt, zeg je direct vanuit die e-mail op.',
  'acct.cancel.trial.reminderPointMail': 'De opzeglink staat direct in de e-mail.',
  'acct.cancel.trial.reminderPointNoCharge': 'Daarvoor wordt er niets afgeschreven.',
  'acct.cancel.trial.reminderCta': 'Doorgaan & herinner me',
  'acct.cancel.trial.keepTestingCta': 'Verder testen',
  'acct.cancel.trial.reminderSaving': 'Activeren …',
  'acct.cancel.trial.reminderDoneTitle': 'Herinnering staat aan',
  'acct.cancel.trial.reminderDoneBody':
    'We mailen je op {date} — 24 uur voordat je proefperiode afloopt, met de opzeglink direct in de e-mail.',
  'acct.cancel.trial.reminderDoneBodyNoDate':
    'We mailen je 24 uur voordat je proefperiode afloopt, met de opzeglink direct in de e-mail.',
  'acct.cancel.trial.cancelNowLink': 'Nu definitief opzeggen',
  'acct.cancel.trial.confirm.endsNow': 'Je proeftoegang stopt direct — niet pas op de einddatum.',
  'acct.cancel.trial.confirm.forfeits': 'Je zoekprofielen en resterende credits vervallen.',
  'acct.cancel.trial.confirm.noCharge': 'Er wordt niets in rekening gebracht.',
  'acct.cancel.trial.done.title': 'Proefperiode beëindigd',
  'acct.cancel.trial.done.body':
    'Je proefperiode is beëindigd en er is niets in rekening gebracht. Bedenk je je, dan kun je altijd een abonnement starten.',

  'acct.cancel.trigger': 'Abonnement opzeggen',
  'acct.cancel.manageHint': 'Abonnement beheren',
  'acct.cancel.scheduledTitle': 'Opzegging gepland',
  'acct.cancel.scheduledDetail':
    'Je abonnement eindigt op {date}. Tot dan behoud je volledige toegang.',
  'acct.cancel.reactivate': 'Opzegging ongedaan maken',
  'acct.cancel.reactivating': 'Wordt ongedaan gemaakt …',
  'acct.cancel.restored': 'Abonnement hersteld, je plan loopt door.',
  'acct.cancel.title': 'Abonnement opzeggen',
  'acct.cancel.stepOf': 'Stap {n} van {total}',
  'acct.cancel.reasonTitle': 'Waarom zeg je op?',
  'acct.cancel.reasonSub': 'Optioneel: je antwoord helpt ons om Leadscraper beter te maken.',
  'acct.cancel.reason.too_expensive': 'Te duur',
  'acct.cancel.reason.too_few_leads': 'Te weinig (goede) leads',
  'acct.cancel.reason.wrong_contacts': 'Verkeerde contactpersonen',
  'acct.cancel.reason.unreliable_data': 'E-mails/contactgegevens onbetrouwbaar',
  'acct.cancel.reason.too_complicated': 'Te ingewikkeld',
  'acct.cancel.reason.missing_feature': 'Er ontbreekt een functie',
  'acct.cancel.reason.temporary_only': 'Alleen tijdelijk nodig',
  'acct.cancel.reason.switched_tool': 'Overstap naar een andere tool',
  'acct.cancel.reason.other': 'Overig',
  'acct.cancel.freeTextPlaceholder': 'Vertel ons meer (optioneel) …',
  'acct.cancel.save.downgradeTitle': 'Misschien past een kleiner plan?',
  'acct.cancel.save.downgradeBody':
    'In plaats van opzeggen kun je overstappen naar een goedkoper plan: je behoudt je credits en betaalt vanaf de volgende cyclus minder.',
  'acct.cancel.save.downgradeCta': 'Goedkopere plannen bekijken',
  'acct.cancel.save.downgradeOffer':
    'Stap over naar {plan}: €{price}/mnd · {leads} leads/maand. Je behoudt je credits en betaalt vanaf de volgende cyclus minder.',
  'acct.cancel.save.downgradeCtaPlan': 'Overstappen naar {plan}',
  'acct.cancel.save.downgrading': 'Wordt gewijzigd …',
  'acct.cancel.save.seeAllPlans': 'Alle plannen bekijken',
  'acct.cancel.save.helpTitle': 'Laten we het rechtzetten',
  'acct.cancel.save.helpBody':
    'We verbeteren veel hiervan momenteel actief. Vertel ons kort wat er ontbrak: we kunnen je zoekopdracht vaak snel bijstellen.',
  'acct.cancel.confirm.accessUntil': 'Je behoudt volledige toegang tot {date}.',
  'acct.cancel.confirm.noCharge': 'Daarna worden er geen bedragen meer in rekening gebracht.',
  'acct.cancel.confirm.reactivate': 'Je kunt de opzegging op elk moment daarvoor ongedaan maken.',
  'acct.cancel.audit.title': 'Nog één ding (optioneel)',
  'acct.cancel.audit.sub': 'Wat werkte, wat niet? Het vloeit rechtstreeks in verbeteringen.',
  'acct.cancel.audit.rightCompanies': 'De juiste bedrijven?',
  'acct.cancel.audit.rightContacts': 'De juiste contactpersonen?',
  'acct.cancel.audit.contactDataUsable': 'E-mail/telefoon/LinkedIn bruikbaar?',
  'acct.cancel.audit.enoughLeads': 'Genoeg leads?',
  'acct.cancel.audit.helpedWin': 'Heeft het je geholpen klanten te winnen?',
  'acct.cancel.audit.good': 'Goed',
  'acct.cancel.audit.bad': 'Slecht',
  'acct.cancel.lead.title': 'Welke lead stelde je teleur? (optioneel)',
  'acct.cancel.lead.sub':
    'Als één specifieke lead niet klopte, helpt het ons het meest als je hem noemt.',
  'acct.cancel.lead.pick': 'Kies een lead',
  'acct.cancel.lead.loading': 'Wordt geladen …',
  'acct.cancel.lead.none': 'Geen afgeleverde leads gevonden.',
  'acct.cancel.cf.title': 'Help ons het beter te doen (optioneel)',
  'acct.cancel.cf.gapPlaceholder': 'Wat had je nodig dat wij niet konden leveren?',
  'acct.cancel.cf.toolPlaceholder': 'Stap je over naar een andere tool? Welke?',
  'acct.cancel.cf.betterPlaceholder': 'Wat doet die beter?',
  'acct.cancel.justCancel': 'Nu opzeggen',
  'acct.cancel.keep': 'Toch behouden',
  'acct.cancel.next': 'Verder',
  'acct.cancel.back': 'Terug',
  'acct.cancel.stillCancel': 'Toch opzeggen',
  'acct.cancel.confirmBtn': 'Opzegging bevestigen',
  'acct.cancel.confirming': 'Wordt opgezegd …',
  'acct.cancel.done.title': 'Opzegging bevestigd',
  'acct.cancel.done.body':
    'Je abonnement eindigt op {date}. Tot dan heb je volledige toegang, en je kunt de opzegging op elk moment daarvoor ongedaan maken.',
  'acct.cancel.done.close': 'Sluiten',
  'acct.cancel.save.pauseTitle': 'Pauzeren in plaats van opzeggen?',
  'acct.cancel.save.pauseBody':
    'Bevries je abonnement in plaats van op te zeggen: geen afschrijvingen, je credits en gegevens blijven behouden, en je kunt op elk moment met één klik hervatten.',
  'acct.cancel.save.pauseCta': 'Abonnement pauzeren',
  'acct.cancel.save.pausing': 'Wordt gepauzeerd …',
  'acct.cancel.pauseTrigger': 'Pauzeren',
  'acct.cancel.pausing': 'Wordt gepauzeerd …',
  'acct.cancel.pausedBadge': 'Gepauzeerd',
  'acct.cancel.pausedNote':
    'Abonnement gepauzeerd, geen afschrijvingen. Je credits blijven bruikbaar.',
  'acct.cancel.pausedTitle': 'Abonnement gepauzeerd',
  'acct.cancel.pausedDetail':
    'Er worden geen bedragen afgeschreven. Je behoudt toegang en je resterende credits. Hervat op elk moment.',
  'acct.cancel.resume': 'Abonnement hervatten',
  'acct.cancel.resuming': 'Wordt hervat …',
  'billing.errorRetry': 'Opnieuw proberen',
  'billing.transientError': 'Tijdelijk niet beschikbaar. Probeer het zo meteen opnieuw.',
  'billing.downgradeScheduled':
    'Planwijziging gepland: je gaat op {date} over naar {plan}. Je credits blijven behouden.',
  'billing.downgradeAlready': 'Een wijziging naar {plan} is al gepland voor {date}.',
  'dash.run.suggHeading': 'Voorbeeldzoekopdrachten voor jouw bedrijf',
  'dash.run.intent.broad': 'Klassiek',
  'dash.run.intent.growth': 'Groeisignaal',
  'dash.run.intent.tool': 'Tool-signaal',
  'dash.run.intent.default': 'Suggestie',
  'dash.run.costPreview': 'tot {n} credits',
  'det.sourcesPending':
    'Het bronbewijs voor deze lead wordt nog samengesteld: het verschijnt hier zodra het geverifieerd is.',
  'ld.contact.emailCopied': 'E-mailadres gekopieerd.',
  'ld.contact.phoneCopied': 'Telefoonnummer gekopieerd.',
  'ld.contact.copy': 'Kopiëren',
  'ld.contact.copied': 'Gekopieerd.',
  'ld.contact.tagCentral': 'Centrale',
  'ld.contact.tagUnconfirmed': 'onbevestigd',
  'ld.contact.tagPattern': 'Patroon',
  'ld.contact.centralTooltip': 'Directe lijn niet openbaar: bel en vraag naar {name}.',
  'ld.contact.centralTooltipNoName': 'Directe lijn niet openbaar: dit komt uit bij de centrale.',
  'ld.contact.verifiedSmtp': 'E-mailpostvak bevestigd (SMTP).',
  'ld.contact.unverifiedHint': 'Overgenomen uit een openbare bron, nog niet SMTP-gecontroleerd.',
  'ld.contact.patternTooltip':
    'Waarschijnlijk adres op basis van het e-mailpatroon van het bedrijf, onbevestigd.',
  'ld.contact.derivePattern': 'E-mail afleiden uit bedrijfspatroon',
  'ld.contact.bestRoute': 'Beste route:',
  'ld.contact.route.central': 'Bellen via de centrale',
  'ld.contact.route.centralEmail': 'E-mail naar de centrale',
  'ld.contact.route.linkedin': 'LinkedIn-bericht',
  'ld.contact.route.xing': 'Xing-bericht',
  'ld.contact.route.phone': 'Bellen (directe lijn)',
  'ld.contact.route.email': 'E-mail',
  'ld.contact.route.pattern': 'E-mail via bedrijfspatroon',
  'ld.contact.provMailbox': 'Postvak bevestigd',
  'ld.contact.provImpressum': 'Genoemd in het Impressum',
  'ld.contact.provFound': 'Gevonden in openbare bronnen',
  'ld.contact.provVia': 'bevestigd via',
  'ld.contact.confHigh': 'Hoog',
  'ld.contact.confMid': 'Gemiddeld',
  'ld.contact.confLow': 'Laag',
  'ld.contact.photoVia': 'Foto: {src} ↗',
  'ld.contact.roleProof': 'Rol openbaar bevestigd ↗',
  'ld.section.roleFallback':
    'Gewenste rol ({roles}) is niet openbaar bevestigd: we tonen de eerstvolgende beste contactpersonen.',
  'ld.section.noDirect': 'Directe contacten zijn hier niet openbaar, bereikbaar via de centrale.',
  'lt.expH.legalForm': 'Rechtsvorm',
  'lt.expH.street': 'Straat',
  'lt.expH.zip': 'Postcode',
  'lt.expH.website': 'Website',
  'lt.expH.vatId': 'Btw-nummer',
  'lt.expH.hr': 'Handelsregister',
  'lt.expH.founded': 'Opgericht',
  'lt.expH.size': 'Medewerkers',
  'lt.expH.revenue': 'Omzet-range',
  'lt.expH.description': 'Beschrijving',
  'lt.expH.techStack': 'Tech stack',
  'lt.expH.triggers': 'Signalen/Triggers',
  'lt.expH.scoreCompany': 'Bedrijfs-fit-score',
  'lt.expH.scoreData': 'Datakwaliteit',
  'lt.expH.seniority': 'Senioriteit',
  'lt.expH.department': 'Afdeling',
  'lt.expH.phone': 'Telefoon',
  'lt.expH.linkedin': 'LinkedIn',
  'lt.expH.xing': 'Xing',
  'lt.expH.qualification': 'Kwalificatie',
  'lt.expH.confidence': 'Betrouwbaarheid',
  'lt.expH.channel': 'Aanbevolen kanaal',
  'lt.filter.all': 'Alle',
  'lt.filter.torate': 'Te beoordelen',
  'lt.filter.identified': 'Bedrijf aangemaakt',
  'lt.filter.connected': 'Met contactpersonen',
  'lt.filter.planned': 'Plan klaar',
  'lt.filter.archived': 'Gearchiveerd',
  'lt.view.list': 'Lijst',
  'lt.view.listSubheader': 'Tabel: alle kolommen zichtbaar',
  'lt.funnel.subheader': 'Funnel: leads gegroepeerd per fase',
  'lt.funnel.addCompany': 'Bedrijf aanmaken',
  'lt.funnel.add': 'Aanmaken',
  'lt.funnel.addTooltip': 'Bedrijf toevoegen via URL · 1 credit',
  'lt.funnel.pullAllContacts': 'Alle contactpersonen ophalen',
  'lt.funnel.empty': 'Nog geen leads in deze fase',
  'lt.funnel.dropHint': 'Hier neerzetten om de fase te starten',
  'lt.col.planned': 'Acquisitieplan klaar',
  'lt.card.new': 'Nieuw',
  'lt.card.viewPlan': 'Plan bekijken',
  'lt.card.findContacts': 'Contactpersonen vinden',
  'lt.card.createPlan': 'Acquisitieplan maken',
  'lt.card.contactsCount': '{n} contactpersonen',
  'lt.card.fitTooltip': 'Fit {score}%: hoe goed dit bedrijf bij jouw doelgroep past',
  'lt.card.noContacts': 'Nog geen contactpersonen',
  'lt.card.noJustification':
    'Nog geen Cortex-onderbouwing: de lead wordt bij de volgende run verrijkt.',
  'lt.card.rejectTitle': 'Als niet passend markeren',
  'lt.card.rejectAria': '{company} als niet passend markeren',
  'lt.card.openWebsite': '{website} openen',
  'lt.manual.verifyingDesc': 'Website wordt geverifieerd, basisgegevens worden geëxtraheerd …',
  'lt.manual.addedDesc':
    'Via URL aangemaakt: branche, adres en contactgegevens worden tijdens de verificatie aangevuld.',
  'lt.phaseChip.identified': 'Aangemaakt',
  'lt.phaseChip.connected': 'Contactpersonen',
  'lt.phaseChip.planned': 'Plan klaar',
  'nav.matchRateMin': 'Trefferquote wordt vanaf 5 beoordelingen getoond',
  'notif.review.bodyAll': '{n} onbeoordeelde leads in {m} doelgroepen.',
  'price.ctaDowngradeScheduled': 'Wijziging al gepland',
  'run.startFailed': 'De zoekopdracht kon niet worden gestart. Probeer het opnieuw.',
  'email.subscription-paused.subject': 'Je abonnement is gepauzeerd',
  'email.subscription-paused.badge': 'Abonnement gepauzeerd',
  'email.subscription-paused.hero': 'Je abonnement<br>staat op pauze.',
  'email.subscription-paused.detail.plan_label': 'Abonnement',
  'email.subscription-paused.detail.until_label': 'Gepauzeerd tot',
  'email.subscription-paused.preheader': 'Geen afschrijvingen tot {{pause_ends_at}}.',
  'email.subscription-paused.greeting': 'Hoi {{first_name}},',
  'email.subscription-paused.intro':
    'je {{plan_name}}-abonnement is nu gepauzeerd. Er wordt niets afgeschreven tot {{pause_ends_at}}.',
  'email.subscription-paused.access':
    'Je behoudt volledige toegang en je resterende credits: je ontvangt alleen geen nieuwe maandelijkse credits.',
  'email.subscription-paused.resume_note':
    'Op {{pause_ends_at}} wordt je abonnement automatisch hervat. Je kunt het op elk moment daarvoor zelf hervatten of opzeggen.',
  'email.subscription-paused.button': 'Abonnement beheren',
  'email.subscription-paused.signoff': 'Tot snel, het Leadscraper-team',
  'email.subscription-pause-ending.subject': 'Je abonnement wordt binnenkort hervat',
  'email.subscription-pause-ending.preheader': 'Je pauze eindigt op {{resumes_at}}.',
  'email.subscription-pause-ending.greeting': 'Hoi {{first_name}},',
  'email.subscription-pause-ending.intro':
    'even een herinnering: je pauze eindigt op {{resumes_at}}. Je {{plan_name}}-abonnement wordt dan automatisch hervat.',
  'email.subscription-pause-ending.charge_note':
    'Vanaf dan loopt de facturatie weer normaal. Als je liever niet hervat, kun je vóór die datum opzeggen.',
  'email.subscription-pause-ending.button': 'Abonnement beheren',
  'email.subscription-pause-ending.signoff': 'Het Leadscraper-team',
  'scraper.sum.recallUnverified':
    '{n}/10 leads geleverd: de AI-onderzoeker was voldoende, daarom is de brede webzoekopdracht overgeslagen. De markt kan veel groter zijn dan de {total} tot nu toe gevonden bedrijven.',
  'scraper.sum.recallUnverifiedRec':
    'Dit is geen dunne markt. Het is een overgeslagen zoekopdracht. We verbreden de discovery om de echte marktomvang te meten.',
  'scraper.sum.supplyExhausted':
    '{n}/10 leads geleverd: {dropped} extra treffers had je al ontvangen bij eerdere zoekopdrachten en zijn als duplicaten weggefilterd. De markt is niet dun; je hebt simpelweg al het merendeel van de bedrijven ontvangen die we momenteel kunnen vinden.',
  'scraper.sum.supplyExhaustedRec':
    'Normaal bij terugkerende zoekopdrachten: nieuwe bedrijven komen er na verloop van tijd bij. Voor meer vers volume: kies een bredere regio of verwante branches.',
  'det.emailPatternExampleTag': 'Voorbeeld',
  'det.emailPatternLockedHint':
    'Wordt voor dit bedrijf bepaald wanneer je de contactpersonen verifieert.',
  'det.email.verified': 'geverifieerd',
  'det.email.unverified': 'niet geverifieerd',
  'det.linkedinProfile': 'LinkedIn-profiel',
  'det.xingProfile': 'Xing-profiel',
  // --- Autopilot-Modus (Port aus feat/autopilot-setup-experience) ---
  'autopilot.act.title': 'Recent gebeurd',
  'autopilot.appr.action': 'Goedkeuren',
  'autopilot.appr.givenShort': 'Goedgekeurd',
  'autopilot.appr.opsShort': 'Door ons goedgekeurd',
  'autopilot.appr.opsFeedback':
    'Dit hebben we gecontroleerd en goedgekeurd, je hoeft niets te doen. Als het voor jou klopt, kun je het hier bevestigen. Wijzigingen graag direct aan je contactpersoon.',
  'autopilot.appr.opsNoAction':
    'Dit hebben we gecontroleerd en goedgekeurd, je hoeft niets te doen. Wijzigingen graag direct aan je contactpersoon.',
  'autopilot.appr.opsChanged':
    'De inhoud is gewijzigd sinds je feedback van {date}. We hebben de huidige versie gecontroleerd en goedgekeurd.',
  'autopilot.appr.opsConfirm': 'Klopt voor mij',
  'autopilot.appr.opsConfirmAsk': 'Feedback opslaan?',
  'autopilot.appr.opsDone': 'Bedankt, je feedback is opgeslagen.',
  'autopilot.appr.opsAllDone': 'Alles is goedgekeurd. Valt je iets op, laat het ons gewoon weten.',
  'autopilot.appr.launchHintOps':
    'We keuren de start goed zodra doelgroep, berichten en antwoordafhandeling gecontroleerd zijn.',
  'autopilot.camp.readonlyOps':
    'Wil je iets wijzigen? Laat het je contactpersoon weten, wij passen het aan.',
  'autopilot.appr.pvShow': 'Bekijken',
  'autopilot.appr.pvHide': 'Inklappen',
  'autopilot.appr.pvShowFirst': 'Bekijk eerst wat je goedkeurt',
  'autopilot.appr.pvHeading': 'Dit keur je goed',
  'autopilot.appr.pvSampleTitle': 'Voorbeeld van doelbedrijven',
  'autopilot.appr.pvSampleFoot':
    'Een steekproef uit je doelgroep — de volledige lijst zie je tijdens de uitvoering.',
  'autopilot.appr.pvEmpty': 'De inhoud wordt voor je voorbereid.',
  'autopilot.appr.pvFirms': '{n} bedrijven',
  'autopilot.appr.pvPace': '{n}/dag',
  'autopilot.appr.pvStart': 'Direct',
  'autopilot.appr.pvWait': '+{d} dagen',
  'autopilot.appr.pvSubject': 'Onderwerp:',
  'autopilot.appr.pvAb': 'A/B-variant:',
  'autopilot.appr.pvLaunchReady':
    'Alle inhoud is goedgekeurd — bij de start gaat de eerste mail eruit.',
  'autopilot.appr.pvLaunchWait':
    'De start komt vrij zodra de drie goedkeuringen hierboven er zijn.',
  'autopilot.appr.allDone':
    'Alles goedgekeurd — we starten je campagne en laten het weten zodra deze actief is.',
  'autopilot.appr.confirmAsk': 'Definitief goedkeuren?',
  'autopilot.appr.copy': 'Aanschrijving & sequentie',
  'autopilot.appr.copyHint':
    'Je mails, kant-en-klaar geformuleerd — je ziet echte voorbeelden, geen sjablonen.',
  'autopilot.appr.done': 'Goedkeuring geregistreerd — met tijdstempel en controlesom.',
  'autopilot.appr.error': 'Goedkeuring mislukt — probeer het opnieuw.',
  'autopilot.appr.given': 'Goedgekeurd op {date}',
  'autopilot.appr.hash': 'Controlesom',
  'autopilot.appr.icp': 'Doelgroep & segment',
  'autopilot.appr.icpHint': "Wie je engine benadert — branches, regio's, beslissers.",
  'autopilot.appr.intro':
    'Jij geeft goedkeuring, wij voeren uit. Elke goedkeuring wordt vastgelegd — jij houdt de controle over doelgroep, inhoud en start.',
  'autopilot.appr.launch': 'Campagnestart',
  'autopilot.appr.launchHint':
    'Jouw definitieve akkoord — pas daarna verlaat de eerste mail het huis.',
  'autopilot.appr.locked': 'Wordt vrijgegeven zodra de andere goedkeuringen binnen zijn',
  'autopilot.appr.logIntro':
    'Elke goedkeuring wordt met tijdstempel vastgelegd; de goedgekeurde inhoud wordt bevroren en met een controlesom verankerd.',
  'autopilot.appr.logTitle': 'Goedkeuringslogboek',
  'autopilot.appr.pending': 'Wacht op jou',
  'autopilot.appr.preparingShort': 'In voorbereiding',
  'autopilot.appr.preparing':
    'De inhoud wordt voorbereid — je krijgt bericht zodra je kunt goedkeuren.',
  'autopilot.appr.playbook': 'Antwoord-playbook',
  'autopilot.appr.playbookHint': 'Hoe we vragen namens jou beantwoorden, voordat we overdragen.',
  'autopilot.appr.soon': 'Inhoud wordt momenteel voor je voorbereid',
  'autopilot.appr.title': 'Jouw goedkeuringen',
  'autopilot.camp.approvedAt': 'Door jou goedgekeurd op {date}',
  'autopilot.camp.approvedShort': 'Goedgekeurd — start volgt',
  'autopilot.camp.audience': 'Doelgroep',
  'autopilot.camp.audienceN': '{n} bedrijven in segment',
  'autopilot.camp.awaitApproval': 'Wacht op jouw goedkeuring om te lanceren',
  'autopilot.camp.back': 'Alle campagnes',
  'autopilot.camp.chip.paused': 'Gepauzeerd',
  'autopilot.camp.chip.running': 'Actief',
  'autopilot.camp.chip.scheduled': 'Gepland',
  'autopilot.camp.hideMail': 'Inklappen',
  'autopilot.camp.nextSend': 'Volgende verzending {when}',
  'autopilot.camp.open': 'Bekijken',
  'autopilot.camp.pace': 'tot {n} mails/dag via jouw mailboxen',
  'autopilot.camp.progress': '{done} van {total} bedrijven aangeschreven',
  'autopilot.camp.queue': '{n} gecontroleerde bedrijven in voorraad',
  'autopilot.camp.readonly':
    'Wil je iets wijzigen? Laat het je contactpersoon weten — elke wijziging gaat pas live na jouw goedkeuring.',
  'autopilot.camp.runningSince': 'actief sinds {date}',
  'autopilot.camp.sReplies': '{n} reacties',
  'autopilot.camp.sSent': '{n} verstuurd',
  'autopilot.camp.sectionRunning': 'Loopt nu',
  'autopilot.camp.sending': 'Verzending',
  'autopilot.camp.sequence': 'De sequentie',
  'autopilot.camp.sequenceHint':
    'Elke mail is uniek — de {{variabelen}} vult de engine per bedrijf individueel in.',
  'autopilot.camp.showMail': 'Mail bekijken',
  'autopilot.camp.startsAt': 'Start {when}',
  'autopilot.camp.stepStart': 'Start van de sequentie',
  'autopilot.camp.stepWait': '+{n} dagen daarna',
  'autopilot.camp.subject': 'Onderwerp',
  'autopilot.contact.hint': 'Directe lijn, geen ticketsysteem. De noodstop staat onder Vrijgaven.',
  'autopilot.contact.title': 'Je contactpersoon',
  'autopilot.contact.write': 'Bericht schrijven',
  'autopilot.end.testing': 'Momenteel in test: {label}',
  'autopilot.exp.empty':
    'Zodra je engine test-hypotheses uitvoert, zie je hier wat er getest wordt — en waarom.',
  'autopilot.exp.since': 'sinds {date}',
  'autopilot.exp.title': 'Experimenten',
  'autopilot.foot.details': 'Details in Techniek',
  'autopilot.foot.quota': 'Quotum {used}/{target}',
  'autopilot.health.amber': 'Wordt in de gaten gehouden',
  'autopilot.health.blacklistOk': 'Blacklists schoon',
  'autopilot.health.bounce': 'Bounce-rate {n}%',
  'autopilot.health.green': 'Alle systemen groen',
  'autopilot.health.red': 'We pakken het aan',
  'autopilot.health.suppressed': '{n} afmeldingen gerespecteerd, campagnebreed geblokkeerd',
  'autopilot.health.title': 'Systeemstatus',
  'autopilot.hist.campaigns': 'Afgerond',
  'autopilot.hist.completed': 'afgerond',
  'autopilot.hist.emptyHint':
    'Zodra je eerste campagne loopt, verzamelen zich hier campagne-overzichten en de resultaten van afgeronde tests.',
  'autopilot.hist.emptyTitle': 'Nog geen geschiedenis',
  'autopilot.hist.intro':
    'Wat er nu loopt, wat er gelopen heeft — en wat je engine daarvan geleerd heeft. Bekijk en klik door; de sturing verloopt via jouw goedkeuringen.',
  'autopilot.hist.ongoing': 'actief',
  'autopilot.hist.running': 'actief',
  'autopilot.hist.steps': '{n} sequentiestappen',
  'autopilot.hist.tests': 'Afgeronde tests',
  'autopilot.hist.tie': 'Gelijkspel',
  'autopilot.hist.title': 'Campagnes',
  'autopilot.hist.vs': 'tegen',
  'autopilot.ho.none': 'Geen openstaande overdrachten — de engine werkt door.',
  'autopilot.ho.title': 'Warme overdrachten',
  'autopilot.infra.dns': 'E-mailauthenticatie ingericht (SPF · DKIM · DMARC)',
  'autopilot.infra.domain': 'Verzenddomein geregistreerd — op jouw naam',
  'autopilot.infra.mailboxes': 'Postbussen ingericht',
  'autopilot.infra.title': 'Jouw infrastructuur',
  'autopilot.infra.verify': 'Domein geverifieerd en vrijgegeven voor verzending',
  'autopilot.infra.yourTask': 'Jouw taak',
  'autopilot.setup.title': 'Je engine wordt gebouwd',
  'autopilot.setup.intro': 'Wat we nu voor je opzetten — elke stap gedocumenteerd.',
  'autopilot.setup.ev.domain_registered':
    'Verzenddomein {domain} geregistreerd — op naam van je bedrijf, jij bent de eigenaar.',
  'autopilot.setup.ev.dns_shield':
    'DNS-veiligheidsnet voor {domain} actief: afzenderverificatie (SPF · DKIM · DMARC) en anti-spoofingbescherming.',
  'autopilot.setup.ev.redirect_live':
    '{domain} leidt bezoekers nu rechtstreeks naar {target} — volledige transparantie voor elke ontvanger.',
  'autopilot.setup.ev.mailboxes_created':
    '{n} mailboxen ingericht op {domain}, beveiligd en versleuteld.',
  'autopilot.setup.ev.warmup_started':
    'Opwarmnetwerk gestart: {n} mailboxen bouwen dag na dag bezorgreputatie op.',
  'autopilot.setup.ev.warmup_progress':
    'Opwarmfase dag {day} van {total} — {rate}% inbox-plaatsing in het netwerk.',
  'autopilot.setup.ev.blacklist_clean':
    'Reputatiecheck: {n} blokkadelijsten gecontroleerd — alles schoon.',
  'autopilot.kpi.contacted': 'Benaderd',
  'autopilot.kpi.delivered': 'Afgeleverd',
  'autopilot.kpi.handovers': 'Overdrachten',
  'autopilot.kpi.lockedHint': 'Cijfers verschijnen zodra je campagne loopt.',
  'autopilot.kpi.modulePrice': 'Module: {price}/maand',
  'autopilot.kpi.replies': 'Reacties',
  'autopilot.kpi.won': 'Gewonnen',
  'autopilot.kpi.wonValueLabel': 'Gewonnen orderwaarde',
  'autopilot.mb.empty': 'Je postbussen worden momenteel ingericht.',
  'autopilot.mb.hint':
    'Warmup loopt continu — ook tijdens live gebruik houdt een lage basis de afleverbaarheid hoog.',
  'autopilot.mb.perDay': '{n} mails/dag',
  'autopilot.mb.score': 'Afleverbaarheid',
  'autopilot.mb.st.connecting': 'wordt verbonden',
  'autopilot.mb.st.ready': 'gereed',
  'autopilot.mb.st.sending': 'actief · onderhouds-warmup',
  'autopilot.mb.st.warmup': 'Warmup · Dag {d}/{total}',
  'autopilot.mb.title': 'Postbussen & Warmup',
  'autopilot.mb.count': '{active} van {total} actief',
  'autopilot.mb.scoreLabel': 'Bezorgscore',
  'autopilot.mode.autopilot': 'Autopilot',
  'autopilot.mode.lockedHint': 'Autopilot is een aanvullende module – meer informatie',
  'autopilot.mode.search': 'Standaard',
  'autopilot.nav.history': 'Campagnes',
  'autopilot.nav.overview': 'Dashboard',
  'autopilot.nav.replies': 'Kanban',
  'autopilot.nav.tech': 'Techniek',
  'autopilot.notActive.hint': 'Als je Autopilot wilt gebruiken, neem dan contact met ons op.',
  'autopilot.notActive.title': 'Autopilot is niet actief voor dit account',
  'autopilot.ov.activeTitle': 'Je engine is aan het werk',
  'autopilot.ov.awaitCta': 'Naar de goedkeuringen',
  'autopilot.ov.awaitHint':
    'Alleen je goedkeuringen ontbreken nog — daarna starten we de verzending.',
  'autopilot.ov.awaitTitle': 'Je engine is klaar om te starten',
  'autopilot.ov.endedTitle': 'Autopilot beëindigd',
  'autopilot.ov.engineTitle': 'Jouw Engine',
  'autopilot.ov.offerHint':
    'Zodra het contract rond is, starten we met de inrichting van je engine.',
  'autopilot.ov.offerTitle': 'Je Autopilot wordt voorbereid',
  'autopilot.ov.pausedHint':
    'Er wordt niets verzonden. Neem contact op met je contactpersoon om verder te gaan.',
  'autopilot.ov.pausedTitle': 'Verzending gepauzeerd',
  'autopilot.ov.setupHint':
    'Domein, authenticatie en postbussen worden ingericht — volledig door ons. Jij hoeft niets te doen; we nemen contact op zodra je eerste goedkeuringen klaarstaan.',
  'autopilot.ov.setupTitle': 'We bouwen je engine',
  'autopilot.ov.warmupDay': 'Warmup · Dag {d} van {total}',
  'autopilot.ov.warmupHint':
    'Je postbussen worden voorzichtig opgewarmd, zodat je mails in de inbox belanden — niet in spam. In deze periode kun je je goedkeuringen afronden.',
  'autopilot.ov.warmupTitle': 'Warmup loopt',
  'autopilot.pause.hintContact':
    'Je contactpersoon zet de verzending voor je stop — geef het even door, het gaat meteen in.',
  'autopilot.pause.action': 'Verzending pauzeren',
  'autopilot.pause.hint':
    'Stopt de verzending direct en volledig. Je contactpersoon neemt daarna persoonlijk contact met je op.',
  'autopilot.pause.title': 'Noodstop',
  'autopilot.pause.confirm': 'Echt stoppen?',
  'autopilot.pause.done':
    'Verzending gepauzeerd — je contactpersoon neemt persoonlijk contact met je op.',
  'autopilot.pause.error':
    'Pauzeren is niet gelukt — neem direct contact op met je contactpersoon.',
  'autopilot.pause.pausedHint':
    'De verzending is gepauzeerd. Je contactpersoon neemt persoonlijk contact met je op voordat het verdergaat.',
  'autopilot.pulse.checked': '{n} AI-gecontroleerd',
  'autopilot.pulse.next': 'Volgende verzending {when}',
  'autopilot.pulse.queue': '{n} in voorraad',
  'autopilot.pulse.quiet':
    'Nog geen verzending — de engine wordt opgebouwd. Zodra het start, zie je hier de dagelijkse activiteit.',
  'autopilot.pulse.researched': '{n} onderzocht',
  'autopilot.pulse.sent': '{n} vandaag verzonden',
  'autopilot.pulse.title': 'De engine op dit moment',
  'autopilot.quota.progress': '{used} van ~{target} bedrijven',
  'autopilot.quota.title': 'Contingent deze maand',
  'autopilot.rc.interested': 'Interesse',
  'autopilot.rc.later': 'Later',
  'autopilot.rc.noNeed': 'Geen behoefte',
  'autopilot.rc.ooo': 'Afwezigheid',
  'autopilot.rc.unsub': 'Afmelding',
  'autopilot.rcls.title': 'Reacties per categorie',
  'autopilot.rep.actionFailed': 'Actie mislukt — probeer het opnieuw.',
  'autopilot.rep.call': 'Nu bellen',
  'autopilot.rep.contacted': 'Markeren als overgenomen',
  'autopilot.rep.contactedDone': 'Overgenomen op {date}',
  'autopilot.rep.contactedSet': 'Gemarkeerd als overgenomen — bedankt, dit helpt ons.',
  'autopilot.rep.contactedShort': 'Overgenomen',
  'autopilot.rep.dealPlaceholder': 'Orderwaarde',
  'autopilot.rep.emptyHint':
    'Zodra je campagne loopt, verschijnen hier de reacties van de bedrijven die je hebt benaderd — met volledige geschiedenis en onze inschatting.',
  'autopilot.rep.emptyTitle': 'Nog geen antwoorden',
  'autopilot.rep.intro':
    'Elke reactie komt hier binnen — geclassificeerd en met volledige geschiedenis. Wij verhelderen, jij belt.',
  'autopilot.rep.lostPlaceholder': 'Reden (optioneel)',
  'autopilot.rep.noFit': 'Geen fit',
  'autopilot.rep.noFitSet': 'Gemarkeerd als „geen fit” — jouw Engine leert hiervan.',
  'autopilot.rep.saveClose': 'Opslaan',
  'autopilot.rep.title': 'Antwoorden',
  'autopilot.rep.viewThread': 'Verloop bekijken ({n})',
  'autopilot.rep.threadEmpty': 'Nog geen gespreksverloop.',
  'autopilot.rep.threadSent': 'Verzonden · {step}',
  'autopilot.rep.threadSentPlain': 'Door jou verzonden',
  'autopilot.rep.threadFoot': 'Verzonden in jouw naam. Wijzigingen lopen via je contactpersoon.',
  'autopilot.rep.cls.interested': 'Interesse',
  'autopilot.rep.cls.later': 'Later',
  'autopilot.rep.cls.noNeed': 'Geen behoefte',
  'autopilot.rep.cls.referral': 'Andere contactpersoon',
  'autopilot.rep.cls.question': 'Vraag',
  'autopilot.rep.cls.outOfOffice': 'Afwezig',
  'autopilot.rep.cls.unsubscribed': 'Afmelding',
  'autopilot.rep.wonNoValue': 'Gewonnen',
  'autopilot.rep.wonSet': 'Gewonnen — sterk! De orderwaarde telt mee in je resultaten.',
  'autopilot.report.first':
    'Je volgende rapport komt op {date} — verzonden, afgeleverd, reacties, overdrachten. Geen mooi weer spelen.',
  'autopilot.report.title': 'Maandrapport',
  'autopilot.res.angles': 'Invalshoeken',
  'autopilot.res.anglesHint': 'Met welke opening we het gesprek beginnen.',
  'autopilot.res.emptyHint':
    'Zodra je campagne draait en de eerste reacties binnenkomen, zie je hier wat werkt en wat niet.',
  'autopilot.res.emptyTitle': 'Nog geen resonantie',
  'autopilot.res.footnote':
    'Percentages pas vanaf 30 benaderde bedrijven — daaronder zou een percentage toeval zijn.',
  'autopilot.res.intro':
    'Waar reacties vandaan komen — en waar niemand op reageert. Je engine meet elke aanpak en trekt daar de conclusies uit.',
  'autopilot.res.learnedTitle': 'Wat je engine ermee doet',
  'autopilot.res.segments': 'Segmenten',
  'autopilot.res.segmentsHint': 'Welke branches en functies reageren.',
  'autopilot.res.subjects': 'Onderwerpregels',
  'autopilot.res.subjectsHint': 'Wat geopend en beantwoord wordt.',
  'autopilot.res.thin': 'te weinig data',
  'autopilot.res.title': 'Wat werkt',
  'autopilot.spark.empty': 'Verschijnt zodra de verzending start.',
  'autopilot.spark.title': 'Verzendactiviteit (4 weken)',
  'autopilot.stage.clarify': 'In verheldering',
  'autopilot.stage.handover': 'Overgedragen',
  'autopilot.stage.lost': 'Verloren',
  'autopilot.stage.new': 'Nieuw',
  'autopilot.stage.won': 'Gewonnen',
  'autopilot.status.active': 'Actief',
  'autopilot.status.awaiting': 'Wacht op goedkeuring',
  'autopilot.status.contract': 'Contract ondertekend',
  'autopilot.status.ended': 'Beëindigd',
  'autopilot.status.offer': 'In voorbereiding',
  'autopilot.status.paused': 'Gepauzeerd',
  'autopilot.status.setup': 'Inrichting',
  'autopilot.status.warmup': 'Warmup',
  'autopilot.step.approvals': 'Goedkeuringen',
  'autopilot.step.live': 'Live',
  'autopilot.step.setup': 'Instellen',
  'autopilot.step.warmup': 'Warmup',
  'autopilot.talk.all': 'Alles bekijken',
  'autopilot.talk.empty':
    'Zodra je campagne live is, zie je hier met wie de engine op dat moment spreekt.',
  'autopilot.talk.emptyLive':
    'Op dit moment geen open gesprekken — bij de volgende reactie verschijnt het bedrijf hier.',
  'autopilot.talk.title': 'Actief in gesprek',
  'autopilot.tasks.approvals': '{n} vrijgaven wachten op jou',
  'autopilot.tasks.call1': 'Eén warme overdracht wacht op je telefoontje',
  'autopilot.tasks.calls': '{n} warme overdrachten wachten op je telefoontje',
  'autopilot.tasks.none': 'Niets te tun — de engine werkt voor je.',
  'autopilot.tasks.title': 'Jouw taken',
  'autopilot.tech.allGreen': 'Alles operationeel',
  'autopilot.tech.auto': 'Draait automatisch',
  'autopilot.tech.autoHint':
    'Deze onderhoudstaken lopen op de achtergrond — je hoeft er zelf nooit iets voor te doen.',
  'autopilot.tech.blacklists': 'Blacklist-monitoring',
  'autopilot.tech.clean': 'schoon',
  'autopilot.tech.dmarcReports': 'DMARC-aggregatierapporten actief',
  'autopilot.tech.domains': 'Verzenddomeinen',
  'autopilot.tech.integrations': 'Gekoppelde systemen',
  'autopilot.tech.intro':
    'Je volledige verzendinfrastructuur in één oogopslag — domeinen, DNS-authenticatie, postbussen, monitoring. Wij richten alles in en houden het groen; jij hoeft er niets aan te doen.',
  'autopilot.tech.mailboxes': 'Postbussen & authenticatie',
  'autopilot.tech.nis2': 'Domein bevestigd',
  'autopilot.tech.owner': 'Eigenaar: jij',
  'autopilot.tech.pending':
    'Je infrastructuur wordt momenteel ingericht — hier verschijnt binnenkort je volledige controlecentrum.',
  'autopilot.tech.pipeline': 'De AI-pipeline',
  'autopilot.tech.pipelineHint':
    'Elke afzonderlijke e-mail doorloopt deze onafhankelijke controles voordat deze verzendklaar is.',
  'autopilot.tech.placement': 'Laatste placement-test: {n}% inbox',
  'autopilot.tech.registrar': 'Registrar: {name}',
  'autopilot.tech.rep': 'Reputatie {n}',
  'autopilot.tech.replyLogic': 'Antwoordintelligentie',
  'autopilot.tech.reputation': 'Reputatie & aflevermonitoring',
  'autopilot.tech.ssl': 'TLS/SSL',
  'autopilot.tech.title': 'Techniek & bezorgbaarheid',
  'autopilot.tech.warmup': 'Warmup',
  'autopilot.warm.traffic.weekendShort': 'WE',
  'autopilot.warm.traffic.pauseShort': 'Pauze',
  'autopilot.warm.traffic.weekend':
    'Weekend: het opwarmnetwerk vermindert de activiteit volgens planning',
  'autopilot.warm.traffic.pause': 'Rustdag in het opwarmnetwerk',
  'autopilot.ov.hero.warmOffen':
    'Je postvakken warmen nog op (dag {d} van {total}). Geef nu je goedkeuring, dan starten we zodra ze klaar zijn.',
  'autopilot.ov.hero.warmFrei':
    'Alles is goedgekeurd. Je postvakken warmen nog op (dag {d} van {total}), daarna gaat de eerste mail eruit.',
  'autopilot.ov.hero.fertigOffen':
    'Je postvakken zijn opgewarmd. We wachten alleen nog op je goedkeuringen om te starten.',
  'autopilot.ov.hero.fertigFrei':
    'Opgewarmd en goedgekeurd. We bereiden de eerste verzending voor.',
  'autopilot.ov.hero.startNachFreigabe': 'zodra je je goedkeuring hebt gegeven',
  'autopilot.ov.hero.startInVorbereitung': 'in voorbereiding',
  'autopilot.mb.st.fertig': 'Opgewarmd',
  'autopilot.appr.zf.lead':
    'We benaderen elk bedrijf dat je niet uitsluit. Een vinkje is optioneel en helpt ons begrijpen welke bedrijven je voorkeur hebben.',
  'autopilot.appr.zf.f.alle': 'Alle {n}',
  'autopilot.appr.zf.f.dabei': 'Inbegrepen {n}',
  'autopilot.appr.zf.f.raus': 'Uitgesloten {n}',
  'autopilot.appr.zf.f.ohneKontakt': 'Geen contact {n}',
  'autopilot.camp.offenN': '{n} goedkeuringen open: {liste}',
  'autopilot.camp.offen1': 'Eén goedkeuring open: {liste}',
  'autopilot.appr.zf.neuTitle': 'Nieuw sinds je laatste bezoek',
  'autopilot.appr.zf.g.bekanntHinweis':
    '‘Kennen we al’ haalt het bedrijf blijvend uit je voorstellen, ook in toekomstige campagnes.',
  'autopilot.camp.offenDanach': ', daarna {label}',
  'autopilot.ov.ring.bereit': 'klaar',
  'autopilot.ov.hero.bereitOffen':
    'Startklaar: alle {n} mailboxen scoren minstens {s} op bezorgbaarheid. Alleen je goedkeuringen ontbreken nog.',
  'autopilot.ov.hero.bereitFrei':
    'Startklaar en goedgekeurd. Alle {n} mailboxen scoren minstens {s}; we bereiden de eerste verzending voor.',
  'autopilot.ov.hero.teilOffen':
    '{bereit} van {n} mailboxen zijn startklaar (bezorgscore vanaf {s}). Keur nu goed, dan starten we zodra ze allemaal zover zijn.',
  'autopilot.ov.hero.teilFrei':
    '{bereit} van {n} mailboxen zijn startklaar (bezorgscore vanaf {s}). We starten zodra ze allemaal zover zijn.',
  'autopilot.ov.hero.scoreRegel': 'Bezorgscore per mailbox · startklaar vanaf {s}',
  'autopilot.mb.st.bereit': 'Startklaar',
  'autopilot.mb.st.bereitTeil': '{bereit} van {n} startklaar',
  'autopilot.mb.st.mbBereit': 'startklaar · dag {d}/{total}',
  'autopilot.warm.regel':
    'Een mailbox is startklaar vanaf een bezorgscore van {s}. De {total} dagen zijn een richtlijn, niet de voorwaarde.',
  'autopilot.camp.vs.post': '{n} per post',
  'autopilot.camp.vs.geprueft': '{n} bevestigd',
  'autopilot.camp.vs.ungeprueft': '{n} niet bevestigd',
  'autopilot.camp.vs.zust.ok': 'Adres bevestigd',
  'autopilot.camp.vs.zust.ungeprueft': 'Adres niet bevestigd',
  'autopilot.camp.vs.erkl.geprueft':
    'We controleren elk adres voor verzending. Bevestigd betekent dat de mailserver het heeft geaccepteerd. Niet bevestigd wijst meestal op catch-all, waarbij de server voor elk adres hetzelfde antwoordt.',
  'autopilot.camp.vs.absender': 'Afzender',
  'autopilot.camp.vs.takt': 'Tempo',
  'autopilot.camp.vs.taktWert': '{n} e-mails per dag',
  'autopilot.camp.vs.naechster': 'volgende verzending {when}',
  'autopilot.camp.vs.keinAbsender':
    'Er is nog geen afzenderpostvak aan deze campagne gekoppeld. We stellen dit vóór de start in.',
  'autopilot.camp.vs.hint':
    'Zo gaat de mail eruit. Groen onderstreept: ingevuld uit ons onderzoek. Gestippeld: per persoon ingevuld bij verzending.',
  'autopilot.camp.vs.wartetTitel':
    'Bedrijven zonder gevonden e-mailadres. Ze schuiven automatisch aan zodra een contact met adres is gevonden.',
  'autopilot.camp.vs.empfaenger': 'Ontvangers',
  'autopilot.camp.vs.vorschauFuer': 'Voorbeeld voor',
  'autopilot.camp.vs.an': 'Aan',
  'autopilot.camp.vs.platzhalter': 'per persoon ingevuld bij verzending',
  'autopilot.erkl.aria': 'Hoe wordt dit berekend?',
  'autopilot.erkl.quelle': 'Bron: {q}',
  'autopilot.warm.traffic.title': 'Opwarmverkeer van je postvakken',
  'autopilot.warm.traffic.hint':
    'Uitgaande opwarmmails en opwarmmails die in de inbox zijn geregistreerd, voor al je postvakken.',
  'autopilot.mb.place.hint': 'Opwarm-mails in inbox en spam over al je mailboxen.',
  'autopilot.ov.zu.sub': 'van {n} opwarmmails in de afgelopen 7 dagen',
  'autopilot.warm.scoreChart.title': 'Afleverscore per postvak',
  'autopilot.warm.scoreChart.hint':
    'De band beslaat alle mailboxen, de lijn volgt de zwakste. Startklaar vanaf {s}.',
  'autopilot.warm.scoreChart.perBox': 'per postvak',
  'autopilot.warm.scoreChart.perDomain': 'per domein',
  'autopilot.warm.scoreChart.schwelle': 'klaar om te starten vanaf {s}',
  'autopilot.warm.scoreChart.xHinweis':
    'Elk punt is een opgeslagen scorewijziging, rechts zie je de huidige stand.',
  'autopilot.warm.scoreChart.messpunkt': 'Meetpunt {n}',
  'autopilot.warm.chart.gesendet': 'Verzonden',
  'autopilot.warm.scoreChart.titleDomain': 'Afleverscore per domein',
  'autopilot.warm.scoreChart.hintDomain':
    'De band beslaat je domeinen, de lijn volgt de zwakste. Een mailbox is startklaar vanaf {s}.',
  'autopilot.warm.erkl.traffic':
    'Hier zie je opwarmmails in het lemwarm-netwerk. De cijfers bevatten ook inkomend netwerkverkeer en tonen geen campagneverzendingen.',
  'autopilot.warm.erkl.placement':
    'De waarden tonen waar je opwarmmails terechtkomen, inclusief inkomende mails uit het netwerk. Het inboxpercentage is inbox gedeeld door de som van inbox en spam.',
  'autopilot.warm.erkl.tage':
    'De dagen zijn een richtlijn voor je opwarmperiode; de voorwaarde is een afleverscore van minimaal {s} per postvak.',
  'autopilot.warm.traffic.nochKeineKampagne':
    'Dit is verkeer in het opwarmnetwerk, nog geen campagnemails.',
  'autopilot.warm.placement.vorwoche':
    'Inboxpercentage van de laatste 7 geregistreerde dagen vergeleken met de 7 dagen ervoor.',
  'autopilot.camp.vs.absenderKonto':
    'Deze mailboxen horen bij je account. Welke ervan deze campagne verstuurt, leggen we voor de start vast.',
  'autopilot.camp.vs.quellePruefung': 'e-mailcontrole',
  'autopilot.appr.zf.unvollstaendig':
    'We tonen de nieuwste bedrijven tot de weergavegrens. Oudere staan hier niet bij.',
  'autopilot.appr.zf.ladeFehler':
    'Een deel van je bedrijven kon niet worden geladen. Herlaad de pagina, dan proberen we het opnieuw.',
  'autopilot.warm.scoreChart.schwelleKurz': 'startklaar',
  'autopilot.warm.scoreChart.alle': 'Alle',
  'autopilot.warm.scoreChart.hintEines': 'Verloop van {adresse}. Startklaar vanaf {s}.',
  // LEA-505 — Ein-Klick-Nachkauf von Kontakt-Paketen (Bestätigungskarte + Checkout-Einwilligung)
  'refill.checkoutConsent':
    'Je kaart wordt opgeslagen voor latere aanvullingen met één klik. Er wordt alleen afgeschreven als je een aanvulling voor het getoonde bedrag uitdrukkelijk bevestigt — geen abonnement, geen automatische aanvulling. Je kunt de kaart altijd verwijderen in het klantenportaal.',
  'refill.title': 'Contacten bijkopen',
  'refill.subtitle': 'Met je opgeslagen kaart — zonder omweg via de checkout.',
  'refill.choose': 'Kies een pakket',
  'refill.pack': '{n} contacten',
  'refill.net': '{amount} excl. btw',
  'refill.total': 'Totaal',
  'refill.inclTax': 'incl. {tax} btw',
  'refill.reverseCharge': 'Zonder btw — btw verlegd, de afnemer draagt de btw af.',
  'refill.cardLabel': 'Betaald met {brand} •••• {last4}',
  'refill.cta': 'Nu {amount} betalen',
  'refill.quoting': 'Bedrag wordt berekend …',
  'refill.paying': 'Betaling wordt verwerkt …',
  'refill.terms': 'Eenmalige betaling, geen abonnement. Je contacten verlopen niet.',
  // LEA-518 — first contact-pack purchase (Checkout) for reveal customers
  'packs.first.title': 'Contacten kopen',
  'packs.first.subtitle': 'Kies een pakket en ontgrendel daarmee contacten.',
  'packs.first.balance': 'Beschikbare contacten: {n}',
  'packs.first.popular': 'Populair',
  'packs.first.cta': 'Verder naar betaling',
  'packs.first.redirecting': 'Doorsturen naar Stripe…',
  'packs.first.checkoutNote':
    'Je betaalt in de volgende stap veilig via Stripe en ziet daar het eindbedrag inclusief btw.',
  'packs.first.error': 'De betaling kon niet worden gestart. Probeer het opnieuw.',
  'packs.first.loadError': 'De pakketten konden nu niet worden geladen.',
  'packs.first.retry': 'Opnieuw proberen',
  'refill.success': '{n} contacten bijgeschreven. Nieuw saldo: {balance}.',
  'refill.again': 'Nog een pakket kopen',
  'refill.amountChanged': 'Het bedrag is gewijzigd. Bevestig het nieuwe bedrag.',
  'refill.inProgress': 'Er loopt al een aanvulling. Een ogenblik …',
  'refill.processing': 'De betaling wordt nog verwerkt. We controleren het zo opnieuw.',
  'refill.failedDeclined': 'Je bank heeft de betaling geweigerd. Er is niets afgeschreven.',
  'refill.failedAuth': 'De bevestiging bij je bank is niet afgerond. Er is niets afgeschreven.',
  'refill.failed': 'De betaling is niet uitgevoerd. Er is niets afgeschreven.',
  'refill.error': 'Dat is niet gelukt. Probeer het zo nog eens.',
  'refill.checking': 'We controleren de status van je betaling …',
  'refill.unknown':
    'We konden de betaling nog niet bevestigen. Controleer je saldo voordat je opnieuw koopt.',
  'refill.retryQuote': 'Bedrag opnieuw laden',
  'refill.checkStatus': 'Betaalstatus controleren',

  'auth.register.errPwPolicy':
    'Het wachtwoord is te zwak. Gebruik minstens 8 tekens met hoofdletters, kleine letters, een cijfer en een speciaal teken.',
  'auth.err.emailTaken': 'Dit e-mailadres is al geregistreerd. Log in.',
  'auth.err.rateLimited':
    'Te veel pogingen vanaf deze verbinding. Probeer het over maximaal {minutes} minuten opnieuw.',
  'auth.err.rateLimitedLater': 'Te veel pogingen vanaf deze verbinding. Probeer het later opnieuw.',
  'auth.err.network': 'Geen verbinding met de server. Controleer je internetverbinding.',
  'auth.err.busy': 'De server is momenteel druk. Probeer het zo meteen opnieuw.',
  'auth.err.signupFailed': 'Registratie mislukt. Probeer het zo meteen opnieuw.',
  'auth.err.invalidInput': 'Controleer je invoer.',
  'auth.err.turnstileFailed':
    'De botcontrole is mislukt of verlopen. Laad de pagina opnieuw en probeer het nog eens.',
  'auth.err.turnstileBlocked':
    'De beveiligingscontrole kon niet draaien. Een advertentie- of trackingblokker kan dit tegenhouden: sta challenges.cloudflare.com toe voor deze pagina of probeer een andere browser.',
  'auth.err.popupBlocked':
    'Het inlogvenster is geblokkeerd. Sta pop-ups toe voor deze site en probeer het opnieuw.',
  'auth.err.popupClosed': 'Het inlogvenster is gesloten voordat de aanmelding was voltooid.',
  'auth.err.otherProvider': 'Er bestaat al een account met dit e-mailadres. Log in met {provider}.',
  'auth.err.otherMethod':
    'Er bestaat al een account met dit e-mailadres. Log in zoals je je hebt geregistreerd (Google, Microsoft of e-mail en wachtwoord).',
  'auth.err.providerPassword': 'e-mail en wachtwoord',
  'auth.err.firstName': 'Vul je voornaam in.',
  'auth.err.lastName': 'Vul je achternaam in.',
  'auth.err.pwLong': 'Het wachtwoord is te lang.',
  'auth.err.oauthFailed': 'Aanmelden via de identiteitsprovider is mislukt. Probeer het opnieuw.',
  'auth.err.noEmailFromProvider':
    'We hebben geen e-mailadres van je provider ontvangen. Kies een andere manier om in te loggen.',
  'auth.err.ssoUnavailable':
    'Inloggen met Google of Microsoft is tijdelijk niet beschikbaar. Gebruik e-mail en wachtwoord.',
  'auth.err.accountGone': 'Dit account is verwijderd of gedeactiveerd.',
  'auth.err.sessionFailed': 'De sessie kon niet worden aangemaakt. Probeer het opnieuw.',
  'auth.register.next.prism':
    'Volgende stap: beschrijf je doelgroep en bekijk echte bedrijven. Je betaalt pas wanneer je leads ontgrendelt.',
  'auth.register.next.noCard':
    'Na je registratie kun je direct beginnen. Geen betaalgegevens nodig.',
  'auth.register.next.trial':
    'Volgende stap: kies een pakket en test 3 dagen. Kaart nodig, vandaag € 0; daarna loopt het pakket door, tenzij je vóór het einde van de proefperiode opzegt.',
  'auth.register.next.plan':
    'Volgende stap: kies een pakket. Betaling met kaart is direct verschuldigd.',
  'auth.register.busyHint': 'Je account wordt aangemaakt. Dat duurt enkele seconden.',
  'auth.login.legalSso':
    'Nieuw hier? Inloggen met Google of Microsoft maakt automatisch een account aan en je gaat akkoord met onze {terms}. Informatie over je gegevens vind je in ons {privacy}.',
  'auth.r19.form.pw.title': 'Wachtwoordeisen',
  'auth.r19.form.pw.len': 'Minstens 8 tekens',
  'auth.r19.form.pw.case': 'Hoofdletters en kleine letters',
  'auth.r19.form.pw.digit': 'Een cijfer',
  'auth.r19.form.pw.special': 'Een speciaal teken',
  'auth.r19.form.pw.met': 'voldaan',
  'auth.r19.form.pw.open': 'nog niet voldaan',
  'auth.r19.chat.greeting':
    'Stel je vraag hier. Als je je e-mailadres erbij zet, kunnen we je ook later antwoorden.',
  'auth.r19.chat.failed': 'De chat kan nu niet geopend worden. Mail ons in plaats daarvan op',

  'prism.abandon.fit': 'De bedrijven passen niet',
  'prism.abandon.fitQ': 'Welke bedrijven had je verwacht?',
  'prism.abandon.freeText': 'Of vertel het in één zin…',
  'prism.abandon.later': 'Bekijk ik later',
  'prism.abandon.price': 'De prijs',
  'prism.abandon.q': 'Korte vraag: wat houdt je tegen?',
  'prism.abandon.send': 'Versturen',
  'prism.abandon.skip': 'Overslaan',
  'prism.abandon.thanks': 'Bedankt — dit helpt ons echt.',
  'prism.checkout.autoNote':
    'Wordt automatisch het Starter-abonnement (250 credits/maand) als je niet binnen de 3 proefdagen opzegt.',
  // Prism-Umsatzpaket (16.10.2026): Abo-Satz, Entscheider vor dem Kauf, Hinweise.
  'prism.abo.line':
    '€ 49 vandaag · vanaf dag 4: € 290/maand · maandelijks opzegbaar met één klik',
  'prism.abo.afterDelivery':
    'Elke week ~{n} nieuwe bedrijven. Bij elk bedrijf zoeken we de beslisser, en je betaalt alleen als we die vinden.',
  'prism.abo.afterCredits':
    'Daarna elke maand {credits} credits voor nieuwe bedrijven en contactpersonen.',
  'prism.teaser.tag':
    'Beslisser gratis vooraf',
  'prism.teaser.running':
    'We zoeken nu de beslisser bij {company} …',
  'prism.teaser.foundShort':
    'Beslisser gevonden: {name}',
  'prism.teaser.noneShort':
    'Geen beslisser met bewijs gevonden',
  'prism.teaser.failedShort':
    'Opzoeken lukt nu niet',
  'prism.teaser.open':
    'Bekijken',
  'prism.teaser.close':
    'Inklappen',
  'prism.teaser.role':
    'Functie',
  'prism.teaser.source':
    'Bewijs',
  'prism.teaser.email':
    'E-mail',
  'prism.teaser.src.impressum':
    'Colofon van {domain}',
  'prism.teaser.src.handelsregister':
    'Handelsregister',
  'prism.teaser.src.website':
    'Website van {domain}',
  'prism.teaser.mail.verified':
    'gecontroleerd bij de mailserver',
  'prism.teaser.mail.probable':
    'zeer waarschijnlijk bezorgbaar',
  'prism.teaser.mail.found':
    'staat zo op hun website',
  'prism.teaser.mail.none':
    'geen persoonlijk e-mailadres gevonden',
  'prism.teaser.foundNote':
    'Zo zoeken we elk van je {n} passende bedrijven uit. Het volledige e-mailadres zie je na het vrijgeven, het telefoonnummer waar beschikbaar.',
  'prism.teaser.noneBody':
    'Voor {company} vonden we geen beslisser met bewijs (colofon, handelsregister of eigen website). Liever tonen we niets dan iets te verzinnen.',
  'prism.teaser.noneNote':
    'Na het vrijgeven telt een credit alleen als we een contactpersoon vinden.',
  'prism.teaser.failedBody':
    'Het opzoeken lukte net niet. Na het vrijgeven loopt het voor alle {n} bedrijven.',
  'prism.teaser.cta':
    'Alle {n} vrijgeven',
  'prism.cardHint.body':
    'De beslisser bij {company} zoeken we na het vrijgeven uit: naam en functie, plus e-mail of telefoon als die openbaar zijn.',
  'prism.cardHint.example':
    'Een voorbeeld zie je hierboven bij {top}.',
  'prism.cardHint.cta':
    'Vrijgeven',
  'prism.website.skip':
    'Verder zonder website',
  'prism.website.issue.own_product':
    'Dat is onze site, niet de jouwe. Vul hier de website van je eigen bedrijf in, zodat we begrijpen wat je verkoopt.',
  'prism.website.issue.ai_chat':
    'Dat is een link naar een AI-chat. We hebben de website van je eigen bedrijf nodig, bijv. ‘jouw-bedrijf.nl’.',
  'prism.website.issue.social':
    'Een socialmediaprofiel vertelt ons te weinig over je aanbod. Heb je een eigen website? Sla deze stap anders gewoon over.',
  'prism.website.issue.redirect':
    'Dat is een korte of doorstuurlink. Vul direct het adres van je website in, bijv. ‘jouw-bedrijf.nl’.',
  'prism.notice.title':
    'Even over de data',
  'prism.notice.local_b2c':
    'Kleine zaken voor particulieren (bijv. kappers of snackbars) noemen online vaak alleen telefoon en eigenaar. Gecontroleerde e-mailadressen van beslissers vinden we daar minder vaak dan bij bedrijven die aan bedrijven verkopen.',
  'prism.notice.outside_dach':
    'Onze data is het meest volledig in Duitsland, Oostenrijk en Zwitserland. Daarbuiten ontbreken colofon en handelsregister vaak, dus vinden we minder beslissers.',
  'prism.notice.continue':
    'Zoeken kan toch.',
  // Gratis-Leads vor dem Kauf + Hinweise für die übrige Liste (16.10.2026).
  'prism.free.tag':
    'Je {n} gratis leads, direct bruikbaar',
  'prism.free.tagRunning':
    'We zoeken nu je {n} gratis leads',
  'prism.free.tagOne':
    'Je gratis lead, direct bruikbaar',
  'prism.free.tagNone':
    'Gratis leads: deze keer geen met bewijs',
  'prism.free.tagSlow':
    'Je gratis leads duren wat langer',
  'prism.free.slowBody':
    'Het zoeken duurt deze keer langer dan normaal. We tonen je gratis leads hier zodra ze klaar zijn, ook als je later terugkomt.',
  'prism.free.running':
    'We zoeken nu de beslissers bij je sterkste bedrijven … ({found} van {n})',
  'prism.free.noneBody':
    'Bij je sterkste bedrijven vonden we geen beslisser met bewijs en e-mailadres (colofon, handelsregister of eigen website). Liever tonen we niets dan iets te verzinnen. Na het vrijgeven telt een credit alleen als we een contactpersoon vinden.',
  'prism.free.fewer':
    '{found} van {n} konden we onderbouwen. Bij de andere topbedrijven ontbrak bewijs, daar tonen we niets.',
  'prism.free.yours':
    'Kopieer of exporteer ze, ze zijn van jou.',
  'prism.free.export':
    'Exporteren als CSV',
  'prism.free.copy':
    'Kopiëren',
  'prism.free.copied':
    'Gekopieerd',
  'prism.free.cta':
    'Alle {n} vrijgeven',
  'prism.free.usedNote':
    'Gratis leads krijg je één keer per account en bedrijf. Deze beslisser zie je hier als voorbeeld.',
  'prism.free.csv.company':
    'Bedrijf',
  'prism.free.csv.domain':
    'Domein',
  'prism.free.csv.name':
    'Naam',
  'prism.free.csv.role':
    'Functie',
  'prism.free.csv.email':
    'E-mail',
  'prism.free.csv.phone':
    'Telefoon',
  'prism.free.csv.source':
    'Bewijs',
  'prism.pattern.first':
    'voornaam',
  'prism.pattern.last':
    'achternaam',
  'prism.pattern.f':
    'v',
  'prism.hint.freeAbove':
    'Gratis vrijgegeven, zie boven',
  'prism.hint.dmsOne':
    '1 beslisser: {roles}',
  'prism.hint.dmsMany':
    '{count} beslissers: {roles}',
  'prism.hint.dmsNoRole':
    '{count} beslissers onderbouwd',
  'prism.hint.pattern':
    'E-mailpatroon herkend:',
  'prism.hint.src.impressum':
    'Colofon',
  'prism.hint.src.handelsregister':
    'Handelsregister',
  'prism.hint.src.website':
    'Website',
  'prism.hint.unlock':
    'Contactpersoon',
  'prism.hint.unlockSub':
    'vrijgeven',
  'prism.freelead.tagTop': 'Je sterkste match',
  'prism.rail.label': 'Voortgang',
  'prism.rail.audience': 'Doelgroep',
  'prism.rail.website': 'Website',
  'prism.rail.refine': 'Verfijnen',
  'prism.rail.result': 'Resultaat',
  'prism.rail.done': 'voltooid',
  'prism.steps.earlier': '{n} eerdere stappen voltooid',
  'prism.lead.evidenceTag': 'Op hun website:',
  'prism.plan.termsStrong': 'Vanaf dag 4: € 290/maand.',
  'prism.plan.termsBody':
    'Na de 3 proefdagen gaat je toegang automatisch over op het Starter-abonnement (250 credits/maand). Zeg je eerder op in je account, dan betaal je alleen de € 49.',
  'prism.rateLimited.body':
    'Je hebt je zoekopdrachten voor vandaag gebruikt. Morgen gaan we verder — je gegevens blijven bewaard.',
  'prism.rateLimited.title': 'Daglimiet bereikt',
  'prism.results.queriesLabel': 'Zo hebben we gezocht:',
  'prism.results.queriesMore': '+{count} meer',
  'prism.score.possible': 'Mogelijke fit',
  'prism.target.errEmpty':
    'Vertel ons eerst wie je wilt bereiken — bijv. “tandartsen in Amsterdam”.',
  // LEA-595: Setup-Lieferungen freischalten (für jedes Offer).
  'ld.reveal.title': 'Contactpersonen gevonden, nog vergrendeld',
  'ld.reveal.hint':
    'Naam, e-mail en telefoon zie je na het ontgrendelen. Eén keer ontgrendelen opent alle contactpersonen van dit bedrijf.',
  'ld.reveal.cta': 'Contactpersonen ontgrendelen',
  'ld.reveal.confirm':
    'Dit kost 1 credit. Daarna zie je de contactpersonen van dit bedrijf volledig, en het acquisitieplan kost niets extra.',
  'ld.reveal.confirmCta': 'Ontgrendelen voor 1 credit',
  'ld.reveal.busy': 'Bezig met ontgrendelen…',
  'ld.reveal.done': 'Contactpersonen ontgrendeld, 1 credit gebruikt.',
  'ld.reveal.already': 'Al ontgrendeld, er is niets opnieuw afgeschreven.',
  'ld.reveal.notEligible':
    'Geen bereikbare contactpersoon: er valt niets te ontgrendelen en er wordt niets afgeschreven.',
  'ld.reveal.verificationPending':
    'De contactpersonen worden nog gecontroleerd. Probeer het over een minuut opnieuw; er is niets afgeschreven.',
  'ld.reveal.researchRunning':
    'Het zoeken naar contactpersonen loopt nog. Ontgrendelen kan zodra het klaar is.',
  'ld.reveal.failed':
    'Ontgrendelen is niet gelukt. Probeer het opnieuw; je betaalt nooit twee keer.',
  'ld.reveal.noCredits': 'Je hebt 1 credit nodig om te ontgrendelen.',
  'ld.reveal.buyContacts': 'Je saldo is leeg – hier kun je contacten bijkopen',
  'ld.reveal.planLocked': 'Ontgrendel eerst de contactpersonen',
  'ld.reveal.planNoContact': 'Geen bereikbare contactpersoon, dus geen acquisitieplan',
  'ld.contact.lockedEmailPhone': 'E-mail en telefoon na ontgrendelen',
  'ld.contact.lockedEmail': 'E-mail na ontgrendelen',
  'ld.contact.lockedPhone': 'Telefoon na ontgrendelen',
  // Wöchentliche Lieferung, Etappe B (16.10.2026) — Kundenseite + Assistant.
  'delivery.card.title': 'Wekelijkse levering',
  'delivery.card.badgeNew': 'Nieuw',
  'delivery.card.forAudience': 'voor {name}',
  'delivery.card.amount': 'Elke week ~{n} nieuwe bedrijven. Bij elk bedrijf zoeken we de beslisser, en je betaalt alleen als we die vinden.',
  'delivery.card.credits': 'Tot {credits} credits per levering: 1 per bedrijf, 1 per gevonden beslisser',
  'delivery.card.switchLabel': 'Wekelijkse levering aan- of uitzetten',
  'delivery.card.on': 'Aan',
  'delivery.card.off': 'Uit',
  'delivery.card.offHint': 'Zet haar aan en de eerste levering start meteen.',
  'delivery.card.next.label': 'Volgende levering',
  'delivery.card.next.afterRating': 'zodra je de huidige hebt beoordeeld, uiterlijk {date}',
  'delivery.card.next.soon': 'start zo',
  'delivery.card.running': 'Levering {no} loopt: {delivered} van {target} bedrijven',
  'delivery.card.runningConnect': 'Levering {no}: {delivered} bedrijven binnen, nu zoeken we de beslissers',
  'delivery.card.lowCredits': 'Je hebt {credits} credits, een volledige levering heeft er {need} nodig.',
  'delivery.card.topUp': 'Credits aanvullen',
  'delivery.card.loadFailed': 'De levering kon niet worden geladen.',
  'delivery.pause.out_of_credits.title': 'Gepauzeerd: geen credits meer',
  'delivery.pause.out_of_credits.body': 'Met nieuwe credits gaat de levering vanzelf verder.',
  'delivery.pause.niche_exhausted.title': 'Gepauzeerd: je doelgroep is uitgeput',
  'delivery.pause.niche_exhausted.body': 'Hier vinden we geen nieuwe bedrijven meer. Verbreed haar met één klik:',
  'delivery.pause.subscription_ended.title': 'Gepauzeerd: je abonnement is beëindigd',
  'delivery.pause.subscription_ended.body': 'Met een actief pakket gaat de levering verder.',
  'delivery.pause.subscription_ended.cta': 'Pakket kiezen',
  'delivery.pause.subscription_paused.title': 'Gepauzeerd: je abonnement staat stil',
  'delivery.pause.subscription_paused.body': 'Zodra je abonnement weer loopt, gaat de levering verder.',
  'delivery.pause.payment_issue.title': 'Gepauzeerd: betaling openstaand',
  'delivery.pause.payment_issue.body': 'Werk je betaalmethode bij, dan gaat de levering verder.',
  'delivery.pause.payment_issue.cta': 'Betaling bijwerken',
  'delivery.pause.other.title': 'Gepauzeerd',
  'delivery.pause.other.body': 'Stuur ons een kort bericht, dan kijken we ernaar.',
  'delivery.expand.hint': 'Dit verandert je doelgroep, ook voor je handmatige zoekopdrachten.',
  'delivery.pause.profile_missing.title': 'Gepauzeerd: deze doelgroep bestaat niet meer',
  'delivery.pause.profile_missing.body': 'Maak een nieuwe doelgroep aan en zet de levering daar aan.',
  'delivery.pause.profile_missing.cta': 'Doelgroep aanmaken',
  'delivery.pause.not_self_service.title': 'Gepauzeerd: ons team beheert je account',
  'delivery.pause.not_self_service.body': 'Je bedrijven krijg je via Autopilot.',
  'delivery.pause.account_closed.title': 'Gepauzeerd: verwijdering aangevraagd',
  'delivery.pause.account_closed.body': 'We leveren niet aan een account dat wordt verwijderd.',
  'delivery.pause.unsupported_model.title': 'Gepauzeerd: niet in je pakket',
  'delivery.pause.unsupported_model.body': 'De levering hoort bij Basic, Starter en Growth.',
  'delivery.short.title': 'Laatste levering: {delivered} van {target} bedrijven',
  'delivery.short.body': 'Je doelgroep levert nu niet meer op. Verbreed haar met één klik:',
  'delivery.expand.loading': 'Voorstellen worden gecontroleerd …',
  'delivery.expand.none': 'Omschrijf je doelgroep breder om verder te gaan.',
  'delivery.expand.edit': 'Doelgroep bewerken',
  'delivery.expand.applied': 'Doelgroep verbreed. De volgende levering start zo.',
  'delivery.expand.opt.area': 'Uitbreiden naar heel {area} in plaats van {from} en levering starten',
  'delivery.expand.opt.dach': 'Uitbreiden naar Duitsland, Oostenrijk en Zwitserland en levering starten',
  'delivery.expand.opt.industry': '{industry} aan je doelgroep toevoegen en levering starten',
  'delivery.expand.opt.size': 'Alle bedrijfsgroottes toestaan in plaats van {from} medewerkers en levering starten',
  'delivery.toast.on': 'Levering staat aan. De eerste start zo.',
  'delivery.toast.off': 'Levering staat uit.',
  'delivery.toast.failed': 'Dat is niet gelukt. Probeer het opnieuw.',
  'delivery.toast.planRequired': 'Voor de levering heb je een actief pakket nodig.',
  'delivery.history.title': 'Eerdere leveringen',
  'delivery.history.cycle': 'Levering {no}',
  'delivery.history.companies': '{n} bedrijven',
  'delivery.history.withContact': '{n} met beslisser',
  'delivery.history.acceptRate': '{pct} % past',
  'delivery.history.noRating': 'nog niet beoordeeld',
  'delivery.history.review': 'Nu beoordelen ({n} open)',
  'delivery.history.show': 'Bekijken',
  'delivery.history.empty': 'Je eerste levering verschijnt hier.',
  'delivery.history.more': 'Alles tonen',
  'delivery.history.less': 'Minder tonen',
  'delivery.filter.prefix': 'Gefilterd op:',
  'delivery.notif.ready.title': 'Je levering is er: {n} bedrijven',
  'delivery.notif.ready.body': '{connected} daarvan met beslisser, voor {name}. Beoordeel ze, dan komt de volgende.',
  'delivery.notif.paused.out_of_credits.title': 'Levering gepauzeerd: geen credits',
  'delivery.notif.paused.out_of_credits.body': 'Met nieuwe credits gaat ze vanzelf verder.',
  'delivery.notif.paused.niche_exhausted.title': 'Levering gepauzeerd: doelgroep uitgeput',
  'delivery.notif.paused.niche_exhausted.body': 'Verbreed {name} met één klik om verder te gaan.',
  'agent.delivery.tool.status': 'Levering bekijken',
  'agent.delivery.tool.set': 'Wekelijkse levering',
  'agent.delivery.cost.enable': 'Tot {credits} credits per levering: elke week ~{n} nieuwe bedrijven, en bij elk bedrijf zoeken we de beslisser. Die credit betaal je alleen als we die vinden. Uitzetten kan altijd.',
};

export default nl;
